import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../supabaseClient'
import { security, USER_ROLES } from '../config/security'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import ListaMaterial from './ListaMaterial'
import Empresas from './Empresas'
import PagamentoColaborador from './PagamentoColaborador'
import Adiantamento from './Adiantamento'
import ClientePDFs from './ClientePDFs'
import KitSolar from './KitSolar'
import MonteSeuKit from './MonteSeuKit'
import CalculadoraSolar from './CalculadoraSolar'
import ValorKitManager from './ValorKitManager'
import KitsPersonalizados from './KitsPersonalizados'
import KitFornecedores from './KitFornecedores'
import ConsultaPropostas from './ConsultaPropostas'
import PropostasCadastro from './PropostasCadastro'
import ClientesII from './ClientesII'
import CadastrarClientes from './CadastrarClientes'
import TipoServicoManager from './TipoServicoManager'
import Leads from './Leads'
import GestaoLeads from './GestaoLeads'
import CadastrarLeads from './CadastrarLeads'
import LeadsSDR from './LeadsSDR'
import LeadsCapacitacao from './LeadsCapacitacao'
import OrdemServico from './OrdemServico'
import Servicos from './Servicos'
import Vistorias from './Vistorias'
import GestaoInstalacao from './GestaoInstalacao'
import EngenhariaHomologacao from './EngenhariaHomologacao'
import FluxoCliente from './FluxoCliente'
import PainelProcessosClientes from './PainelProcessosClientes'
import Usuarios from './Usuarios'
import AppSidebar from './AppSidebar'
import EngenhariaInversores from './EngenhariaInversores'
import PermissoesMenus from './PermissoesMenus'
import DashboardV2 from './DashboardV2'
import Monitoramento from './Monitoramento'
import Calendario from './Calendario'
import DashboardEventosCalendario from './DashboardEventosCalendario'
import MonitoramentoAlertas from './MonitoramentoAlertas'
import Vendas from './Vendas'
import Financeiro from './Financeiro'
import CadastroTiposMovimentacao from './CadastroTiposMovimentacao'
import CadastroInversoresModulos from './CadastroInversoresModulos'
import LancarMovimentacoes from './LancarMovimentacoes'
import Orcamentos from './Orcamentos'
import SimulacaoFotus from './SimulacaoFotus'
import WhatsApp from './WhatsApp'
import WhatsAppFloatingChat from './WhatsAppFloatingChat'
import { languageCodeTemplate, listarTemplatesDisponiveis } from '../services/whatsappApi'
import './Welcome.css'
import './MedicaoControls.css'
import './Vistorias.css'
import '../styles/dashboard-header.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

/** Administrativo desta empresa pode usar o filtro por (múltiplas) empresas na tela de Instalações Realizadas. */
const EMPRESA_ID_ADMINISTRATIVO_PODE_FILTRAR = 'f0c6de5a-eaf9-4530-a6a7-28140091897d'

const Welcome = () => {
  const navigate = useNavigate()
  
  // Estados básicos
  const [currentView, setCurrentView] = useState('dashboard')
  const [viewHistory, setViewHistory] = useState(['dashboard']) // Histórico de navegação interno

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const gcal = params.get('google_calendar')
    if (!gcal) return
    sessionStorage.setItem('google_calendar_oauth', gcal === 'ok' ? 'ok' : 'error')
    setCurrentView('calendario')
    params.delete('google_calendar')
    params.delete('motivo')
    const qs = params.toString()
    window.history.replaceState({}, '', `${window.location.pathname}${qs ? `?${qs}` : ''}`)
  }, [])
  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [dadosIniciaisCliente, setDadosIniciaisCliente] = useState(null)
  const [clienteParaOrdemServico, setClienteParaOrdemServico] = useState(null)
  const [permissoesMenusCache, setPermissoesMenusCache] = useState({})
  const [hasPermissoesCustomizadas, setHasPermissoesCustomizadas] = useState(false)
  
  // Estado para o relógio dinâmico
  const [currentTime, setCurrentTime] = useState(new Date())
  
  // Variáveis derivadas do user
  const userId = user?.id
  const userName = user?.nome
  
  // Estados para alterar senha
  const [showChangePasswordForm, setShowChangePasswordForm] = useState(false)
  const [changePasswordData, setChangePasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  })
  const [passwordError, setPasswordError] = useState('')
  const [passwordSuccess, setPasswordSuccess] = useState('')

  // Estados para modal de senha temporária
  const [showPasswordModal, setShowPasswordModal] = useState(false)
  const [tempPasswordData, setTempPasswordData] = useState({
    nome: '',
    email: '',
    senha: ''
  })
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false)
  
  // Estados para modal de erro de autenticação
  const [showAuthErrorModal, setShowAuthErrorModal] = useState(false)
  const [authErrorMessage, setAuthErrorMessage] = useState('')
  
  // Estados para clientes
  const [clientes, setClientes] = useState([])
  const [showClienteForm, setShowClienteForm] = useState(false)
  const [editingCliente, setEditingCliente] = useState(null)
  const [showClienteModal, setShowClienteModal] = useState(false)
  const [clienteModalData, setClienteModalData] = useState(null)
  const [showClientePDFs, setShowClientePDFs] = useState(false)
  const [clientePDFsData, setClientePDFsData] = useState(null)
  const [showClienteFotos, setShowClienteFotos] = useState(false)
  const [clienteFotosData, setClienteFotosData] = useState(null)
  const [clienteFotos, setClienteFotos] = useState([])
  const [formulariosFotosCache, setFormulariosFotosCache] = useState(null) // para edição admin: [{ id, fotos }, ...]
  const [loadingFotos, setLoadingFotos] = useState(false)
  const [downloadingAll, setDownloadingAll] = useState(false)
  const [downloadingIndividual, setDownloadingIndividual] = useState({})
  const [removingFotoId, setRemovingFotoId] = useState(null)
  const [addingFotosCliente, setAddingFotosCliente] = useState(false)
  const [tituloFotoAdicional, setTituloFotoAdicional] = useState('')
  const [observacoesFormularioBaixa, setObservacoesFormularioBaixa] = useState([])
  const [observacoesModalFormularioBaixa, setObservacoesModalFormularioBaixa] = useState([])
  const [clienteFormData, setClienteFormData] = useState({
    nome_cliente: '',
    endereco: '',
    telefone: '',
    data_instalacao: '',
    tipo_servico_id: '',
    tipo_padrao_id: '',
    id_profiles: [],
    equipe_id: '',
    data_cadastro: new Date().toISOString().split('T')[0],
    quantidade_modulos: 0,
    deslocamento: '',
    deslocamento_buscar_material: false,
    configuracao_inversor: false,
    obra_civil: false,
    obra_cancelada: false,
    nota_material: false,
    observacoes: '',
    id_status: 1, // Status padrão: Pendente (ID 1)
    empresa_id: null // Será definido automaticamente baseado no usuário logado
  })
  
  // Estados para presença
  const [presencas, setPresencas] = useState([])
  const [propostas, setPropostas] = useState([])
  
  // Estados para vistorias (para vistoriadores)
  const [vistorias, setVistorias] = useState([])
  const [isLoadingVistorias, setIsLoadingVistorias] = useState(false)

  // Estados para eventos do calendário (card no dashboard)
  const [eventosCalendario, setEventosCalendario] = useState([])
  const [filtroEventosCalendario, setFiltroEventosCalendario] = useState('dia')
  const [loadingEventosCalendario, setLoadingEventosCalendario] = useState(false)
  
  // Estados para modal de baixa de vistoria (no dashboard)
  const [showBaixaModalDashboard, setShowBaixaModalDashboard] = useState(false)
  const [vistoriaParaBaixaDashboard, setVistoriaParaBaixaDashboard] = useState(null)
  const [tiposPadraoVistoria, setTiposPadraoVistoria] = useState([])
  const [isLoadingBaixaDashboard, setIsLoadingBaixaDashboard] = useState(false)
  
  // Estado para formulário de baixa (no dashboard)
  const [formBaixaDashboard, setFormBaixaDashboard] = useState({
    tipo_padrao_id: '',
    ligacao_padrao: '',
    local_inversor: '',
    posicao_poste_concessionaria: '',
    conexao_inversor: '',
    local_aterramento_sistema: '',
    metragem_ca_inversor: '',
    metragem_cc: '',
    metragem_ca_padrao_fases: '',
    percurso_aterramento: '',
    qtd_conduletes_inversor: '',
    qtd_eletroduto_inversor: '',
    qtd_eletroduto_padrao: '',
    qtd_modulos_telhado: '',
    caminho_img_padrao: '',
    caminho_img_inversor: '',
    caminho_img_fachada: '',
    caminho_img_mapa: '',
    caminho_img_telhado: '',
    caminho_img_quadro: '',
    caminho_img_estrutura: '',
    caminho_img_croqui: '',
    observacoes: '',
    data_vistoria: new Date().toISOString().split('T')[0],
    status: 'Novo'
  })
  
  // Estados para upload de imagens (no dashboard)
  const [uploadingImagesDashboard, setUploadingImagesDashboard] = useState({})
  const [imageFilesDashboard, setImageFilesDashboard] = useState({})
  const [multipleImageFilesDashboard, setMultipleImageFilesDashboard] = useState({
    telhado: [],
    estrutura: []
  })
  
  const [showPresencaForm, setShowPresencaForm] = useState(false)
  const [editingPresenca, setEditingPresenca] = useState(null)
  const [presencaFormData, setPresencaFormData] = useState({
    data_presenca: '',
    data_cadastro_preenchido: '',
    cliente_id: '',
    equipe_id: '',
    veiculo_id: '',
    km_inicial: '',
    observacoes: '',
    colaboradores: [] // Array de IDs dos colaboradores selecionados
  })
  
  // Estados para tipos de serviço
  const [tiposServico, setTiposServico] = useState([])
  
     // Estados para tipos de padrão
   const [tiposPadrao, setTiposPadrao] = useState([])
   
   // Estados para status de clientes
   const [statusClientes, setStatusClientes] = useState([])
   
  // Estados para medição
  const [medicaoData, setMedicaoData] = useState([])
  const [medicaoLoading, setMedicaoLoading] = useState(false)
  const [medicaoPeriodo, setMedicaoPeriodo] = useState({
    inicio: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], // 30 dias atrás
    fim: new Date().toISOString().split('T')[0] // Hoje
  })
  const [tipoMedicao, setTipoMedicao] = useState('modulos') // 'kwp' ou 'modulos'
   
   // Estados para formulários de tipos
   const [showTipoServicoForm, setShowTipoServicoForm] = useState(false)
   const [editingTipoServico, setEditingTipoServico] = useState(null)
   const [tipoServicoFormData, setTipoServicoFormData] = useState({
     nome: '',
     descricao: '',
     valor_servico: '',
     ativo: true
   })
   
   // Estado para modal de validação de nome duplicado
   const [showDuplicateModal, setShowDuplicateModal] = useState(false)
   const [duplicateTipoData, setDuplicateTipoData] = useState(null)
   
   // Estado para menu Empresas
   const [showEmpresas, setShowEmpresas] = useState(false)
   
  // Estado para empresa do usuário logado
  const [userEmpresa, setUserEmpresa] = useState(null)
  
  // Estados para filtro de empresa na tela de Instalações Realizadas
  const [empresasDisponiveis, setEmpresasDisponiveis] = useState([])
  // Filtro por múltiplas empresas (dropdown checklist) - administrador e administrativo privilegiado
  const [empresasFiltroMultiClientes, setEmpresasFiltroMultiClientes] = useState([])
  const [empresaFiltroDropdownAberto, setEmpresaFiltroDropdownAberto] = useState(false)
  const empresaFiltroDropdownRef = useRef(null)
  // Administrativo da empresa privilegiada pode filtrar Instalações Realizadas por múltiplas empresas
  const podeFiltrarMultiEmpresaClientes = useMemo(() => (
    userRole === USER_ROLES.ADMINISTRATIVO &&
    String(userEmpresa?.id || '') === EMPRESA_ID_ADMINISTRATIVO_PODE_FILTRAR
  ), [userRole, userEmpresa])
  // Quem pode usar o filtro por (múltiplas) empresas: administrador OU administrativo privilegiado
  const podeFiltrarEmpresaClientes = userRole === USER_ROLES.ADMINISTRADOR || podeFiltrarMultiEmpresaClientes
  
  // Estado para filtro de status (disponível para todos os usuários)
  const [statusFiltroClientes, setStatusFiltroClientes] = useState('')
   
   const [showTipoPadraoForm, setShowTipoPadraoForm] = useState(false)
   const [editingTipoPadrao, setEditingTipoPadrao] = useState(null)
   const [tipoPadraoFormData, setTipoPadraoFormData] = useState({
     nome: '',
     ativo: true
   })
  
  // Estados para usuários instaladores
  const [usuariosInstaladores, setUsuariosInstaladores] = useState([])
  
  // Estados para colaboradores
  const [colaboradores, setColaboradores] = useState([])
  const [showColaboradorForm, setShowColaboradorForm] = useState(false)
  const [editingColaborador, setEditingColaborador] = useState(null)
  const [colaboradorFormData, setColaboradorFormData] = useState({
    nome: '',
    cargo: '',
    email: '',
    chave_pix: '',
    ativo: true,
    empresa_id: '',
    tipo_pagamento_id: '',
    valor_pagamento: ''
  })
  
  // Estados para equipes
  const [equipes, setEquipes] = useState([])
  const [showEquipeForm, setShowEquipeForm] = useState(false)
  const [editingEquipe, setEditingEquipe] = useState(null)
  const [formulariosBaixa, setFormulariosBaixa] = useState([])
  const [equipeFormData, setEquipeFormData] = useState({
    nome: '',
    descricao: '',
    ativo: true,
    empresa_id: '',
    lider_equipe: '',
    telefone: '',
    exibir_presenca: true,
    exibir_baixa: true,
    id_formularios_baixa: 1,
    multiequipes: false
  })
  
  // Estados para carros/veículos
  const [carros, setCarros] = useState([])
  
  // Estados para usuários do sistema
  const [usuarios, setUsuarios] = useState([])
  const [showUsuarioForm, setShowUsuarioForm] = useState(false)
  const [editingUsuario, setEditingUsuario] = useState(null)
  const [usuarioFormData, setUsuarioFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    role: 'instalador',
    status: 'ativo',
    empresa_id: '',
    multiempresas: false,
    chat_zap: 0,
    whatsapp_gestor: 0,
    whatsapp_proposta: 0,
    whatsapp_template_id: '',
    whatsapp_template_nome: '',
    whatsapp_template_language: ''
  })
  
  // Estados para empresas (para o dropdown de usuários)
  const [empresas, setEmpresas] = useState([])
  const [loadingEmpresas, setLoadingEmpresas] = useState(false)
  const [empresasLoaded, setEmpresasLoaded] = useState(false)
  const [templatesWhatsAppUsuario, setTemplatesWhatsAppUsuario] = useState([])
  const [carregandoTemplatesWhatsApp, setCarregandoTemplatesWhatsApp] = useState(false)
  
  // Estados para cargos
  const [cargos, setCargos] = useState([])
  const [showCargoForm, setShowCargoForm] = useState(false)
  const [editingCargo, setEditingCargo] = useState(null)
  const [cargoFormData, setCargoFormData] = useState({
    cargo: '',
    ativo: true
  })
  
  // Estados para tipos de pagamento
  const [tiposPagamento, setTiposPagamento] = useState([])
  const [loadingTiposPagamento, setLoadingTiposPagamento] = useState(false)
  const [tiposPagamentoLoaded, setTiposPagamentoLoaded] = useState(false)
  
  // Estados para pagamento de colaboradores
  const [showPagamentoColaboradores, setShowPagamentoColaboradores] = useState(false)
  const [pagamentoData, setPagamentoData] = useState([])
  const [loadingPagamento, setLoadingPagamento] = useState(false)
  const [filtrosPagamento, setFiltrosPagamento] = useState({
    dataInicio: '',
    dataFim: ''
  })
  
  // Estados para veículos
  const [veiculos, setVeiculos] = useState([])
  const [showVeiculoForm, setShowVeiculoForm] = useState(false)
  const [editingVeiculo, setEditingVeiculo] = useState(null)
  const [veiculoFormData, setVeiculoFormData] = useState({
    veiculo: '',
    placa: '',
    ativo: true,
    empresa_id: null // Será definido automaticamente baseado no usuário logado
  })
  
  // Estados para filtros
  const [filtrosCliente, setFiltrosCliente] = useState({
    nome_cliente: '',
    dataInicio: '',
    dataFim: '',
    tipoServicoId: '',
    idProfiles: []
  })
  
  // Estados para notificações
  const [notifications, setNotifications] = useState([])
  
  // Estados para modais
  const [showPresencaWarningModal, setShowPresencaWarningModal] = useState(false)
  const [clienteParaExcluir, setClienteParaExcluir] = useState(null)
  const [presencasCliente, setPresencasCliente] = useState([])
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false)
  
  // Estado para lista de material
  const [showListaMaterial, setShowListaMaterial] = useState(false)
  
  // Estados para presença modal não fechável
  const [presencaModalNaoFechavel, setPresencaModalNaoFechavel] = useState(false)
  
  // Estados para importação de planilha
  const [showImportPresencaModal, setShowImportPresencaModal] = useState(false)
  const [importFile, setImportFile] = useState(null)
  const [importData, setImportData] = useState([])
  const [importLoading, setImportLoading] = useState(false)
  const [showImportProgressModal, setShowImportProgressModal] = useState(false)
  const [importProgress, setImportProgress] = useState({ current: 0, total: 0, status: '' })
  
  // Estados para resumo de colaboradores não encontrados
  const [showColaboradoresNaoEncontradosModal, setShowColaboradoresNaoEncontradosModal] = useState(false)
  const [colaboradoresNaoEncontrados, setColaboradoresNaoEncontrados] = useState([])
  const [colaboradoresEncontrados, setColaboradoresEncontrados] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [searchLoading, setSearchLoading] = useState(false)
  
  // Estados para resumo de confirmação
  const [showResumoConfirmacaoModal, setShowResumoConfirmacaoModal] = useState(false)
  const [resumoImportacao, setResumoImportacao] = useState({})
  
  // Estado para ValorKitManager
  const [showValorKitManager, setShowValorKitManager] = useState(false)
  const [showKitsPersonalizados, setShowKitsPersonalizados] = useState(false)
  const [showConsultaPropostas, setShowConsultaPropostas] = useState(false)
  
  // Estados para cliente modal não fechável (quando finalizando obra)
  const [clienteModalNaoFechavel, setClienteModalNaoFechavel] = useState(false)
  
  // Estados para modal de notificação
  const [showNotificationModal, setShowNotificationModal] = useState(false)
  const [notificationModalData, setNotificationModalData] = useState({
    message: '',
    type: 'info',
    title: ''
  })
  
  // Estado para modal de loading do relatório
  const [showRelatorioLoadingModal, setShowRelatorioLoadingModal] = useState(false)
  
  // Função para mostrar notificações
  const showNotification = (message, type = 'info') => {
    // Definir título baseado no tipo
    let title = ''
    switch (type) {
      case 'success':
        title = 'Sucesso!'
        break
      case 'error':
        title = 'Erro!'
        break
      case 'warning':
        title = 'Atenção!'
        break
      default:
        title = 'Informação'
    }
    
    // Configurar dados do modal
    setNotificationModalData({
      message,
      type,
      title
    })
    
    // Mostrar modal
    setShowNotificationModal(true)
  }
  
  // Função para fechar modal de notificação
  const closeNotificationModal = () => {
    setShowNotificationModal(false)
    setNotificationModalData({
      message: '',
      type: 'info',
      title: ''
    })
  }
  
  // Funções para colaboradores
  const handleEditColaborador = (colaborador) => {
    setEditingColaborador(colaborador)
    setColaboradorFormData({
      nome: colaborador.nome || '',
      cargo: colaborador.cargo || '',
      email: colaborador.email || '',
      chave_pix: colaborador.chave_pix || '',
      ativo: colaborador.ativo !== undefined ? colaborador.ativo : true,
      empresa_id: colaborador.empresa_id || userEmpresa?.id || '',
      tipo_pagamento_id: colaborador.tipo_pagamento_id || '',
      valor_pagamento: colaborador.valor_pagamento || ''
    })
    setShowColaboradorForm(true)
  }

  const handleDeleteColaborador = async (colaborador) => {
    if (!window.confirm(`Tem certeza que deseja excluir o colaborador "${colaborador.nome}"?`)) {
      return
    }
    
    try {
      const { error } = await supabase
        .from('colaboradores')
        .delete()
        .eq('id', colaborador.id)
      
      if (error) throw error
      
      showNotification('Colaborador excluído com sucesso!', 'success')
      loadColaboradores()
    } catch (error) {
      console.error('Erro ao excluir colaborador:', error)
      showNotification('Erro ao excluir colaborador: ' + error.message, 'error')
    }
  }

  // Salvar colaborador
  const handleColaboradorFormSubmit = async (e) => {
    e.preventDefault()
    
    try {
      // Garantir que a empresa_id esteja definida
      if (!colaboradorFormData.empresa_id) {
        if (userRole === 'administrador') {
          // Para administradores, usar a empresa do usuário logado se não selecionou uma
          if (userEmpresa?.id) {
            colaboradorFormData.empresa_id = userEmpresa.id
          } else {
            showNotification('Selecione uma empresa para o colaborador.', 'error')
            return
          }
        } else {
          // Usuário não-administrador: usar empresa do usuário logado
          colaboradorFormData.empresa_id = userEmpresa?.id
        }
      }

      if (editingColaborador) {
        // Atualizar colaborador existente
        const { error } = await supabase
          .from('colaboradores')
          .update(colaboradorFormData)
          .eq('id', editingColaborador.id)
        
        if (error) throw error
        
        showNotification('Colaborador atualizado com sucesso!', 'success')
      } else {
        // Criar novo colaborador
        const { error } = await supabase
          .from('colaboradores')
          .insert([colaboradorFormData])
        
        if (error) throw error
        
        showNotification('Colaborador cadastrado com sucesso!', 'success')
      }
      
      closeColaboradorForm()
      loadColaboradores()
    } catch (error) {
      console.error('Erro ao salvar colaborador:', error)
      showNotification('Erro ao salvar colaborador: ' + error.message, 'error')
    }
  }

  // Fechar formulário de colaborador
  const closeColaboradorForm = () => {
    setShowColaboradorForm(false)
    setEditingColaborador(null)
    setColaboradorFormData({
      nome: '',
      cargo: '',
      email: '',
      chave_pix: '',
      ativo: true,
      empresa_id: userEmpresa?.id || '',
      tipo_pagamento_id: '',
      valor_pagamento: ''
    })
  }

  // Funções para equipes
  const loadFormulariosBaixa = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('formularios_baixa')
        .select('id, tipo')
        .order('id')

      if (error) throw error
      
      setFormulariosBaixa(data || [])
    } catch (error) {
      console.error('Erro ao carregar formulários de baixa:', error)
      setFormulariosBaixa([])
    }
  }, [])

  const handleEditEquipe = (equipe) => {
    setEditingEquipe(equipe)
    setEquipeFormData({
      nome: equipe.nome || '',
      descricao: equipe.descricao || '',
      ativo: equipe.ativo !== undefined ? equipe.ativo : true,
      empresa_id: equipe.empresa_id || '',
      lider_equipe: equipe.lider_equipe || '',
      telefone: equipe.telefone || '',
      exibir_presenca: equipe.exibir_presenca !== undefined ? equipe.exibir_presenca : true,
      exibir_baixa: equipe.exibir_baixa !== undefined ? equipe.exibir_baixa : true,
      id_formularios_baixa: equipe.id_formularios_baixa || 1,
      multiequipes: equipe.multiequipes !== undefined ? equipe.multiequipes : false
    })
    loadFormulariosBaixa() // ✅ Carregar formulários de baixa para edição
    setShowEquipeForm(true)
  }

  const handleDeleteEquipe = async (equipe) => {
    if (!window.confirm(`Tem certeza que deseja excluir a equipe "${equipe.nome}"?`)) {
      return
    }
    
    try {
      const { error } = await supabase
        .from('equipes')
        .delete()
        .eq('id', equipe.id)
      
      if (error) throw error
      
      showNotification('Equipe excluída com sucesso!', 'success')
      loadEquipes()
    } catch (error) {
      console.error('Erro ao excluir equipe:', error)
      showNotification('Erro ao excluir equipe: ' + error.message, 'error')
    }
  }

  // Salvar equipe
  const handleEquipeFormSubmit = async (e) => {
    e.preventDefault()
    
    try {
      // Garantir que a empresa_id esteja definida
      if (!equipeFormData.empresa_id) {
        if (userRole === 'administrador') {
          showNotification('Selecione uma empresa para a equipe.', 'error')
          return
        } else {
          // Usuário não-administrador: usar empresa do usuário logado
          equipeFormData.empresa_id = userEmpresa?.id
        }
      }

      // Garantir que o líder esteja selecionado
      if (!equipeFormData.lider_equipe) {
        showNotification('Selecione um líder para a equipe.', 'error')
        return
      }

      if (editingEquipe) {
        // Atualizar equipe existente
        const { error } = await supabase
          .from('equipes')
          .update(equipeFormData)
          .eq('id', editingEquipe.id)
        
        if (error) throw error
        
        showNotification('Equipe atualizada com sucesso!', 'success')
      } else {
        // Criar nova equipe
        const { error } = await supabase
          .from('equipes')
          .insert([equipeFormData])
        
        if (error) throw error
        
        showNotification('Equipe cadastrada com sucesso!', 'success')
      }
      
      closeEquipeForm()
      loadEquipes()
    } catch (error) {
      console.error('Erro ao salvar equipe:', error)
      showNotification('Erro ao salvar equipe: ' + error.message, 'error')
    }
  }

  // Fechar formulário de equipe
  const closeEquipeForm = () => {
    setShowEquipeForm(false)
    setEditingEquipe(null)
    setEquipeFormData({
      nome: '',
      descricao: '',
      ativo: true,
      empresa_id: '',
      lider_equipe: '',
      telefone: '',
      exibir_presenca: true,
      exibir_baixa: true,
      id_formularios_baixa: 1,
      multiequipes: false
    })
  }

  // Funções para usuários
  const handleEditUsuario = (usuario) => {
    loadEmpresas()
    setEditingUsuario(usuario)
    setUsuarioFormData({
      nome: usuario.nome || '',
      email: usuario.email || '',
      telefone: usuario.telefone || '',
      role: usuario.role || 'instalador',
      status: usuario.status || 'ativo',
      empresa_id: usuario.empresa_id || '',
      multiempresas: usuario.multiempresas !== undefined ? usuario.multiempresas : false,
      chat_zap: Number(usuario.chat_zap) === 1 ? 1 : 0,
      whatsapp_gestor: Number(usuario.whatsapp_gestor) === 1 ? 1 : 0,
      whatsapp_proposta: Number(usuario.whatsapp_proposta) === 1 ? 1 : 0,
      whatsapp_template_id: usuario.whatsapp_template_id || '',
      whatsapp_template_nome: usuario.whatsapp_template_nome || '',
      whatsapp_template_language: usuario.whatsapp_template_language || ''
    })
    setShowUsuarioForm(true)
  }

  const handleToggleChatZap = async (usuario, checked) => {
    const valor = checked ? 1 : 0
    try {
      const { error } = await supabase
        .from('usuarios_sistema')
        .update({ chat_zap: valor })
        .eq('id', usuario.id)
      if (error) throw error
      setUsuarios((prev) =>
        prev.map((u) => (u.id === usuario.id ? { ...u, chat_zap: valor } : u))
      )
      if (String(usuario.id) === String(userId)) {
        setUser((prev) => (prev ? { ...prev, chat_zap: valor } : prev))
      }
    } catch (error) {
      console.error('Erro ao atualizar chat_zap:', error)
      showNotification('Erro ao atualizar Chat Zap: ' + error.message, 'error')
    }
  }

  const handleToggleWhatsappGestor = async (usuario, checked) => {
    const valor = checked ? 1 : 0
    try {
      const { error } = await supabase
        .from('usuarios_sistema')
        .update({ whatsapp_gestor: valor })
        .eq('id', usuario.id)
      if (error) throw error
      setUsuarios((prev) =>
        prev.map((u) => (u.id === usuario.id ? { ...u, whatsapp_gestor: valor } : u))
      )
      if (String(usuario.id) === String(userId)) {
        setUser((prev) => (prev ? { ...prev, whatsapp_gestor: valor } : prev))
      }
    } catch (error) {
      console.error('Erro ao atualizar whatsapp_gestor:', error)
      showNotification('Erro ao atualizar Painel gestor: ' + error.message, 'error')
    }
  }

  const handleToggleWhatsappProposta = async (usuario, checked) => {
    const valor = checked ? 1 : 0
    try {
      const { error } = await supabase
        .from('usuarios_sistema')
        .update({ whatsapp_proposta: valor })
        .eq('id', usuario.id)
      if (error) throw error
      setUsuarios((prev) =>
        prev.map((u) => (u.id === usuario.id ? { ...u, whatsapp_proposta: valor } : u))
      )
      if (String(usuario.id) === String(userId)) {
        setUser((prev) => (prev ? { ...prev, whatsapp_proposta: valor } : prev))
      }
    } catch (error) {
      console.error('Erro ao atualizar whatsapp_proposta:', error)
      showNotification('Erro ao atualizar aba Proposta WhatsApp: ' + error.message, 'error')
    }
  }

  const handleDeleteUsuario = async (usuario) => {
    if (!window.confirm(`Tem certeza que deseja excluir o usuário "${usuario.nome}"?`)) {
      return
    }
    
    try {
      const { error } = await supabase
        .from('usuarios_sistema')
        .delete()
        .eq('id', usuario.id)
      
      if (error) throw error
      
      showNotification('Usuário excluído com sucesso!', 'success')
      loadUsuarios()
    } catch (error) {
      console.error('Erro ao excluir usuário:', error)
      showNotification('Erro ao excluir usuário: ' + error.message, 'error')
    }
  }

  // Salvar usuário
  const handleUsuarioFormSubmit = async (e) => {
    e.preventDefault()
    
    try {
      if (editingUsuario) {
        // Atualizar usuário existente
        const { error } = await supabase
          .from('usuarios_sistema')
          .update({
            nome: usuarioFormData.nome,
            email: usuarioFormData.email,
            telefone: usuarioFormData.telefone.trim() || null,
            role: usuarioFormData.role,
            status: usuarioFormData.status,
            empresa_id: usuarioFormData.empresa_id,
            multiempresas: usuarioFormData.multiempresas,
            chat_zap: usuarioFormData.chat_zap ? 1 : 0,
            whatsapp_gestor: usuarioFormData.whatsapp_gestor ? 1 : 0,
            whatsapp_proposta: usuarioFormData.whatsapp_proposta ? 1 : 0,
            whatsapp_template_id: usuarioFormData.whatsapp_template_id || null,
            whatsapp_template_nome: usuarioFormData.whatsapp_template_nome || null,
            whatsapp_template_language: usuarioFormData.whatsapp_template_language || null
          })
          .eq('id', editingUsuario.id)
        
        if (error) throw error

        if (String(editingUsuario.id) === String(userId)) {
          setUser((prev) => (prev ? {
            ...prev,
            chat_zap: usuarioFormData.chat_zap ? 1 : 0,
            whatsapp_gestor: usuarioFormData.whatsapp_gestor ? 1 : 0,
            whatsapp_proposta: usuarioFormData.whatsapp_proposta ? 1 : 0
          } : prev))
        }
        
        showNotification('Usuário atualizado com sucesso!', 'success')
      } else {
        // Criar novo usuário usando função personalizada
        const { data, error } = await supabase
          .rpc('criar_usuario_com_senha_temp', {
            p_nome: usuarioFormData.nome,
            p_email: usuarioFormData.email,
            p_role: usuarioFormData.role,
            p_empresa_id: usuarioFormData.empresa_id
          })
        
        if (error) throw error
        
        if (data && data.length > 0) {
          const resultado = data[0]
          if (usuarioFormData.telefone.trim() || usuarioFormData.multiempresas || usuarioFormData.chat_zap || usuarioFormData.whatsapp_gestor || usuarioFormData.whatsapp_proposta || usuarioFormData.whatsapp_template_id) {
            const { error: updateFlagsError } = await supabase
              .from('usuarios_sistema')
              .update({
                telefone: usuarioFormData.telefone.trim() || null,
                multiempresas: !!usuarioFormData.multiempresas,
                chat_zap: usuarioFormData.chat_zap ? 1 : 0,
                whatsapp_gestor: usuarioFormData.whatsapp_gestor ? 1 : 0,
                whatsapp_proposta: usuarioFormData.whatsapp_proposta ? 1 : 0,
                whatsapp_template_id: usuarioFormData.whatsapp_template_id || null,
                whatsapp_template_nome: usuarioFormData.whatsapp_template_nome || null,
                whatsapp_template_language: usuarioFormData.whatsapp_template_language || null
              })
              .eq('email', usuarioFormData.email)
            if (updateFlagsError) throw updateFlagsError
          }
          if (resultado.senha_temporaria) {
            // Exibir modal com senha temporária
            setTempPasswordData({
              nome: usuarioFormData.nome,
              email: usuarioFormData.email,
              senha: resultado.senha_temporaria
            })
            setShowPasswordModal(true)
          } else {
            showNotification('Usuário cadastrado com sucesso!', 'success')
          }
        } else {
          showNotification('Usuário cadastrado com sucesso!', 'success')
        }
      }
      
      closeUsuarioForm()
      loadUsuarios()
    } catch (error) {
      console.error('Erro ao salvar usuário:', error)
      showNotification('Erro ao salvar usuário: ' + error.message, 'error')
    }
  }

  // Fechar formulário de usuário
  const closeUsuarioForm = () => {
    setShowUsuarioForm(false)
    setEditingUsuario(null)
    setUsuarioFormData({
      nome: '',
      email: '',
      telefone: '',
      role: 'instalador',
      status: 'ativo',
      empresa_id: '',
      multiempresas: false,
      chat_zap: 0,
      whatsapp_gestor: 0,
      whatsapp_proposta: 0,
      whatsapp_template_id: '',
      whatsapp_template_nome: '',
      whatsapp_template_language: ''
    })
  }

  useEffect(() => {
    if (!showUsuarioForm) return undefined
    let cancelado = false
    setCarregandoTemplatesWhatsApp(true)
    listarTemplatesDisponiveis({ usuario_id: userId })
      .then((res) => {
        if (!cancelado) setTemplatesWhatsAppUsuario(res.templates || [])
      })
      .finally(() => {
        if (!cancelado) setCarregandoTemplatesWhatsApp(false)
      })
    return () => {
      cancelado = true
    }
  }, [showUsuarioForm, userId])

  // Fechar modal de senha temporária
  const closePasswordModal = () => {
    setShowPasswordModal(false)
    setTempPasswordData({
      nome: '',
      email: '',
      senha: ''
    })
    showNotification('Usuário cadastrado com sucesso!', 'success')
  }

  // Funções para alterar senha
  const openChangePasswordForm = () => {
    setShowChangePasswordForm(true)
    setChangePasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    })
    setPasswordError('')
    setPasswordSuccess('')
  }

  const closeChangePasswordForm = () => {
    setShowChangePasswordForm(false)
    setChangePasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    })
    setPasswordError('')
    setPasswordSuccess('')
  }

  const handleChangePassword = async (e) => {
    e.preventDefault()
    setPasswordError('')
    setPasswordSuccess('')

    // Validações
    if (!changePasswordData.currentPassword.trim()) {
      setPasswordError('Senha atual é obrigatória')
      return
    }

    if (!changePasswordData.newPassword.trim()) {
      setPasswordError('Nova senha é obrigatória')
      return
    }

    if (changePasswordData.newPassword.length < 6) {
      setPasswordError('Nova senha deve ter pelo menos 6 caracteres')
      return
    }

    if (changePasswordData.newPassword !== changePasswordData.confirmPassword) {
      setPasswordError('As senhas não coincidem')
      return
    }

    try {
      // Usar a função personalizada do banco para alterar senha
      const { data, error } = await supabase
        .rpc('alterar_senha_usuario', {
          p_usuario_id: user.id,
          p_senha_atual: changePasswordData.currentPassword,
          p_nova_senha: changePasswordData.newPassword
        })

      if (error) throw error

      if (data && data.length > 0) {
        const resultado = data[0]
        
        if (resultado.sucesso) {
          setPasswordSuccess(resultado.mensagem)
          
          // Limpar formulário
          setChangePasswordData({
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
          })
          
          // Fechar modal após um tempo
          setTimeout(() => {
            closeChangePasswordForm()
          }, 2000)
        } else {
          setPasswordError(resultado.mensagem)
        }
      } else {
        setPasswordError('Resposta inválida do servidor')
      }
    } catch (error) {
      console.error('Erro ao alterar senha:', error)
      setPasswordError('Erro ao alterar senha: ' + error.message)
    }
  }

  // Funções para confirmação de saída
  const openLogoutConfirmation = () => {
    setShowLogoutConfirmation(true)
  }

  const closeLogoutConfirmation = () => {
    setShowLogoutConfirmation(false)
  }
  const confirmLogout = async () => {
    try {
      // Fechar o modal primeiro
      closeLogoutConfirmation()
      
      // Fazer logout do sistema simplificado
      localStorage.removeItem('usuario')
      localStorage.removeItem('isAuthenticated')
      
      // Redirecionar para login
      window.location.href = '/login'
    } catch (error) {
      console.error('Erro ao fazer logout:', error)
      // Em caso de erro, mostrar notificação
      showNotification('Erro ao fazer logout: ' + error.message, 'error')
    }
  }

  // Funções para menu hambúrguer
  const toggleHamburgerMenu = () => {
    setShowHamburgerMenu(!showHamburgerMenu)
  }
  
  // Função para voltar da lista de material
  const handleBackFromListaMaterial = () => {
    setShowListaMaterial(false)
  }

  const closeHamburgerMenu = () => {
    setShowHamburgerMenu(false)
  }

  // Função para navegar entre views com histórico
  const navigateToView = useCallback((view, addToHistory = true) => {
    if (addToHistory) {
      // Adicionar ao histórico interno
      setViewHistory(prev => {
        // Evitar adicionar a mesma view consecutiva
        if (prev[prev.length - 1] !== view) {
          const newHistory = [...prev, view]
          // Adicionar ao histórico do navegador (para o botão voltar funcionar)
          window.history.pushState({ view, history: newHistory }, '', window.location.pathname)
          return newHistory
        }
        return prev
      })
    }
    
    // Atualizar a view atual
    setCurrentView(view)
  }, [])

  // Função para voltar usando o histórico (chamada quando usuário clica no botão "Voltar")
  const goBack = useCallback(() => {
    setViewHistory(prev => {
      if (prev.length > 1) {
        // Remove a view atual do histórico
        const newHistory = prev.slice(0, -1)
        // Volta para a view anterior
        const previousView = newHistory[newHistory.length - 1] || 'dashboard'
        setCurrentView(previousView)
        
        // Atualizar o histórico do navegador para manter sincronizado
        window.history.replaceState({ view: previousView, history: newHistory }, '', window.location.pathname)
        
        return newHistory
      } else {
        // Se não há histórico, vai para o dashboard
        setCurrentView('dashboard')
        window.history.replaceState({ view: 'dashboard', history: ['dashboard'] }, '', window.location.pathname)
        return ['dashboard']
      }
    })
  }, [])

  const handleNavItemClick = (view) => {
    setShowValorKitManager(false)
    setShowKitsPersonalizados(false)
    setShowConsultaPropostas(false)
    setShowListaMaterial(false)
    setShowEmpresas(false)
    navigateToView(view, true)
    closeHamburgerMenu()
  }
  
  // Listener para o botão voltar do dispositivo móvel
  useEffect(() => {
    const handlePopState = (event) => {
      // Quando o usuário aperta o botão voltar do dispositivo, navegar internamente
      setViewHistory(prev => {
        if (prev.length > 1) {
          // Remove a view atual do histórico
          const newHistory = prev.slice(0, -1)
          // Volta para a view anterior
          const previousView = newHistory[newHistory.length - 1] || 'dashboard'
          setCurrentView(previousView)
          
          return newHistory
        } else {
          // Se não há histórico, mantém no dashboard
          // Prevenir sair da aplicação - adiciona uma entrada falsa no histórico
          window.history.pushState({ view: 'dashboard', history: ['dashboard'] }, '', window.location.pathname)
          setCurrentView('dashboard')
          return ['dashboard']
        }
      })
    }
    
    // Adicionar uma entrada inicial no histórico para evitar sair da aplicação ao primeiro back
    if (!window.history.state || !window.history.state.view) {
      window.history.replaceState({ view: 'dashboard', history: ['dashboard'] }, '', window.location.pathname)
      // Adicionar uma segunda entrada para garantir que sempre há onde voltar
      window.history.pushState({ view: 'dashboard', history: ['dashboard'] }, '', window.location.pathname)
    }
    
    // Adicionar listener
    window.addEventListener('popstate', handlePopState)
    
    // Limpar listener ao desmontar
    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  // Funções para cargos
  const handleEditCargo = (cargo) => {
    // Verificar se o usuário pode editar este cargo
    if (isCargoRestrito(cargo.cargo) && !isAdministrador()) {
      showNotification('Você não tem permissão para editar este cargo.', 'error')
      return
    }
    
    setEditingCargo(cargo)
    setCargoFormData({
      cargo: cargo.cargo || '',
      ativo: cargo.ativo !== undefined ? cargo.ativo : true
    })
    setShowCargoForm(true)
  }

  const handleDeleteCargo = async (cargo) => {
    // Verificar se o usuário pode excluir este cargo
    if (isCargoRestrito(cargo.cargo) && !isAdministrador()) {
      showNotification('Você não tem permissão para excluir este cargo.', 'error')
      return
    }
    
    if (!window.confirm(`Tem certeza que deseja excluir o cargo "${cargo.cargo}"?`)) {
      return
    }
    
    try {
      const { error } = await supabase
        .from('cargos')
        .delete()
        .eq('id', cargo.id)
      
      if (error) throw error
      
      showNotification('Cargo excluído com sucesso!', 'success')
      loadCargos()
    } catch (error) {
      console.error('Erro ao excluir cargo:', error)
      showNotification('Erro ao excluir cargo: ' + error.message, 'error')
    }
  }

  // Salvar cargo
  const handleCargoFormSubmit = async (e) => {
    e.preventDefault()
    
    // Verificar se o usuário pode criar/editar cargos restritos
    if (isCargoRestrito(cargoFormData.cargo) && !isAdministrador()) {
      showNotification('Você não tem permissão para criar ou editar este cargo.', 'error')
      return
    }
    
    try {
      if (editingCargo) {
        // Atualizar cargo existente
        const { error } = await supabase
          .from('cargos')
          .update(cargoFormData)
          .eq('id', editingCargo.id)
        
        if (error) throw error
        
        showNotification('Cargo atualizado com sucesso!', 'success')
      } else {
        // Criar novo cargo
        const { error } = await supabase
          .from('cargos')
          .insert([cargoFormData])
        
        if (error) throw error
        
        showNotification('Cargo cadastrado com sucesso!', 'success')
      }
      
      closeCargoForm()
      loadCargos()
    } catch (error) {
      console.error('Erro ao salvar cargo:', error)
      showNotification('Erro ao salvar cargo: ' + error.message, 'error')
    }
  }

  // Fechar formulário de cargo
  const closeCargoForm = () => {
    setShowCargoForm(false)
    setEditingCargo(null)
    setCargoFormData({
      cargo: '',
      ativo: true
    })
  }

  // Funções para veículos
  const handleEditVeiculo = (veiculo) => {
    setEditingVeiculo(veiculo)
    setVeiculoFormData({
      veiculo: veiculo.veiculo || '',
      placa: veiculo.placa || '',
      ativo: veiculo.ativo !== undefined ? veiculo.ativo : true,
      empresa_id: veiculo.empresa_id || userEmpresa?.id || ''
    })
    setShowVeiculoForm(true)
  }

  const handleDeleteVeiculo = async (veiculo) => {
    if (!window.confirm(`Tem certeza que deseja excluir o veículo "${veiculo.veiculo}"?`)) {
      return
    }
    
    try {
      const { error } = await supabase
        .from('veiculos')
        .delete()
        .eq('id', veiculo.id)
      
      if (error) throw error
      
      showNotification('Veículo excluído com sucesso!', 'success')
      loadVeiculos()
    } catch (error) {
      console.error('Erro ao excluir veículo:', error)
      showNotification('Erro ao excluir veículo: ' + error.message, 'error')
    }
  }

  // Salvar veículo
  const handleVeiculoFormSubmit = async (e) => {
    e.preventDefault()
    
    try {
      // Garantir que a empresa_id esteja definida
      if (!veiculoFormData.empresa_id) {
        if (userRole === 'administrador') {
          // Para administradores, usar a empresa do usuário logado se não selecionou uma
          if (userEmpresa?.id) {
            veiculoFormData.empresa_id = userEmpresa.id
          } else {
            showNotification('Selecione uma empresa para o veículo.', 'error')
            return
          }
        } else {
          // Usuário não-administrador: usar empresa do usuário logado
          veiculoFormData.empresa_id = userEmpresa?.id
        }
      }

      if (editingVeiculo) {
        // Atualizar veículo existente
        const { error } = await supabase
          .from('veiculos')
          .update(veiculoFormData)
          .eq('id', editingVeiculo.id)
        
        if (error) throw error
        
        showNotification('Veículo atualizado com sucesso!', 'success')
      } else {
        // Criar novo veículo
        const { error } = await supabase
          .from('veiculos')
          .insert([veiculoFormData])
        
        if (error) throw error
        
        showNotification('Veículo cadastrado com sucesso!', 'success')
      }
      
      closeVeiculoForm()
      loadVeiculos()
    } catch (error) {
      console.error('Erro ao salvar veículo:', error)
      showNotification('Erro ao salvar veículo: ' + error.message, 'error')
    }
  }

     // Fechar formulário de veículo
   const closeVeiculoForm = () => {
     setShowVeiculoForm(false)
     setEditingVeiculo(null)
     setVeiculoFormData({
       veiculo: '',
       placa: '',
       ativo: true,
       empresa_id: userEmpresa?.id || ''
     })
   }
   
   // Funções para tipos de serviço
   const handleEditTipoServico = (tipo) => {
     setEditingTipoServico(tipo)
     setTipoServicoFormData({
       nome: tipo.nome || '',
       descricao: tipo.descricao || '',
       valor_servico: tipo.valor_servico 
         ? parseFloat(tipo.valor_servico).toLocaleString('pt-BR', {
             minimumFractionDigits: 2,
             maximumFractionDigits: 2
           })
         : '',
       ativo: tipo.ativo !== undefined ? tipo.ativo : true
     })
     setShowTipoServicoForm(true)
   }
   
   const handleDeleteTipoServico = async (tipo) => {
     if (!window.confirm(`Tem certeza que deseja excluir o tipo de serviço "${tipo.nome}"?`)) {
       return
     }
     
     try {
       const { error } = await supabase
         .from('tipo_servico')
         .delete()
         .eq('id', tipo.id)
       
       if (error) throw error
       
       showNotification('Tipo de serviço excluído com sucesso!', 'success')
       loadTiposServico()
     } catch (error) {
       console.error('Erro ao excluir tipo de serviço:', error)
       showNotification('Erro ao excluir tipo de serviço: ' + error.message, 'error')
     }
   }
   
   // Função para formatar valor de moeda no padrão brasileiro
   const formatCurrencyInput = (value) => {
     // Remove tudo que não é dígito
     const numbers = value.replace(/\D/g, '')
     
     if (!numbers) return ''
     
     // Converte para número e divide por 100
     const amount = parseFloat(numbers) / 100
     
     // Formata com separador de milhar e decimal brasileiro
     return amount.toLocaleString('pt-BR', {
       minimumFractionDigits: 2,
       maximumFractionDigits: 2
     })
   }

   // Função para converter valor brasileiro para número
   const parseCurrencyBR = (value) => {
     // Converte formato brasileiro (14.524,25) para número (14524.25)
     if (!value) return 0
     const cleanValue = value.replace(/\./g, '').replace(',', '.')
     return parseFloat(cleanValue) || 0
   }

   // Salvar tipo de serviço
   const handleTipoServicoFormSubmit = async (e) => {
     e.preventDefault()
     
     try {
       const nomeNormalizado = tipoServicoFormData.nome.trim().toLowerCase()
       
       // Validação: Verificar se já existe um tipo com o mesmo nome
       const tipoExistente = tiposServico.find(tipo => {
         // Se estiver editando, ignorar o próprio registro
         if (editingTipoServico && tipo.id === editingTipoServico.id) {
           return false
         }
         return tipo.nome.toLowerCase() === nomeNormalizado
       })
       
       if (tipoExistente) {
         // Mostrar modal de validação customizado
         setDuplicateTipoData(tipoExistente)
         setShowDuplicateModal(true)
         return
       }

       const dataToSave = {
         nome: tipoServicoFormData.nome.trim(),
         descricao: tipoServicoFormData.descricao.trim() || null,
         valor_servico: tipoServicoFormData.valor_servico ? parseCurrencyBR(tipoServicoFormData.valor_servico) : 0,
         ativo: tipoServicoFormData.ativo
       }

       if (editingTipoServico) {
         // Atualizar tipo de serviço existente
         const { error } = await supabase
           .from('tipo_servico')
           .update(dataToSave)
           .eq('id', editingTipoServico.id)
         
         if (error) throw error
         
         showNotification('Tipo de serviço atualizado com sucesso!', 'success')
       } else {
         // Criar novo tipo de serviço
         const { error } = await supabase
           .from('tipo_servico')
           .insert([dataToSave])
         
         if (error) throw error
         
         showNotification('Tipo de serviço cadastrado com sucesso!', 'success')
       }
       
       closeTipoServicoForm()
       loadTiposServico()
     } catch (error) {
       console.error('Erro ao salvar tipo de serviço:', error)
       showNotification('Erro ao salvar tipo de serviço: ' + error.message, 'error')
     }
   }
   
   // Fechar formulário de tipo de serviço
   const closeTipoServicoForm = () => {
     setShowTipoServicoForm(false)
     setEditingTipoServico(null)
     setTipoServicoFormData({ 
       nome: '', 
       descricao: '',
       valor_servico: '',
       ativo: true 
     })
   }

   // Funções para modal de nome duplicado
   const closeDuplicateModal = () => {
     setShowDuplicateModal(false)
     setDuplicateTipoData(null)
   }

   const handleEditExistingTipo = () => {
     if (duplicateTipoData) {
       handleEditTipoServico(duplicateTipoData)
       closeDuplicateModal()
     }
   }
   
   // Funções para tipos de padrão
   const handleEditTipoPadrao = (tipo) => {
     setEditingTipoPadrao(tipo)
     setTipoPadraoFormData({
       nome: tipo.nome || '',
       ativo: tipo.ativo !== undefined ? tipo.ativo : true
     })
     setShowTipoPadraoForm(true)
   }
   
   const handleDeleteTipoPadrao = async (tipo) => {
     if (!window.confirm(`Tem certeza que deseja excluir o tipo de padrão "${tipo.nome}"?`)) {
       return
     }
     
     try {
       const { error } = await supabase
         .from('tipo_padrao')
         .delete()
         .eq('id', tipo.id)
       
       if (error) throw error
       
       showNotification('Tipo de padrão excluído com sucesso!', 'success')
       loadTiposPadrao()
     } catch (error) {
       console.error('Erro ao excluir tipo de padrão:', error)
       showNotification('Erro ao excluir tipo de padrão: ' + error.message, 'error')
     }
   }
   
   // Exportar medição para CSV
   const exportarMedicaoCSV = () => {
     if (medicaoData.length === 0) {
       showNotification('Não há dados para exportar!', 'warning')
       return
     }
     
     try {
       // Criar cabeçalho do CSV
       const headers = tipoMedicao === 'kwp' ? [
         'CLIENTE',
         'DATA',
         'TIPO DE SERVIÇO',
         'QTD MÓDULOS',
         'KWP',
         'PADRÃO',
         'CONFIG. INVERSOR',
         'DESLOCAMENTO',
         'NOTA MATERIAL',
         'OBRA CIVIL',
         'TOTAL',
         'OBSERVAÇÃO'
       ] : [
         'CLIENTE',
         'DATA',
         'TIPO DE SERVIÇO',
         'QTD MÓDULOS',
         'KWP',
         'PADRÃO',
         'CONFIG. INVERSOR',
         'DESLOCAMENTO',
         'NOTA MATERIAL',
         'OBRA CIVIL',
         'COMPRAS',
         'TOTAL',
         'OBSERVAÇÃO'
       ]
       
       // Criar linhas de dados
       const rows = medicaoData.map(item => {
         const baseData = [
           item.cliente,
           new Date(item.data).toLocaleDateString('pt-BR'),
           item.tipo_servico,
           item.qtd_modulos,
           ((item.qtd_modulos || 0) * 0.610).toFixed(2).replace('.', ','),
           item.padrao,
           item.configuracao_inversor,
           item.deslocamento_buscar_material,
           item.nota_material,
           item.valor_obra_civil,
           `R$ ${item.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`,
           item.observacao
         ]
         
         if (tipoMedicao === 'modulos') {
           baseData.splice(10, 0, `R$ ${(item.valor_compras || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`)
         }
         
         return baseData
       })
       
       // Combinar cabeçalho e dados
       const csvContent = [headers, ...rows]
         .map(row => row.map(cell => `"${cell}"`).join(','))
         .join('\n')
       
       // Criar e baixar arquivo
       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
       const link = document.createElement('a')
       const url = URL.createObjectURL(blob)
       link.setAttribute('href', url)
       link.setAttribute('download', `medicao_tecsol_${medicaoPeriodo.inicio}_${medicaoPeriodo.fim}.csv`)
       link.style.visibility = 'hidden'
       document.body.appendChild(link)
       link.click()
       document.body.removeChild(link)
       
       showNotification('Relatório CSV exportado com sucesso!', 'success')
     } catch (error) {
       console.error('Erro ao exportar medição CSV:', error)
       showNotification('Erro ao exportar medição CSV: ' + error.message, 'error')
     }
   }

   // Exportar medição para Excel
   const exportarMedicaoExcel = () => {
     if (medicaoData.length === 0) {
       showNotification('Não há dados para exportar!', 'warning')
       return
     }
     
     try {
       // Criar cabeçalho do Excel
       const headers = tipoMedicao === 'kwp' ? [
         'CLIENTE',
         'DATA DE INSTALAÇÃO',
         'TIPO DE SERVIÇO',
         'QTD MÓDULOS',
         'KWP',
         'PADRÃO',
         'CONFIG. INVERSOR',
         'DESLOCAMENTO',
         'NOTA MATERIAL',
         'OBRA CIVIL',
         'EQUIPE',
         'VALOR OBRA',
         'VALOR MATERIAL',
         'TOTAL',
         'OBSERVAÇÃO'
       ] : [
         'CLIENTE',
         'DATA DE INSTALAÇÃO',
         'TIPO DE SERVIÇO',
         'QTD MÓDULOS',
         'KWP',
         'PADRÃO',
         'CONFIG. INVERSOR',
         'DESLOCAMENTO',
         'NOTA MATERIAL',
         'OBRA CIVIL',
         'EQUIPE',
         'VALOR OBRA',
         'VALOR MATERIAL',
         'COMPRAS',
         'TOTAL',
         'OBSERVAÇÃO'
       ]
       
       // Criar linhas de dados
       const rows = medicaoData.map(item => {
         const baseData = [
           item.cliente,
           new Date(item.data).toLocaleDateString('pt-BR'),
           item.tipo_servico,
           item.qtd_modulos,
           parseFloat(((item.qtd_modulos || 0) * 0.610).toFixed(2)),
           item.padrao,
           item.configuracao_inversor,
           item.deslocamento_buscar_material,
           item.nota_material,
           item.obra_civil,
           item.equipe,
           parseFloat((item.valor_obra || 0).toFixed(2)),
           parseFloat((item.valor_material || 0).toFixed(2)),
           parseFloat(item.total.toFixed(2)),
           item.observacao
         ]
         
         if (tipoMedicao === 'modulos') {
           baseData.splice(13, 0, parseFloat((item.valor_compras || 0).toFixed(2)))
         }
         
         return baseData
       })
       
       // Criar workbook e worksheet
       const wb = XLSX.utils.book_new()
       const ws = XLSX.utils.aoa_to_sheet([headers, ...rows])
       
       // Ajustar largura das colunas
       const colWidths = tipoMedicao === 'kwp' ? [
         { wch: 25 }, // CLIENTE
         { wch: 15 }, // DATA DE INSTALAÇÃO
         { wch: 20 }, // TIPO DE SERVIÇO
         { wch: 12 }, // QTD MÓDULOS
         { wch: 10 }, // KWP
         { wch: 15 }, // PADRÃO
         { wch: 15 }, // CONFIG. INVERSOR
         { wch: 15 }, // DESLOCAMENTO
         { wch: 15 }, // NOTA MATERIAL
         { wch: 12 }, // OBRA CIVIL
         { wch: 15 }, // EQUIPE
         { wch: 15 }, // VALOR OBRA
         { wch: 15 }, // VALOR MATERIAL
         { wch: 15 }, // TOTAL
         { wch: 40 }  // OBSERVAÇÃO
       ] : [
         { wch: 25 }, // CLIENTE
         { wch: 15 }, // DATA DE INSTALAÇÃO
         { wch: 20 }, // TIPO DE SERVIÇO
         { wch: 12 }, // QTD MÓDULOS
         { wch: 10 }, // KWP
         { wch: 15 }, // PADRÃO
         { wch: 15 }, // CONFIG. INVERSOR
         { wch: 15 }, // DESLOCAMENTO
         { wch: 15 }, // NOTA MATERIAL
         { wch: 12 }, // OBRA CIVIL
         { wch: 15 }, // EQUIPE
         { wch: 15 }, // VALOR OBRA
         { wch: 15 }, // VALOR MATERIAL
         { wch: 15 }, // COMPRAS
         { wch: 15 }, // TOTAL
         { wch: 40 }  // OBSERVAÇÃO
       ]
       ws['!cols'] = colWidths
       
       // Aplicar formatação monetária para colunas de valores
       const range = XLSX.utils.decode_range(ws['!ref'])
       
       // Formatação monetária brasileira
       const formatMonetario = '"R$" #,##0.00'
       
       // Aplicar formatação para colunas de valores (baseado no tipo de medição)
       for (let row = 2; row <= range.e.r; row++) { // Começar da linha 2 (pular cabeçalho)
         if (tipoMedicao === 'kwp') {
           // Para Kwp: VALOR OBRA (L), VALOR MATERIAL (M), TOTAL (N)
           ws[XLSX.utils.encode_cell({ r: row, c: 11 })].z = formatMonetario // VALOR OBRA
           ws[XLSX.utils.encode_cell({ r: row, c: 12 })].z = formatMonetario // VALOR MATERIAL
           ws[XLSX.utils.encode_cell({ r: row, c: 13 })].z = formatMonetario // TOTAL
         } else {
           // Para Módulos: VALOR OBRA (L), VALOR MATERIAL (M), COMPRAS (N), TOTAL (O)
           ws[XLSX.utils.encode_cell({ r: row, c: 11 })].z = formatMonetario // VALOR OBRA
           ws[XLSX.utils.encode_cell({ r: row, c: 12 })].z = formatMonetario // VALOR MATERIAL
           ws[XLSX.utils.encode_cell({ r: row, c: 13 })].z = formatMonetario // COMPRAS
           ws[XLSX.utils.encode_cell({ r: row, c: 14 })].z = formatMonetario // TOTAL
         }
       }
       
       // Adicionar worksheet ao workbook
       XLSX.utils.book_append_sheet(wb, ws, 'Medição TecSol')
       
       // Gerar arquivo Excel e baixar
       XLSX.writeFile(wb, `medicao_tecsol_${medicaoPeriodo.inicio}_${medicaoPeriodo.fim}.xlsx`)
       
       showNotification('Relatório Excel exportado com sucesso!', 'success')
     } catch (error) {
       console.error('Erro ao exportar medição Excel:', error)
       showNotification('Erro ao exportar medição Excel: ' + error.message, 'error')
     }
   }
   
   // Salvar tipo de padrão
   const handleTipoPadraoFormSubmit = async (e) => {
     e.preventDefault()
     
     try {
       if (editingTipoPadrao) {
         // Atualizar tipo de padrão existente
         const { error } = await supabase
           .from('tipo_padrao')
           .update(tipoPadraoFormData)
           .eq('id', editingTipoPadrao.id)
         
         if (error) throw error
         
         showNotification('Tipo de padrão atualizado com sucesso!', 'success')
       } else {
         // Criar novo tipo de padrão
         const { error } = await supabase
           .from('tipo_padrao')
           .insert([tipoPadraoFormData])
         
         if (error) throw error
         
         showNotification('Tipo de padrão cadastrado com sucesso!', 'success')
       }
       
       closeTipoPadraoForm()
       loadTiposPadrao()
     } catch (error) {
       console.error('Erro ao salvar tipo de padrão:', error)
       showNotification('Erro ao salvar tipo de padrão: ' + error.message, 'error')
     }
   }
   
   // Fechar formulário de tipo de padrão
   const closeTipoPadraoForm = () => {
     setShowTipoPadraoForm(false)
     setEditingTipoPadrao(null)
     setTipoPadraoFormData({
       nome: '',
       ativo: true
     })
   }

  // Funções auxiliares de segurança
  const isAdministrador = () => {
    return userRole === USER_ROLES.ADMINISTRADOR
  }
  
  const isCargoRestrito = (cargoNome) => {
    const cargosRestritos = ['administrador', 'administrativo', 'pap']
    return cargosRestritos.includes(cargoNome?.toLowerCase())
  }
  
  const podeGerenciarCargo = (cargoNome) => {
    if (!isCargoRestrito(cargoNome)) return true
    return isAdministrador()
  }
  
  // Função para formatar data
  const formatarData = (dataString) => {
    if (!dataString) return 'N/A'
    
    try {
      if (typeof dataString === 'string' && dataString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [ano, mes, dia] = dataString.split('-')
        return `${dia}/${mes}/${ano}`
      }
      
      const data = new Date(dataString)
      if (isNaN(data.getTime())) {
        return 'Data Inválida'
      }
      
      return data.toLocaleDateString('pt-BR')
    } catch (error) {
      return 'Erro na Data'
    }
  }
  
  // Sistema simplificado não precisa monitorar mudanças de autenticação
  // A autenticação é gerenciada via localStorage

  // Carregar dados iniciais
  const loadInitialData = useCallback(async () => {
    try {
      // Verificar se o usuário está autenticado no sistema simplificado
      const usuarioStorage = localStorage.getItem('usuario')
      const isAuthenticated = localStorage.getItem('isAuthenticated')
      
      if (!usuarioStorage || !isAuthenticated) {
        console.error('❌ Usuário não autenticado')
        setAuthErrorMessage('Sessão expirada ou usuário não autenticado. Por favor, faça login novamente.')
        setShowAuthErrorModal(true)
        return
      }

      const usuario = JSON.parse(usuarioStorage)
      
      // Verificar se o usuário ainda é válido no banco
      const { data: profile, error: profileError } = await supabase
        .from('usuarios_sistema')
        .select('id, nome, role, status, empresa_id, chat_zap, whatsapp_gestor, whatsapp_proposta')
        .eq('id', usuario.id)
        .single()
      
      if (profileError) {
        console.error('❌ Erro ao carregar perfil:', profileError)
        localStorage.removeItem('usuario')
        localStorage.removeItem('isAuthenticated')
        setAuthErrorMessage('Erro ao carregar perfil do usuário. Por favor, faça login novamente.')
        setShowAuthErrorModal(true)
        return
      }
      
      // Verificar se o usuário está ativo e definir o role com case-insensitive
      if (profile && profile.status === 'ativo') {
        // Converter role para minúsculo para comparação case-insensitive
        const roleLowerCase = profile.role?.toLowerCase()

        // Definir userRole baseado no role em minúsculo
        if (roleLowerCase === 'instalador') {
          setUserRole('instalador')
        } else if (roleLowerCase === 'administrador') {
          setUserRole('administrador')
        } else if (roleLowerCase === 'administrativo' || roleLowerCase === 'usuarioadministrativo' || roleLowerCase === 'usuario_administrativo') {
          setUserRole('administrativo')
        } else if (roleLowerCase === 'especialista') {
          setUserRole('especialista')
        } else if (roleLowerCase === 'gerente') {
          setUserRole('gerente')
        } else if (roleLowerCase === 'gerente_comercial') {
          setUserRole('gerente_comercial')
        } else if (roleLowerCase === 'homologador') {
          setUserRole('homologador')
        } else if (roleLowerCase === 'campo') {
          setUserRole('campo')
        } else if (roleLowerCase === 'vistoriador') {
          setUserRole('vistoriador')
        } else if (roleLowerCase === 'pap') {
          setUserRole('pap')
        } else if (roleLowerCase === 'sdr') {
          setUserRole('sdr')
        } else if (roleLowerCase === 'avulso') {
          setUserRole('avulso')
        } else {
          setUserRole(null)
        }
      } else {
        // Logout automático para usuários inativos
        localStorage.removeItem('usuario')
        localStorage.removeItem('isAuthenticated')
        setAuthErrorMessage('Usuário inativo. Entre em contato com o administrador.')
        setShowAuthErrorModal(true)
        return
      }
      
      setUser({
        ...usuario,
        nome: profile.nome,
        chat_zap: Number(profile.chat_zap) === 1 ? 1 : 0,
        whatsapp_gestor: Number(profile.whatsapp_gestor) === 1 ? 1 : 0,
        whatsapp_proposta: Number(profile.whatsapp_proposta) === 1 ? 1 : 0
      })
      
      // Carregar dados da empresa separadamente para evitar erro de join
      let empresaData = { empresa: 'Empresa não definida' }
      
      if (profile.empresa_id) {
        try {
          const { data: empresa, error: empresaError } = await supabase
            .from('empresa')
            .select('*') // Selecionar tudo para garantir que pegamos o que existir
            .eq('id', profile.empresa_id)
            .single()
            
          if (empresa && !empresaError) {
            empresaData = empresa
          }
        } catch (err) {
          console.error('Erro ao carregar dados da empresa:', err)
        }
      }
      
      // Definir empresa do usuário (TODOS os usuários têm empresa)
      setUserEmpresa({
        id: profile.empresa_id,
        nome: empresaData.empresa || 'Empresa não definida',
        empresa: empresaData.empresa,
        razao_social: empresaData.razao_social,
        cnpj: empresaData.cnpj,
        contato: empresaData.contato,
        email: empresaData.email,
        endereco: empresaData.endereco,
        logo_url: empresaData.logo || empresaData.logo_url,
        banco: empresaData.banco,
        agencia: empresaData.agencia,
        conta: empresaData.conta,
        chave_pix: empresaData.chave_pix,
        permitir_venda: empresaData.permitir_venda !== false
      })
    } catch (error) {
      console.error('❌ Erro ao carregar dados iniciais:', error)
    } finally {
      setIsLoading(false)
    }
  }, [navigate])
  
  // Função para carregar permissões de menus
  const loadPermissoesMenus = useCallback(async (userId) => {
    try {
      const permissoes = await security.loadPermissoesMenus(userId)
      setPermissoesMenusCache(permissoes)
      // Se tem permissões salvas (mesmo que sejam false), o usuário tem permissões customizadas
      setHasPermissoesCustomizadas(Object.keys(permissoes).length > 0)
    } catch (error) {
      console.error('Erro ao carregar permissões de menus:', error)
      setPermissoesMenusCache({})
      setHasPermissoesCustomizadas(false)
    }
  }, [])
  
  // Carregar propostas
  const loadPropostas = useCallback(async () => {
    try {
      let query = supabase
        .from('propostas_clientes')
        .select(`
          *,
          usuarios_sistema!id_usuario_responsavel!inner (
            id,
            nome,
            email,
            empresa_id
          )
        `)
        .order('data_proposta', { ascending: false })

      // Lógica de filtro multi-empresa
      if (userRole === 'administrador') {
        // Administrador vê tudo
      } else if (userRole === 'gerente' || userRole === 'gerente_comercial') {
        // Gerentes veem tudo da sua empresa
        if (userEmpresa?.id) {
          query = query.eq('usuarios_sistema.empresa_id', userEmpresa.id)
        } else {
          // Fallback: se não tiver empresa definida, vê apenas as suas
          query = query.eq('id_usuario_responsavel', user?.id)
        }
      } else {
        // Outros usuários veem apenas as suas
        query = query.eq('id_usuario_responsavel', user?.id)
      }

      const { data, error } = await query

      if (error) {
        console.error('Erro ao carregar propostas:', error)
        return
      }

      setPropostas(data || [])
    } catch (error) {
      console.error('Erro ao carregar propostas:', error)
    }
  }, [userRole, user?.id, userEmpresa?.id])

  // Carregar empresas disponíveis (administrador ou administrativo da empresa privilegiada)
  const loadEmpresasDisponiveis = useCallback(async () => {
    if (userRole !== USER_ROLES.ADMINISTRADOR && !podeFiltrarMultiEmpresaClientes) {
      return
    }
    
    try {
      const { data, error } = await supabase
        .from('empresa')
        .select('id, empresa')
        .eq('ativa', true)
        .order('empresa')
      
      if (error) throw error
      
      setEmpresasDisponiveis(data || [])
      
      // Definir empresa padrão como a empresa do administrador logado (seleção inicial)
      if (userRole === USER_ROLES.ADMINISTRADOR && userEmpresa?.id) {
        setEmpresasFiltroMultiClientes(prev => (prev.length > 0 ? prev : [userEmpresa.id]))
      }
    } catch (error) {
      console.error('Erro ao carregar empresas disponíveis:', error)
    }
  }, [userRole, userEmpresa, podeFiltrarMultiEmpresaClientes])

  // useEffect para atualizar o relógio a cada segundo
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)
    
    // Limpar o intervalo quando o componente for desmontado
    return () => clearInterval(timer)
  }, [])

  // Carregar dados iniciais quando o componente montar
  useEffect(() => {
    loadInitialData()
  }, [loadInitialData])

  // Carregar dados básicos (cargos e tipos de pagamento) quando o componente montar
  useEffect(() => {
    loadCargos()
    loadTiposPagamento()
  }, [])

  // Carregar permissões de menus quando o usuário fizer login
  useEffect(() => {
    if (user?.id && userRole) {
      // Administradores não precisam de cache (têm acesso a tudo)
      if (userRole === 'administrador') {
        setPermissoesMenusCache({})
        setHasPermissoesCustomizadas(false)
      } else {
        loadPermissoesMenus(user.id)
      }
    } else {
      setPermissoesMenusCache({})
      setHasPermissoesCustomizadas(false)
    }
  }, [user?.id, userRole, loadPermissoesMenus])
  
  // Carregar propostas quando userRole e user estiverem definidos
  useEffect(() => {
    if (userRole && user?.id) {
      loadPropostas()
    }
  }, [userRole, user?.id, loadPropostas])

  // Garantir que o Bootstrap seja inicializado corretamente
  useEffect(() => {
    // Verificar se o Bootstrap está disponível
    if (typeof window !== 'undefined' && window.bootstrap) {
      // Bootstrap carregado com sucesso
    } else {
      console.warn('⚠️ Bootstrap não encontrado, tentando carregar...')
    }
  }, [])

  // Carregar dados básicos após definir o userRole
  useEffect(() => {
    if (userRole && !isLoading) {
      const loadBasicData = async () => {
        try {
          // Carregar dados sequencialmente para evitar sobrecarga
          await loadEquipes()
          await loadTiposServico()
          await loadTiposPadrao()
          await loadStatusClientes()
          await loadUsuariosInstaladores()
        } catch (error) {
          console.error('Erro ao carregar dados básicos:', error)
        }
      }
      
      loadBasicData()
    }
  }, [userRole, isLoading])

  // Carregar empresas disponíveis quando usuário for administrador ou administrativo privilegiado
  useEffect(() => {
    if ((userRole === USER_ROLES.ADMINISTRADOR || podeFiltrarMultiEmpresaClientes) && userEmpresa?.id) {
      loadEmpresasDisponiveis()
    }
  }, [userRole, userEmpresa, loadEmpresasDisponiveis, podeFiltrarMultiEmpresaClientes])

  // Recarregar clientes quando o filtro de (múltiplas) empresas mudar (administrador/administrativo privilegiado)
  useEffect(() => {
    if (podeFiltrarEmpresaClientes && empresasDisponiveis.length > 0) {
      loadClientes()
    }
  }, [empresasFiltroMultiClientes])

  // Fechar o dropdown de filtro por empresa ao clicar fora
  useEffect(() => {
    if (!empresaFiltroDropdownAberto) return
    const handleClickFora = (event) => {
      if (empresaFiltroDropdownRef.current && !empresaFiltroDropdownRef.current.contains(event.target)) {
        setEmpresaFiltroDropdownAberto(false)
      }
    }
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
  }, [empresaFiltroDropdownAberto])

  // Recarregar clientes quando o filtro de status mudar (todos os usuários)
  useEffect(() => {
    if (userRole && statusClientes.length > 0) {
      loadClientes()
    }
  }, [statusFiltroClientes])
  
  // Vistoriador: menus e tela inicial seguem Permissões de Menus (sem redirect forçado)
  
  // Para instaladores, carregar diretamente a tela de gestão de instalação
  useEffect(() => {
    if (userRole === 'instalador' && currentView === 'dashboard') {
      setCurrentView('gestao_instalacao')
    }
  }, [userRole, currentView])

  // Para usuário PAP, ir direto para Cadastrar Lead
  useEffect(() => {
    if (userRole === 'pap') {
      setCurrentView('cadastrar_leads')
    }
  }, [userRole])
  
  // Função para carregar vistorias (para vistoriadores)
  const loadVistorias = useCallback(async () => {
    try {
      setIsLoadingVistorias(true)
      
      if (!userId) {
        setVistorias([])
        return
      }

      // Buscar o ID do tipo de serviço "Vistoria"
      const { data: tipoVistoria, error: tipoError } = await supabase
        .from('tipo_servico')
        .select('id')
        .eq('nome', 'Vistoria')
        .single()

      if (tipoError || !tipoVistoria) {
        console.error('Erro ao buscar tipo de serviço Vistoria:', tipoError)
        setVistorias([])
        return
      }

      // Homologador/administrador: todas as vistorias. Demais: só onde é responsável.
      const veTodasVistorias = userRole === 'administrador' || userRole === 'homologador'
      let query = supabase
        .from('ordens_servicos')
        .select(`
          *,
          id_cliente,
          cliente:clientes_cadastro(id, nome_completo, cpf, telefone, email),
          tipo_servico:tipo_servico(id, nome),
          empresa:empresa(id, empresa),
          ordem_servico_responsaveis${veTodasVistorias ? '' : '!inner'}(
            id,
            id_responsavel,
            id_ordem_servico,
            usuario:usuarios_sistema(nome, email)
          )
        `)
        .eq('id_tipo_servico', tipoVistoria.id)
        .order('created_at', { ascending: false })

      if (!veTodasVistorias) {
        if (!userEmpresa?.id) {
          setVistorias([])
          return
        }
        query = query
          .eq('id_empresa', userEmpresa.id)
          .eq('ordem_servico_responsaveis.id_responsavel', userId)
      }

      const { data: ordensData, error: errorOrdens } = await query
      if (errorOrdens) throw errorOrdens
      const ordensList = ordensData || []

      // Buscar vistorias cadastradas para obter o status correto
      const clienteIds = ordensList.map(o => o.id_cliente).filter(Boolean)
      let vistoriasMap = new Map()
      let vistoriasCompletasMap = new Map()

      if (clienteIds.length > 0) {
        const { data: vistoriasData, error: vistoriasError } = await supabase
          .from('vistorias')
          .select('id_cliente, status, data_vistoria')
          .in('id_cliente', clienteIds)

        if (!vistoriasError && vistoriasData) {
          vistoriasData.forEach(v => {
            vistoriasMap.set(v.id_cliente, v.status)
          })
        }

        const { data: vistoriasCompletasData, error: vistoriasCompletasError } = await supabase
          .from('vistorias')
          .select(`
            *,
            tipo_padrao:tipo_padrao(id, nome)
          `)
          .in('id_cliente', clienteIds)

        if (!vistoriasCompletasError && vistoriasCompletasData) {
          vistoriasCompletasData.forEach(v => {
            vistoriasCompletasMap.set(v.id_cliente, v)
          })
        }
      }

      const vistoriasComStatus = ordensList.map(v => ({
        ...v,
        status: vistoriasMap.get(v.id_cliente) || v.status || 'Pendente',
        vistoria_completa: vistoriasCompletasMap.get(v.id_cliente) || null
      }))

      setVistorias(vistoriasComStatus)
    } catch (error) {
      console.error('Erro ao carregar vistorias:', error)
      setVistorias([])
    } finally {
      setIsLoadingVistorias(false)
    }
  }, [userId, userRole, userEmpresa])
  
  // Carregar vistorias quando o usuário tiver permissão de menu Vistorias
  useEffect(() => {
    if (security.canAccessMenu(userRole, 'vistorias', permissoesMenusCache, hasPermissoesCustomizadas) && userId && userEmpresa?.id) {
      loadVistorias()
      loadTiposPadraoVistoria()
    }
  }, [userRole, userId, userEmpresa, permissoesMenusCache, hasPermissoesCustomizadas, loadVistorias])

  // Função para carregar eventos do calendário (card no dashboard)
  const loadEventosCalendario = useCallback(async () => {
    // Somente administrador vê eventos de todas as empresas. Gerente, administrativo, gerente comercial e avulso veem todos da empresa.
    const canSeeEmpresaEvents = [USER_ROLES.GERENTE, USER_ROLES.ADMINISTRATIVO, USER_ROLES.GERENTE_COMERCIAL, USER_ROLES.AVULSO].includes(userRole)
    if (!userId && !userRole) return
    try {
      setLoadingEventosCalendario(true)
      const hoje = new Date()
      let inicio, fim
      switch (filtroEventosCalendario) {
        case 'dia':
          inicio = new Date(hoje)
          inicio.setHours(0, 0, 0, 0)
          fim = new Date(hoje)
          fim.setHours(23, 59, 59, 999)
          break
        case 'semana':
          const diaSemana = hoje.getDay()
          const diff = diaSemana === 0 ? 6 : diaSemana - 1
          inicio = new Date(hoje)
          inicio.setDate(hoje.getDate() - diff)
          inicio.setHours(0, 0, 0, 0)
          fim = new Date(inicio)
          fim.setDate(inicio.getDate() + 6)
          fim.setHours(23, 59, 59, 999)
          break
        case 'mes':
        default:
          inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
          fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0, 23, 59, 59, 999)
          break
      }
      const inicioTs = inicio.toISOString()
      const fimTs = fim.toISOString()

      const selectEventosDash = `
        id, nome_evento, tipo_evento, executado, data_hora, observacao, id_responsavel, id_ordem_servico,
        responsavel:usuarios_sistema!id_responsavel(id, nome),
        eventos_calendario_usuarios(usuario_id, usuarios_sistema(id, nome))
      `

      let query = supabase
        .from('eventos_calendario')
        .select(selectEventosDash)
        .gte('data_hora', inicioTs)
        .lte('data_hora', fimTs)
        .order('data_hora', { ascending: true })

      if (userRole === USER_ROLES.ADMINISTRADOR) {
        // Somente administrador vê eventos de todas as empresas
      } else if (canSeeEmpresaEvents && userEmpresa?.id) {
        // Eventos da empresa: via id_ordem_servico -> ordens_servicos.id_empresa OU eventos sem ordem com responsável da empresa
        const { data: ordensEmpresa } = await supabase
          .from('ordens_servicos')
          .select('id')
          .eq('id_empresa', userEmpresa.id)
        const ordemIds = (ordensEmpresa || []).map(o => o.id).filter(Boolean)
        const { data: usuariosEmpresa } = await supabase
          .from('usuarios_sistema')
          .select('id')
          .eq('empresa_id', userEmpresa.id)
        const userIdsEmpresa = (usuariosEmpresa || []).map(u => u.id).filter(Boolean)

        const baseSelect = selectEventosDash
        const baseRange = { gte: inicioTs, lte: fimTs }

        const promises = []
        if (ordemIds.length > 0) {
          promises.push(
            supabase
              .from('eventos_calendario')
              .select(baseSelect)
              .gte('data_hora', inicioTs)
              .lte('data_hora', fimTs)
              .in('id_ordem_servico', ordemIds)
              .order('data_hora', { ascending: true })
          )
        }
        if (userIdsEmpresa.length > 0) {
          promises.push(
            supabase
              .from('eventos_calendario')
              .select(baseSelect)
              .gte('data_hora', inicioTs)
              .lte('data_hora', fimTs)
              .is('id_ordem_servico', null)
              .in('id_responsavel', userIdsEmpresa)
              .order('data_hora', { ascending: true })
          )
        }

        // Somente avulso: carregar vistorias onde o responsável é o usuário definido (todos os avulsos veem as vistorias desse usuário)
        if (userRole === USER_ROLES.AVULSO) {
          const ID_RESPONSAVEL_VISTORIAS_AVULSO = '7fc72870-0217-432e-8a71-947d3e141f44'
          const { data: tipoVistoria } = await supabase.from('tipo_servico').select('id').eq('nome', 'Vistoria').maybeSingle()
          if (tipoVistoria?.id) {
            const { data: respOrdens } = await supabase
              .from('ordem_servico_responsaveis')
              .select('id_ordem_servico')
              .eq('id_responsavel', ID_RESPONSAVEL_VISTORIAS_AVULSO)
            const ordemIdsResponsavel = [...new Set((respOrdens || []).map(r => r.id_ordem_servico).filter(Boolean))]
            if (ordemIdsResponsavel.length > 0) {
              const { data: ordensVistoria } = await supabase
                .from('ordens_servicos')
                .select('id')
                .eq('id_tipo_servico', tipoVistoria.id)
                .in('id', ordemIdsResponsavel)
              const vistoriaOrdemIds = (ordensVistoria || []).map(o => o.id).filter(Boolean)
              if (vistoriaOrdemIds.length > 0) {
                promises.push(
                  supabase
                    .from('eventos_calendario')
                    .select(baseSelect)
                    .gte('data_hora', inicioTs)
                    .lte('data_hora', fimTs)
                    .in('id_ordem_servico', vistoriaOrdemIds)
                    .order('data_hora', { ascending: true })
                )
              }
            }
          }
        }

        if (promises.length === 0) {
          setEventosCalendario([])
          setLoadingEventosCalendario(false)
          return
        }
        const results = await Promise.all(promises)
        const porId = new Map()
        results.forEach((res) => {
          if (res.data) res.data.forEach(e => { if (!porId.has(e.id)) porId.set(e.id, e) })
        })
        const merged = Array.from(porId.values()).sort((a, b) => new Date(a.data_hora) - new Date(b.data_hora))
        setEventosCalendario(merged)
        setLoadingEventosCalendario(false)
        return
      } else {
        // Perfis como SDR: ver eventos onde é responsável OU onde foi adicionado em eventos_calendario_usuarios
        const [resResp, resAssoc] = await Promise.all([
          supabase
            .from('eventos_calendario')
            .select(selectEventosDash)
            .gte('data_hora', inicioTs)
            .lte('data_hora', fimTs)
            .eq('id_responsavel', userId)
            .order('data_hora', { ascending: true }),
          supabase.from('eventos_calendario_usuarios').select('evento_id').eq('usuario_id', userId)
        ])
        if (resResp.error) throw resResp.error
        const eventoIdsAssociados = [...new Set((resAssoc.data || []).map(r => r.evento_id).filter(Boolean))]
        if (eventoIdsAssociados.length === 0) {
          setEventosCalendario(resResp.data || [])
          setLoadingEventosCalendario(false)
          return
        }
        const { data: dataAssoc, error: errAssoc } = await supabase
          .from('eventos_calendario')
          .select(selectEventosDash)
          .in('id', eventoIdsAssociados)
          .gte('data_hora', inicioTs)
          .lte('data_hora', fimTs)
          .order('data_hora', { ascending: true })
        if (errAssoc) throw errAssoc
        const porId = new Map((resResp.data || []).map(e => [e.id, e]))
        ;(dataAssoc || []).forEach(e => { if (!porId.has(e.id)) porId.set(e.id, e) })
        setEventosCalendario(Array.from(porId.values()).sort((a, b) => new Date(a.data_hora) - new Date(b.data_hora)))
        setLoadingEventosCalendario(false)
        return
      }

      const { data, error } = await query
      if (error) throw error
      setEventosCalendario(data || [])
    } catch (err) {
      console.error('Erro ao carregar eventos do calendário:', err)
      setEventosCalendario([])
    } finally {
      setLoadingEventosCalendario(false)
    }
  }, [userRole, userId, userEmpresa?.id, filtroEventosCalendario])

  useEffect(() => {
    if (currentView === 'dashboard' && userRole && security.canAccessMenu(userRole, 'calendario', permissoesMenusCache, hasPermissoesCustomizadas)) {
      loadEventosCalendario()
    }
  }, [currentView, userRole, loadEventosCalendario, permissoesMenusCache, hasPermissoesCustomizadas])

  // Carregar tipos de padrão para vistorias
  const loadTiposPadraoVistoria = async () => {
    try {
      const { data, error } = await supabase
        .from('tipo_padrao')
        .select('id, nome')
        .order('nome')
      
      if (error) throw error
      setTiposPadraoVistoria(data || [])
    } catch (error) {
      console.error('Erro ao carregar tipos de padrão:', error)
    }
  }
  
  // Abrir modal de baixa de vistoria (no dashboard) - navega para tela de vistorias
  const openBaixaModalDashboard = async (vistoria) => {
    // Navegar para a tela de vistorias
    navigateToView('vistorias', true)
    setVistoriaParaBaixaDashboard(vistoria)
    
    // Verificar se já existe vistoria cadastrada
    let vistoriaExistente = vistoria.vistoria_completa || null
    const idCliente = vistoria.id_cliente || vistoria.cliente?.id
    
    // Se não tiver os dados completos, buscar do banco
    if (!vistoriaExistente && idCliente) {
      const { data: vistoriaData, error: vistoriaError } = await supabase
        .from('vistorias')
        .select('*')
        .eq('id_cliente', idCliente)
        .order('data_criacao', { ascending: false })
        .limit(1)
        .maybeSingle()
      
      if (!vistoriaError && vistoriaData) {
        vistoriaExistente = vistoriaData
      }
    }
    
    // Preencher formulário com dados existentes ou valores padrão
    if (vistoriaExistente) {
      // Parsear JSON arrays para telhado e estrutura
      let caminhoImgTelhado = ''
      let caminhoImgEstrutura = ''
      let telhadoImages = []
      let estruturaImages = []
      
      try {
        if (vistoriaExistente.caminho_img_telhado) {
          const telhadoUrls = typeof vistoriaExistente.caminho_img_telhado === 'string' 
            ? JSON.parse(vistoriaExistente.caminho_img_telhado) 
            : vistoriaExistente.caminho_img_telhado
          if (Array.isArray(telhadoUrls)) {
            caminhoImgTelhado = vistoriaExistente.caminho_img_telhado
            telhadoImages = telhadoUrls.map((url, idx) => ({ url, name: `Imagem ${idx + 1}` }))
          } else {
            caminhoImgTelhado = vistoriaExistente.caminho_img_telhado
            telhadoImages = [{ url: vistoriaExistente.caminho_img_telhado, name: 'Imagem' }]
          }
        }
        if (vistoriaExistente.caminho_img_estrutura) {
          const estruturaUrls = typeof vistoriaExistente.caminho_img_estrutura === 'string' 
            ? JSON.parse(vistoriaExistente.caminho_img_estrutura) 
            : vistoriaExistente.caminho_img_estrutura
          if (Array.isArray(estruturaUrls)) {
            caminhoImgEstrutura = vistoriaExistente.caminho_img_estrutura
            estruturaImages = estruturaUrls.map((url, idx) => ({ url, name: `Imagem ${idx + 1}` }))
          } else {
            caminhoImgEstrutura = vistoriaExistente.caminho_img_estrutura
            estruturaImages = [{ url: vistoriaExistente.caminho_img_estrutura, name: 'Imagem' }]
          }
        }
      } catch (e) {
        console.warn('Erro ao parsear URLs de imagens:', e)
        if (vistoriaExistente.caminho_img_telhado) {
          caminhoImgTelhado = vistoriaExistente.caminho_img_telhado
          telhadoImages = [{ url: vistoriaExistente.caminho_img_telhado, name: 'Imagem' }]
        }
        if (vistoriaExistente.caminho_img_estrutura) {
          caminhoImgEstrutura = vistoriaExistente.caminho_img_estrutura
          estruturaImages = [{ url: vistoriaExistente.caminho_img_estrutura, name: 'Imagem' }]
        }
      }
      
      setFormBaixaDashboard({
        tipo_padrao_id: vistoriaExistente.tipo_padrao_id || '',
        ligacao_padrao: vistoriaExistente.ligacao_padrao || '',
        local_inversor: vistoriaExistente.local_inversor || '',
        posicao_poste_concessionaria: vistoriaExistente.posicao_poste_concessionaria || '',
        conexao_inversor: vistoriaExistente.conexao_inversor || '',
        local_aterramento_sistema: vistoriaExistente.local_aterramento_sistema || '',
        metragem_ca_inversor: vistoriaExistente.metragem_ca_inversor ? String(vistoriaExistente.metragem_ca_inversor) : '',
        metragem_cc: vistoriaExistente.metragem_cc ? String(vistoriaExistente.metragem_cc) : '',
        metragem_ca_padrao_fases: vistoriaExistente.metragem_ca_padrao_fases ? String(vistoriaExistente.metragem_ca_padrao_fases) : '',
        percurso_aterramento: vistoriaExistente.percurso_aterramento ? String(vistoriaExistente.percurso_aterramento) : '',
        qtd_conduletes_inversor: vistoriaExistente.qtd_conduletes_inversor ? String(vistoriaExistente.qtd_conduletes_inversor) : '',
        qtd_eletroduto_inversor: vistoriaExistente.qtd_eletroduto_inversor ? String(vistoriaExistente.qtd_eletroduto_inversor) : '',
        qtd_eletroduto_padrao: vistoriaExistente.qtd_eletroduto_padrao ? String(vistoriaExistente.qtd_eletroduto_padrao) : '',
        qtd_modulos_telhado: vistoriaExistente.qtd_modulos_telhado ? String(vistoriaExistente.qtd_modulos_telhado) : '',
        caminho_img_padrao: vistoriaExistente.caminho_img_padrao || '',
        caminho_img_inversor: vistoriaExistente.caminho_img_inversor || '',
        caminho_img_fachada: vistoriaExistente.caminho_img_fachada || '',
        caminho_img_mapa: vistoriaExistente.caminho_img_mapa || '',
        caminho_img_telhado: caminhoImgTelhado,
        caminho_img_quadro: vistoriaExistente.caminho_img_quadro || '',
        caminho_img_estrutura: caminhoImgEstrutura,
        caminho_img_croqui: vistoriaExistente.caminho_img_croqui || '',
        observacoes: vistoriaExistente.observacoes || '',
        data_vistoria: vistoriaExistente.data_vistoria || new Date().toISOString().split('T')[0],
        status: vistoriaExistente.status || 'Novo'
      })
      
      // Preencher imagens únicas
      const imageFilesObj = {}
      if (vistoriaExistente.caminho_img_padrao) {
        imageFilesObj.padrao = { url: vistoriaExistente.caminho_img_padrao, name: 'Padrão' }
      }
      if (vistoriaExistente.caminho_img_inversor) {
        imageFilesObj.inversor = { url: vistoriaExistente.caminho_img_inversor, name: 'Inversor' }
      }
      if (vistoriaExistente.caminho_img_fachada) {
        imageFilesObj.fachada = { url: vistoriaExistente.caminho_img_fachada, name: 'Fachada' }
      }
      if (vistoriaExistente.caminho_img_mapa) {
        imageFilesObj.mapa = { url: vistoriaExistente.caminho_img_mapa, name: 'Mapa' }
      }
      if (vistoriaExistente.caminho_img_quadro) {
        imageFilesObj.quadro = { url: vistoriaExistente.caminho_img_quadro, name: 'Quadro' }
      }
      setImageFilesDashboard(imageFilesObj)
      
      // Preencher múltiplas imagens
      setMultipleImageFilesDashboard({
        telhado: telhadoImages,
        estrutura: estruturaImages
      })
      
      // Armazenar ID da vistoria existente para UPDATE
      setVistoriaParaBaixaDashboard({
        ...vistoria,
        vistoria_id: vistoriaExistente.id
      })
    } else {
      // Formulário vazio para nova vistoria
      setFormBaixaDashboard({
        tipo_padrao_id: '',
        ligacao_padrao: '',
        local_inversor: '',
        posicao_poste_concessionaria: '',
        conexao_inversor: '',
        local_aterramento_sistema: '',
        metragem_ca_inversor: '',
        metragem_cc: '',
        metragem_ca_padrao_fases: '',
        percurso_aterramento: '',
        qtd_conduletes_inversor: '',
        qtd_eletroduto_inversor: '',
        qtd_eletroduto_padrao: '',
        qtd_modulos_telhado: '',
        caminho_img_padrao: '',
        caminho_img_inversor: '',
        caminho_img_fachada: '',
        caminho_img_mapa: '',
        caminho_img_telhado: '',
        caminho_img_quadro: '',
        caminho_img_estrutura: '',
        caminho_img_croqui: '',
        observacoes: '',
        data_vistoria: new Date().toISOString().split('T')[0],
        status: 'Novo'
      })
      setImageFilesDashboard({})
      setMultipleImageFilesDashboard({ telhado: [], estrutura: [] })
    }
    
    setUploadingImagesDashboard({})
    setShowBaixaModalDashboard(true)
  }
  
  // Fechar modal de baixa (no dashboard)
  const closeBaixaModalDashboard = () => {
    setShowBaixaModalDashboard(false)
    setVistoriaParaBaixaDashboard(null)
    setImageFilesDashboard({})
    setMultipleImageFilesDashboard({ telhado: [], estrutura: [] })
    setUploadingImagesDashboard({})
  }

  
  // Função para obter valor do padrão
  const getValorPadrao = (nomePadrao) => {
    switch (nomePadrao?.toLowerCase()) {
      case 'fachada':
        return 200
      case 'poste auxiliar':
        return 300
      case 'saga':
        return 400
      case 'fachada com ancoragem':
        return 200
      case 'não instalado':
        return 0
      default:
        return 0
    }
  }

  // Função para calcular valor baseado no Kwp
  const getValorKwp = (kwp) => {
    if (kwp >= 0 && kwp <= 4.5) {
      return 450
    } else if (kwp >= 4.6 && kwp <= 6.5) {
      return 380
    } else if (kwp >= 6.51 && kwp <= 10) {
      return 350
    } else if (kwp >= 10.01 && kwp <= 15) {
      return 320
    } else if (kwp > 15) {
      return 300
    }
    return 0
  }
  
  // Carregar dados de medição
  const loadMedicao = useCallback(async () => {
    setMedicaoLoading(true)
    try {
      // Buscar clientes do período especificado
      // Filtro de data ignorando horas/minutos/segundos - apenas dia/mês/ano
      const dataInicio = medicaoPeriodo.inicio // Formato: YYYY-MM-DD
      const dataFim = medicaoPeriodo.fim // Formato: YYYY-MM-DD
      
      // Construir query base
      let query = supabase
        .from('clientes')
        .select(`
          *,
          tipo_servico:tipo_servico(nome),
          tipo_padrao:tipo_padrao(nome),
          equipe:equipes(nome),
          status_info:status_clientes(status)
        `)
        .gte('data_instalacao', dataInicio)
        .lte('data_instalacao', dataFim)
      
      // Filtrar por empresa se o usuário não for administrador
      if (userRole !== USER_ROLES.ADMINISTRADOR && userEmpresa?.id) {
        query = query.eq('empresa_id', userEmpresa.id)
      }
      
      const { data: clientes, error: clientesError } = await query.order('data_instalacao', { ascending: false })

      if (clientesError) throw clientesError

      // Buscar valores de compras (total_fornecido) da tabela lista_material para cada cliente
      const valoresCompras = {}
      for (const cliente of clientes) {
        // Como os clientes já foram filtrados por empresa, podemos buscar as listas de material diretamente
        const { data: listasMaterial, error: listasError } = await supabase
          .from('lista_material')
          .select('total_fornecido')
          .eq('cliente_id', cliente.id)
        
        if (!listasError && listasMaterial) {
          // Somar todos os valores total_fornecido para este cliente
          const totalCompras = listasMaterial.reduce((sum, lista) => sum + (lista.total_fornecido || 0), 0)
          valoresCompras[cliente.id] = totalCompras
        } else {
          valoresCompras[cliente.id] = 0
        }
      }

      // Processar dados para medição
      const medicaoProcessada = clientes.map(cliente => {
        // Calcular Kwp
        const kwp = (cliente.quantidade_modulos || 0) * 0.610
        
        // Calcular valores baseados no tipo de medição
        const valorPadrao = getValorPadrao(cliente.tipo_padrao?.nome)
        const valorInversor = cliente.configuracao_inversor ? 100 : 0
        const valorDeslocamento = cliente.deslocamento_buscar_material ? 50 : 0
        const valorNotaMaterial = cliente.nota_material ? 0 : 0
        
        let valorBase = 0
        if (tipoMedicao === 'kwp') {
          valorBase = getValorKwp(kwp)
        } else {
          // Lógica original para módulos
          // Se o tipo de serviço for "Configuração", não incluir valor do inversor aqui
          const valorInversorParaBase = (cliente.tipo_servico?.nome === 'Configuração') ? 0 : valorInversor
          valorBase = (90 * (cliente.quantidade_modulos || 0)) + valorPadrao + valorInversorParaBase + valorDeslocamento + valorNotaMaterial
        }
        
        const valorObraCivil = cliente.valor_obra || 0
        const valorMaterial = cliente.valor_material || 0
        const valorCompras = valoresCompras[cliente.id] || 0
        
        // Calcular total incluindo compras
        // Se a obra for cancelada, o TOTAL é 400 + valor de compras
        let total
        if (cliente.obra_cancelada) {
          total = 400 + valorCompras
        } else if (tipoMedicao === 'kwp') {
          // Para Kwp: se tipo_servico for "Configuração", total é apenas 100
          if (cliente.tipo_servico?.nome === 'Configuração') {
            total = 100
          } else {
            // Lógica normal do Kwp (sem somar configuracao_inversor)
            total = (kwp * valorBase) + valorObraCivil + valorMaterial
          }
        } else {
          total = valorBase + valorObraCivil + valorMaterial + valorCompras
        }
        
        // Adicionar valor de configuração se o tipo de serviço for "Configuração" (apenas para módulos)
        if (tipoMedicao === 'modulos' && cliente.tipo_servico?.nome === 'Configuração') {
          total += 100
        }
        
        // Adicionar valor para "Placa de Geração" - R$ 50,00 + compras + valor material
        if (cliente.tipo_servico?.nome === 'Placa de Geração') {
          total = 50 + valorCompras + valorMaterial
        }

        // Lógica para tipo de serviço "retorno": Total = 400 + valor_material + valor_obra
        if (cliente.tipo_servico?.nome?.toLowerCase() === 'retorno') {
          total = 400 + valorMaterial + valorObraCivil
        }

        // Lógica para tipo de serviço "Retirada de paineis + Inversor": Total = (QTD_MÓDULOS × 45 + 350) + valor_material + valor_obra
        if (cliente.tipo_servico?.nome === 'Retirada de paineis + Inversor') {
          total = ((cliente.quantidade_modulos || 0) * 45 + 350) + valorMaterial + valorObraCivil
        }

        // Criar objeto com data corrigida
        const dataProcessada = cliente.data_instalacao ? new Date(cliente.data_instalacao + 'T00:00:00') : (cliente.data_cadastro ? new Date(cliente.data_cadastro + 'T00:00:00') : new Date())

        return {
          id: cliente.id,
          cliente: cliente.nome_cliente,
          data: dataProcessada,
          tipo_servico: cliente.tipo_servico?.nome || 'N/A',
          qtd_modulos: cliente.quantidade_modulos || 0,
          padrao: cliente.tipo_padrao?.nome || 'N/A',
          configuracao_inversor: cliente.configuracao_inversor ? 'Sim' : 'Não',
          deslocamento_buscar_material: cliente.deslocamento_buscar_material ? 'Sim' : 'Não',
          nota_material: cliente.nota_material ? 'Sim' : 'Não',
          obra_civil: cliente.obra_civil ? 'Sim' : 'Não',
          equipe: cliente.equipe?.nome || 'N/A',
          total: total,
          observacao: cliente.observacoes || '',
          // Campo para verificar se obra está cancelada
          obra_cancelada: cliente.obra_cancelada || false,
          // Valores para cálculos
          valor_padrao: valorPadrao,
          valor_inversor: valorInversor,
          valor_deslocamento: valorDeslocamento,
          valor_nota_material: valorNotaMaterial,
          valor_obra_civil: valorObraCivil,
          valor_compras: valorCompras,
          // Valores editáveis
          valor_obra: cliente.valor_obra || 0,
          valor_material: cliente.valor_material || 0
        }
      })

      setMedicaoData(medicaoProcessada)
    } catch (error) {
      console.error('Erro ao carregar dados de medição:', error)
    } finally {
      setMedicaoLoading(false)
    }
  }, [medicaoPeriodo, userRole, userEmpresa, tipoMedicao])
  
  // Carregar equipes
    const loadEquipes = useCallback(async () => {
    try {
      // Construir query base com JOIN para empresa e líder
      let query = supabase
        .from('equipes')
        .select(`
          *,
          empresa:empresa_id(id, empresa),
          lider:lider_equipe(id, nome, cargo),
          formulario_baixa:id_formularios_baixa(id, tipo)
        `)

      // Filtrar por empresa se o usuário não for administrador
      if (userRole !== USER_ROLES.ADMINISTRADOR && userEmpresa?.id) {
        query = query.eq('empresa_id', userEmpresa.id)
      }

      const { data, error } = await query.order('nome')

      if (error) throw error

      // Processar dados para incluir nome da empresa, líder e formulário de baixa
      const equipesProcessadas = data?.map(equipe => ({
        ...equipe,
        empresa_nome: equipe.empresa?.empresa || 'N/A',
        lider_nome: equipe.lider?.nome ? `${equipe.lider.nome} - ${equipe.lider.cargo}` : 'N/A',
        telefone_lider: equipe.telefone || 'N/A',
        formulario_baixa_nome: equipe.formulario_baixa?.tipo || 'N/A'
      })) || []

      setEquipes(equipesProcessadas)
    } catch (error) {
      console.error('Erro ao carregar equipes:', error)
      setEquipes([])
    }
  }, [userRole, userEmpresa])
  
     // Carregar tipos de serviço
   const loadTiposServico = useCallback(async () => {
     try {
       const { data, error } = await supabase
         .from('tipo_servico')
         .select('*')
         .eq('ativo', true)
         .order('nome')
       
       if (error) throw error
       setTiposServico(data || [])
     } catch (error) {
       console.error('Erro ao carregar tipos de serviço:', error)
     }
   }, [])
   
          // Carregar tipos de padrão
   const loadTiposPadrao = useCallback(async () => {
     try {
       const { data, error } = await supabase
         .from('tipo_padrao')
         .select('*')
         .eq('ativo', true)
         .order('nome')
       
       if (error) throw error
       setTiposPadrao(data || [])
     } catch (error) {
       console.error('Erro ao carregar tipos de padrão:', error)
     }
   }, [])
   
   // Carregar status dos clientes
     const loadStatusClientes = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('status_clientes')
        .select('*')
        .eq('ativo', true)
        .order('id')
      
      if (error) throw error
      
      setStatusClientes(data || [])
    } catch (error) {
      console.error('Erro ao carregar status dos clientes:', error)
      setStatusClientes([])
    }
  }, [])
  
  // Carregar usuários instaladores
  const loadUsuariosInstaladores = useCallback(async () => {
    try {
      // Construir query base usando usuarios_sistema
      let query = supabase
        .from('usuarios_sistema')
        .select('id, nome, role')
        .eq('status', 'ativo')
        .eq('role', 'instalador')
      
      // Filtrar por empresa se o usuário não for administrador
      if (userRole !== USER_ROLES.ADMINISTRADOR && userEmpresa?.id) {
        query = query.eq('empresa_id', userEmpresa.id)
      }
      
      const { data, error } = await query.order('nome')
      
      if (error) throw error
      setUsuariosInstaladores(data || [])
      console.log('✅ Usuários instaladores carregados:', data?.length || 0)
    } catch (error) {
      console.error('Erro ao carregar usuários instaladores:', error)
      setUsuariosInstaladores([])
    }
  }, [userRole, userEmpresa])
  
  // Carregar medição quando acessar a tela
  useEffect(() => {
    if (currentView === 'medicao' && userRole) {
      loadMedicao()
    }
  }, [currentView, userRole, loadMedicao])
  
  // Carregar responsáveis de um cliente
  const loadResponsaveisCliente = async (clienteId) => {
    try {
      const { data, error } = await supabase
        .from('clientes_usuarios')
        .select('usuario_sistema_id')
        .eq('cliente_id', clienteId)
        .eq('ativo', true)
      
      if (error) {
        console.error('❌ Erro na query de responsáveis:', error)
        throw error
      }
      
      // Retornar array de IDs dos responsáveis
      const responsaveisIds = data ? data.map(item => item.usuario_sistema_id) : []
      
      return responsaveisIds
    } catch (error) {
      console.error('❌ Erro ao carregar responsáveis do cliente:', error)
      return []
    }
  }

  // Função centralizada para salvar responsáveis (evita duplicação)
  const salvarResponsaveisCliente = async (clienteId, responsaveisIds) => {
    if (!clienteId || !responsaveisIds || responsaveisIds.length === 0) {
      console.log('⚠️ Nenhum responsável para salvar')
      return
    }

    try {
      console.log('🔄 Salvando responsáveis para cliente:', clienteId, 'Responsáveis:', responsaveisIds)
      
      // 1. DELETAR FISICAMENTE todas as relações existentes para este cliente
      const { error: deleteError } = await supabase
        .from('clientes_usuarios')
        .delete()
        .eq('cliente_id', clienteId)
      
      if (deleteError) {
        console.error('❌ Erro ao deletar relações existentes:', deleteError)
        throw deleteError
      }
      
      console.log('✅ Relações existentes deletadas fisicamente')
      
      // 2. Preparar dados para inserção
      const responsaveisData = responsaveisIds.map(usuarioSistemaId => ({
        cliente_id: clienteId,
        usuario_sistema_id: usuarioSistemaId,
        tipo_relacao: 'instalador',
        ativo: true
      }))
      
      // 3. Inserir novas relações
      const { data: insertData, error: responsaveisError } = await supabase
        .from('clientes_usuarios')
        .insert(responsaveisData)
        .select()
      
      if (responsaveisError) {
        console.error('❌ Erro ao salvar responsáveis:', responsaveisError)
        throw responsaveisError
      }
      
      console.log('✅ Responsáveis salvos com sucesso:', insertData)
      return insertData
      
    } catch (error) {
      console.error('❌ Erro geral ao salvar responsáveis:', error)
      throw error
    }
  }
  
  // Carregar clientes
  const loadClientes = useCallback(async () => {
    try {
      // VERIFICAÇÃO DE SEGURANÇA: Não executar se os estados não estiverem prontos
      if (!userRole) {
        return
      }
      
      if (userRole !== USER_ROLES.ADMINISTRADOR && !userEmpresa?.id) {
        return
      }
      
      let clientesData = []
      
      // Administrador ou administrativo privilegiado: filtra por múltiplas empresas (dropdown checklist)
      if (podeFiltrarEmpresaClientes) {
        let query = supabase
          .from('clientes')
          .select(`
            *,
            tipo_servico:tipo_servico(nome),
            tipo_padrao:tipo_padrao(nome),
            equipe:equipes(nome),
            status_info:status_clientes(status)
          `)
        
        // Se houver empresas selecionadas, filtrar por elas; caso contrário, todas as empresas
        if (empresasFiltroMultiClientes.length > 0) {
          query = query.in('empresa_id', empresasFiltroMultiClientes)
        }
        
        // Aplicar filtro de status
        if (statusFiltroClientes && statusFiltroClientes !== '') {
          query = query.eq('id_status', statusFiltroClientes)
        }
        
        const { data, error } = await query.order('created_at', { ascending: false })
        
        if (error) throw error
        clientesData = data || []
      } else {
        // Para não-administradores, buscar clientes da empresa e também com permissão
        if (userEmpresa?.id) {
          // 1. Buscar clientes da empresa do usuário
          let query = supabase
            .from('clientes')
            .select(`
              *,
              tipo_servico:tipo_servico(nome),
              tipo_padrao:tipo_padrao(nome),
              equipe:equipes(nome),
              status_info:status_clientes(status)
            `)
            .eq('empresa_id', userEmpresa.id)
          
          // Aplicar filtro de status
          if (statusFiltroClientes && statusFiltroClientes !== '') {
            query = query.eq('id_status', statusFiltroClientes)
          }
          
          const { data: clientesEmpresa, error: errorEmpresa } = await query.order('created_at', { ascending: false })
          
          if (errorEmpresa) throw errorEmpresa
          const clientesEmpresaList = clientesEmpresa || []
          console.log('📋 Clientes da empresa do usuário (Instalações Realizadas):', clientesEmpresaList.length)
          
          // 2. Buscar permissões de instalações autorizadas
          const { data: permissoes, error: errorPermissoes } = await supabase
            .from('permissoes_instalacoes')
            .select('instalacao_id')
            .eq('empresa_autorizada_id', userEmpresa.id)
          
          if (errorPermissoes) {
            console.error('❌ Erro ao buscar permissões:', errorPermissoes)
            // Não lançar erro, apenas continuar sem permissões adicionais
          }
          
          const instalacaoIdsPermitidos = (permissoes || []).map(p => p.instalacao_id)
          console.log('🔐 Instalações autorizadas encontradas (Instalações Realizadas):', instalacaoIdsPermitidos.length)
          
          // 3. Buscar clientes das instalações autorizadas (que não sejam da própria empresa)
          if (instalacaoIdsPermitidos.length > 0) {
            let queryPermitidos = supabase
              .from('clientes')
              .select(`
                *,
                tipo_servico:tipo_servico(nome),
                tipo_padrao:tipo_padrao(nome),
                equipe:equipes(nome),
                status_info:status_clientes(status)
              `)
              .in('id_cliente_cadastro', instalacaoIdsPermitidos)
              .neq('empresa_id', userEmpresa.id) // Excluir clientes da própria empresa (já estão em clientesEmpresaList)
            
            // Aplicar filtro de status também nas permissões
            if (statusFiltroClientes && statusFiltroClientes !== '') {
              queryPermitidos = queryPermitidos.eq('id_status', statusFiltroClientes)
            }
            
            const { data: clientesPermitidos, error: errorPermitidos } = await queryPermitidos.order('created_at', { ascending: false })
            
            if (errorPermitidos) {
              console.error('❌ Erro ao buscar clientes permitidos:', errorPermitidos)
              // Em caso de erro, usar apenas clientes da empresa
              clientesData = clientesEmpresaList
            } else {
              const clientesPermitidosList = clientesPermitidos || []
              console.log('📋 Clientes permitidos encontrados (Instalações Realizadas):', clientesPermitidosList.length)
              
              // 4. Combinar clientes (usar Map para evitar duplicatas)
              const clientesMap = new Map()
              clientesEmpresaList.forEach(cliente => {
                clientesMap.set(cliente.id, cliente)
              })
              clientesPermitidosList.forEach(cliente => {
                clientesMap.set(cliente.id, cliente)
              })
              
              // Converter para array e ordenar por data
              clientesData = Array.from(clientesMap.values()).sort((a, b) => {
                const dateA = new Date(a.created_at || 0)
                const dateB = new Date(b.created_at || 0)
                return dateB - dateA // Ordem decrescente (mais recente primeiro)
              })
            }
          } else {
            clientesData = clientesEmpresaList
          }
          
          console.log('📋 Total de clientes encontrados (Instalações Realizadas, com permissões):', clientesData.length)
        }
      }
      
      // Definir os clientes com os dados processados
      setClientes(clientesData || [])
    } catch (error) {
      console.error('Erro ao carregar clientes:', error)
      setClientes([])
    }
  }, [userRole, userEmpresa, statusFiltroClientes, podeFiltrarEmpresaClientes, empresasFiltroMultiClientes])

  
  // Carregar presenças
  const loadPresencas = useCallback(async () => {
    try {
      console.log('🔍 Carregando presenças...', { userRole, userEmpresa: userEmpresa?.id })

      // Se for administrador, carregar todas as presenças
      if (userRole === 'administrador') {
        console.log('👑 Usuário é administrador - carregando todas as presenças')
        
        // Primeiro buscar todas as presenças sem JOINs obrigatórios
        const { data, error } = await supabase
          .from('presenca')
          .select('*')
          .order('data_presenca', { ascending: false })

        if (error) throw error

        // Se não retornou dados, retornar vazio
        if (!data || data.length === 0) {
          setPresencas([])
          console.log('⚠️ Nenhuma presença encontrada')
          return
        }

        // Buscar clientes e ordens de serviço separadamente (LEFT JOIN)
        const clienteIds = data.filter(p => p.cliente_id).map(p => p.cliente_id)
        const ordemIds = data.filter(p => p.id_os).map(p => p.id_os)
        const equipeIds = data.filter(p => p.equipe_id).map(p => p.equipe_id)
        const veiculoIds = data.filter(p => p.veiculo_id).map(p => p.veiculo_id)

        // Buscar clientes (LEFT JOIN)
        const { data: clientes } = await supabase
          .from('clientes')
          .select('id, nome_cliente')
          .in('id', clienteIds)

        // Buscar ordens de serviço com clientes_cadastro (LEFT JOIN)
        const { data: ordensServicos } = ordemIds.length > 0 ? await supabase
          .from('ordens_servicos')
          .select(`
            id,
            id_cliente,
            cliente_cadastro:clientes_cadastro!id_cliente(
              nome_completo
            )
          `)
          .in('id', ordemIds) : { data: [] }

        // Buscar equipes (LEFT JOIN)
        const { data: equipes } = equipeIds.length > 0 ? await supabase
          .from('equipes')
          .select('id, nome, empresa_id')
          .in('id', equipeIds) : { data: [] }

        // Buscar veículos (LEFT JOIN)
        const { data: veiculos } = veiculoIds.length > 0 ? await supabase
          .from('veiculos')
          .select('id, veiculo, placa')
          .in('id', veiculoIds) : { data: [] }

        // Buscar colaboradores das presenças
        const presencaIds = data.map(p => p.id)
        const { data: presencaColaboradores } = presencaIds.length > 0 ? await supabase
          .from('presenca_colaboradores')
          .select('presenca_id, colaborador_id, colaborador:colaborador_id(id, nome, cargo, empresa_id)')
          .in('presenca_id', presencaIds) : { data: [] }

        // Processar dados das presenças com LEFT JOINs
        const presencasProcessadas = data.map(presenca => {
          // LEFT JOIN com clientes (via cliente_id)
          let cliente = null
          if (presenca.cliente_id) {
            cliente = clientes?.find(c => c.id === presenca.cliente_id)
          }

          // LEFT JOIN com ordens_servicos (via id_os)
          let ordemServico = null
          if (presenca.id_os) {
            ordemServico = ordensServicos?.find(os => os.id === presenca.id_os)
          }

          // LEFT JOIN com equipes
          let equipe = null
          if (presenca.equipe_id) {
            equipe = equipes?.find(e => e.id === presenca.equipe_id)
          }

          // LEFT JOIN com veículos
          let veiculo = null
          if (presenca.veiculo_id) {
            veiculo = veiculos?.find(v => v.id === presenca.veiculo_id)
          }

          // LEFT JOIN com colaboradores
          const colaboradoresPresenca = presencaColaboradores?.filter(pc => pc.presenca_id === presenca.id) || []
          const colaboradoresIds = colaboradoresPresenca.map(pc => pc.colaborador_id)

          // Prioridade: cliente direto da presença (dados antigos) > cliente da ordem de serviço (dados novos)
          let nomeCliente = 'Cliente não encontrado'
          if (cliente?.nome_cliente) {
            nomeCliente = cliente.nome_cliente
          } else if (ordemServico?.cliente_cadastro?.nome_completo) {
            nomeCliente = ordemServico.cliente_cadastro.nome_completo
          }

          return {
            ...presenca,
            cliente: {
              nome_cliente: nomeCliente
            },
            ordem_servico: ordemServico ? {
              id: ordemServico.id,
              cliente_cadastro: ordemServico.cliente_cadastro
            } : null,
            equipe: equipe,
            veiculo: veiculo,
            colaboradores: colaboradoresIds,
            presenca_colaboradores: colaboradoresPresenca.map(pc => ({
              colaborador_id: pc.colaborador_id,
              colaborador: pc.colaborador
            }))
          }
        })

        setPresencas(presencasProcessadas)
        console.log('✅ Presenças carregadas (admin):', presencasProcessadas.length)
        return
      }

      // Para usuários não-administradores, filtrar por empresa
      if (!userEmpresa?.id) {
        console.log('❌ Usuário não tem empresa definida')
        setPresencas([])
        return
      }

      console.log('🏢 Filtrando presenças por empresa:', userEmpresa.id)
      console.log('👤 Usuário logado:', userId)

      // Primeiro, buscar o colaborador associado ao usuário logado
      let colaboradorUsuarioId = null
      if (userId) {
        const { data: colaboradorUsuario, error: errorColabUsuario } = await supabase
          .from('colaboradores')
          .select('id')
          .eq('user_id', userId)
          .eq('ativo', true)
          .maybeSingle()

        if (errorColabUsuario) {
          console.warn('⚠️ Erro ao buscar colaborador do usuário:', errorColabUsuario)
        } else if (colaboradorUsuario) {
          colaboradorUsuarioId = colaboradorUsuario.id
          console.log('✅ Colaborador do usuário encontrado:', colaboradorUsuarioId)
        } else {
          console.log('ℹ️ Usuário não possui colaborador associado, filtrando por empresa')
        }
      }

      // Buscar colaboradores da empresa
      const { data: colaboradoresEmpresa, error: errorColaboradores } = await supabase
        .from('colaboradores')
        .select('id')
        .eq('empresa_id', userEmpresa.id)
        .eq('ativo', true)

      if (errorColaboradores) {
        console.error('❌ Erro ao carregar colaboradores da empresa:', errorColaboradores)
        setPresencas([])
        return
      }

      // Se o usuário tem um colaborador associado, filtrar apenas por ele
      // Caso contrário, filtrar por todos os colaboradores da empresa
      let colaboradoresIds = []
      if (colaboradorUsuarioId) {
        // Verificar se o colaborador do usuário pertence à empresa
        const colaboradorNaEmpresa = colaboradoresEmpresa?.find(c => c.id === colaboradorUsuarioId)
        if (colaboradorNaEmpresa) {
          colaboradoresIds = [colaboradorUsuarioId]
          console.log('👤 Filtrando presenças apenas do colaborador do usuário logado:', colaboradorUsuarioId)
        } else {
          console.log('⚠️ Colaborador do usuário não pertence à empresa, filtrando por empresa')
          colaboradoresIds = colaboradoresEmpresa?.map(c => c.id) || []
        }
      } else {
        colaboradoresIds = colaboradoresEmpresa?.map(c => c.id) || []
        console.log('👥 Colaboradores da empresa encontrados:', colaboradoresIds.length, colaboradoresIds)
      }

      if (colaboradoresIds.length === 0) {
        console.log('⚠️ Nenhum colaborador encontrado para a empresa')
        setPresencas([])
        return
      }

      // Buscar presenças que tenham colaboradores da empresa (usando INNER JOIN apenas para colaboradores)
      // Primeiro buscar IDs das presenças que têm os colaboradores da empresa
      const { data: presencaColaboradoresFiltrados, error: errorPresencaColab } = await supabase
        .from('presenca_colaboradores')
        .select('presenca_id')
        .in('colaborador_id', colaboradoresIds)
        .eq('presente', true)

      if (errorPresencaColab) {
        console.error('❌ Erro ao buscar presenças por colaboradores:', errorPresencaColab)
        setPresencas([])
        return
      }

      const presencaIdsFiltrados = [...new Set(presencaColaboradoresFiltrados?.map(pc => pc.presenca_id) || [])]
      
      if (presencaIdsFiltrados.length === 0) {
        console.log('⚠️ Nenhuma presença encontrada para os colaboradores da empresa')
        setPresencas([])
        return
      }

      // Agora buscar todas as presenças (LEFT JOINs)
      const { data, error } = await supabase
        .from('presenca')
        .select('*')
        .in('id', presencaIdsFiltrados)
        .order('data_presenca', { ascending: false })

      if (error) {
        console.error('❌ Erro ao carregar presenças:', error)
        throw error
      }

      // Se não retornou dados, retornar vazio
      if (!data || data.length === 0) {
        setPresencas([])
        console.log('⚠️ Nenhuma presença encontrada')
        return
      }

      // Buscar relacionamentos separadamente (LEFT JOINs)
      const clienteIds = data.filter(p => p.cliente_id).map(p => p.cliente_id)
      const ordemIds = data.filter(p => p.id_os).map(p => p.id_os)
      const equipeIds = data.filter(p => p.equipe_id).map(p => p.equipe_id)
      const veiculoIds = data.filter(p => p.veiculo_id).map(p => p.veiculo_id)

      // Buscar clientes (LEFT JOIN)
      const { data: clientes } = clienteIds.length > 0 ? await supabase
        .from('clientes')
        .select('id, nome_cliente')
        .in('id', clienteIds) : { data: [] }

      // Buscar ordens de serviço com clientes_cadastro (LEFT JOIN)
      const { data: ordensServicos } = ordemIds.length > 0 ? await supabase
        .from('ordens_servicos')
        .select(`
          id,
          id_cliente,
          cliente_cadastro:clientes_cadastro!id_cliente(
            nome_completo
          )
        `)
        .in('id', ordemIds) : { data: [] }

      // Buscar equipes (LEFT JOIN)
      const { data: equipes } = equipeIds.length > 0 ? await supabase
        .from('equipes')
        .select('id, nome, empresa_id')
        .in('id', equipeIds) : { data: [] }

      // Buscar veículos (LEFT JOIN)
      const { data: veiculos } = veiculoIds.length > 0 ? await supabase
        .from('veiculos')
        .select('id, veiculo, placa')
        .in('id', veiculoIds) : { data: [] }

      // Buscar colaboradores das presenças
      const presencaIds = data.map(p => p.id)
      const { data: presencaColaboradores } = presencaIds.length > 0 ? await supabase
        .from('presenca_colaboradores')
        .select('presenca_id, colaborador_id, colaborador:colaborador_id(id, nome, cargo, empresa_id)')
        .in('presenca_id', presencaIds) : { data: [] }

      // Processar dados das presenças com LEFT JOINs
      const presencasProcessadas = data.map(presenca => {
        // LEFT JOIN com clientes (via cliente_id)
        let cliente = null
        if (presenca.cliente_id) {
          cliente = clientes?.find(c => c.id === presenca.cliente_id)
        }

        // LEFT JOIN com ordens_servicos (via id_os)
        let ordemServico = null
        if (presenca.id_os) {
          ordemServico = ordensServicos?.find(os => os.id === presenca.id_os)
        }

        // LEFT JOIN com equipes
        let equipe = null
        if (presenca.equipe_id) {
          equipe = equipes?.find(e => e.id === presenca.equipe_id)
        }

        // LEFT JOIN com veículos
        let veiculo = null
        if (presenca.veiculo_id) {
          veiculo = veiculos?.find(v => v.id === presenca.veiculo_id)
        }

        // LEFT JOIN com colaboradores
        const colaboradoresPresenca = presencaColaboradores?.filter(pc => pc.presenca_id === presenca.id) || []
        const colaboradoresIds = colaboradoresPresenca.map(pc => pc.colaborador_id)

        // Prioridade: cliente direto da presença (dados antigos) > cliente da ordem de serviço (dados novos)
        let nomeCliente = 'Cliente não encontrado'
        if (cliente?.nome_cliente) {
          nomeCliente = cliente.nome_cliente
        } else if (ordemServico?.cliente_cadastro?.nome_completo) {
          nomeCliente = ordemServico.cliente_cadastro.nome_completo
        }

        return {
          ...presenca,
          cliente: {
            nome_cliente: nomeCliente
          },
          ordem_servico: ordemServico ? {
            id: ordemServico.id,
            cliente_cadastro: ordemServico.cliente_cadastro
          } : null,
          equipe: equipe,
          veiculo: veiculo,
          colaboradores: colaboradoresIds,
          presenca_colaboradores: colaboradoresPresenca.map(pc => ({
            colaborador_id: pc.colaborador_id,
            colaborador: pc.colaborador
          }))
        }
      })

      setPresencas(presencasProcessadas)
      console.log('✅ Presenças carregadas (filtradas):', presencasProcessadas.length)

    } catch (error) {
      console.error('❌ Erro ao carregar presenças:', error)
      setPresencas([])
    }
  }, [userRole, userEmpresa, userId])

  // Carregar presenças quando usuário e empresa estiverem definidos
  useEffect(() => {
    if (userRole && userEmpresa?.id && !isLoading) {
      loadPresencas()
    }
  }, [userRole, userEmpresa?.id, isLoading, loadPresencas])

  const loadColaboradores = useCallback(async () => {
    try {
      
      // Construir query base
      let query = supabase
        .from('colaboradores')
        .select('*')
      
      // Filtrar por empresa se o usuário não for administrador
      if (userRole !== USER_ROLES.ADMINISTRADOR && userEmpresa?.id) {
        query = query.eq('empresa_id', userEmpresa.id)
      }
      
      const { data, error } = await query.order('nome', { ascending: true })
      
      if (error) {
        console.error('❌ Erro ao carregar colaboradores:', error)
        throw error
      }
      
      setColaboradores(data || [])
    } catch (error) {
      console.error('❌ Erro ao carregar colaboradores:', error)
      setColaboradores([])
    }
  }, [userRole, userEmpresa])
  // Carregar usuários
  const loadUsuarios = useCallback(async () => {
    try {
      // Construir query base com colunas específicas para evitar ambiguidade
      let query = supabase
        .from('usuarios_sistema')
        .select(`
          id,
          nome,
          email,
          telefone,
          role,
          status,
          empresa_id,
          multiempresas,
          chat_zap,
          whatsapp_gestor,
          whatsapp_proposta,
          whatsapp_template_id,
          whatsapp_template_nome,
          whatsapp_template_language,
          primeiro_acesso,
          created_at,
          updated_at
        `)
      
      // Filtrar por empresa se o usuário não for administrador
      if (userRole !== USER_ROLES.ADMINISTRADOR && userEmpresa?.id) {
        query = query.eq('empresa_id', userEmpresa.id)
      }
      
      const { data, error } = await query.order('nome', { ascending: true })
      
      if (error) throw error
      setUsuarios(data || [])
    } catch (error) {
      console.error('Erro ao carregar usuários:', error)
      setUsuarios([])
    }
  }, [userRole, userEmpresa])

  // Carregar empresas para o dropdown de usuários
  const loadEmpresas = useCallback(async () => {
    // Evitar recarregar se já temos empresas carregadas
    if (empresasLoaded) {
      return
    }
    
    try {
      setLoadingEmpresas(true)
      const { data, error } = await supabase
        .from('empresa')
        .select('id, empresa')
        .order('empresa')
      
      if (error) throw error
      setEmpresas(data || [])
      setEmpresasLoaded(true)
    } catch (error) {
      console.error('Erro ao carregar empresas:', error)
      setEmpresas([])
    } finally {
      setLoadingEmpresas(false)
    }
  }, [empresasLoaded])

  // Carregar cargos
  const loadCargos = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('cargos')
        .select('*')
        .order('cargo', { ascending: true })
      
      if (error) throw error
      setCargos(data || [])
    } catch (error) {
      console.error('Erro ao carregar cargos:', error)
      setCargos([])
    }
  }, [])

  // Carregar tipos de pagamento
  const loadTiposPagamento = useCallback(async () => {
    // Evitar recarregar se já temos tipos carregados
    if (tiposPagamentoLoaded) {
      return
    }
    
    try {
      setLoadingTiposPagamento(true)
      const { data, error } = await supabase
        .from('tipos_pagamentos')
        .select('id, tipo_pagamento')
        .order('tipo_pagamento')
      
      if (error) throw error
      setTiposPagamento(data || [])
      setTiposPagamentoLoaded(true)
    } catch (error) {
      console.error('Erro ao carregar tipos de pagamento:', error)
      setTiposPagamento([])
    } finally {
      setLoadingTiposPagamento(false)
    }
  }, [tiposPagamentoLoaded])

  // Carregar dados de pagamento de colaboradores
  const loadPagamentoColaboradores = useCallback(async () => {
    if (!filtrosPagamento.dataInicio || !filtrosPagamento.dataFim) {
      showNotification('Selecione as datas de início e fim para gerar o relatório.', 'warning')
      return
    }

    try {
      setLoadingPagamento(true)
      
      // Consulta para buscar presenças e calcular pagamentos
      const { data, error } = await supabase
        .from('colaboradores')
        .select(`
          id,
          nome,
          cargo,
          valor_pagamento,
          tipos_pagamentos!inner(
            id,
            tipo_pagamento
          ),
          presenca_colaboradores!inner(
            presente,
            presenca!inner(
              data_presenca
            )
          )
        `)
        .eq('ativo', true)
        .eq('presenca_colaboradores.presente', true)
        .gte('presenca.data_presenca', filtrosPagamento.dataInicio)
        .lte('presenca.data_presenca', filtrosPagamento.dataFim)

      if (error) throw error

      // Processar dados e calcular valores
      const pagamentosProcessados = {}
      
      data?.forEach(item => {
        const colaboradorId = item.id
        const colaboradorNome = item.nome
        const cargo = item.cargo
        const valorBase = parseFloat(item.valor_pagamento) || 0
        const tipoPagamento = item.tipos_pagamentos.tipo_pagamento
        
        if (!pagamentosProcessados[colaboradorId]) {
          pagamentosProcessados[colaboradorId] = {
            id: colaboradorId,
            nome: colaboradorNome,
            cargo: cargo,
            tipo_pagamento: tipoPagamento,
            valor_base: valorBase,
            dias_presentes: 0,
            total_pagamento: 0,
            detalhes: []
          }
        }

        // Calcular valor do dia baseado no tipo de pagamento
        let valorDia = 0
        switch (tipoPagamento) {
          case 'Avulso':
          case 'Diaria':
            valorDia = valorBase
            break
          case 'Quinzenal':
            valorDia = valorBase / 15
            break
          case 'Mensal':
            valorDia = valorBase / 30
            break
          default:
            valorDia = 0
        }

        // Adicionar detalhe do dia
        const dataPresenca = item.presenca_colaboradores.presenca.data_presenca
        pagamentosProcessados[colaboradorId].detalhes.push({
          data: dataPresenca,
          valor_dia: valorDia
        })

        // Atualizar totais
        pagamentosProcessados[colaboradorId].dias_presentes += 1
        pagamentosProcessados[colaboradorId].total_pagamento += valorDia
      })

      // Converter para array e ordenar
      const resultado = Object.values(pagamentosProcessados).sort((a, b) => a.nome.localeCompare(b.nome))
      
      setPagamentoData(resultado)
      
      if (resultado.length === 0) {
        showNotification('Nenhum colaborador encontrado com presenças no período selecionado.', 'info')
      } else {
        showNotification(`Relatório gerado com ${resultado.length} colaborador(es).`, 'success')
      }
    } catch (error) {
      console.error('Erro ao carregar pagamentos:', error)
      showNotification('Erro ao carregar dados de pagamento: ' + error.message, 'error')
    } finally {
      setLoadingPagamento(false)
    }
  }, [filtrosPagamento, showNotification])

  // Carregar veículos
  const loadVeiculos = useCallback(async () => {
    try {
          // Logs removidos para limpeza do console
      
      // Construir query base
      let query = supabase
        .from('veiculos')
        .select('*')
      
      // Filtrar pela empresa do usuário logado (todos os perfis, inclusive administrador)
      if (userEmpresa?.id) {
        query = query.eq('empresa_id', userEmpresa.id)
      }
      
      const { data, error } = await query.order('veiculo', { ascending: true })
      
      if (error) throw error
      
      // Logs removidos para limpeza do console
      
      setVeiculos(data || [])
      setCarros(data || []) // Também atualiza o estado de carros
    } catch (error) {
      console.error('Erro ao carregar veículos:', error)
      setVeiculos([])
      setCarros([])
    }
  }, [userRole, userEmpresa])
  
  // Alias para carregar carros (usa a mesma função de veículos)
  // const loadCarros = useCallback(async () => {
  //   await loadVeiculos()
  // }, [loadVeiculos])
  
  // Aplicar filtros aos clientes
  const aplicarFiltrosClientes = useCallback(() => {
    let filtrados = [...clientes]
    
    // Para instaladores, filtrar apenas por status específicos
    if (userRole === 'instalador') {
      filtrados = filtrados.filter(cliente =>
        ['Pendente', 'Em andamento'].includes(cliente.status_info?.status)
      )
    }
    
    if (filtrosCliente.nome_cliente) {
      // Normaliza removendo acentos e ignorando maiúsculas/minúsculas
      const normalizarTexto = (texto) =>
        (texto || '')
          .toString()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()

      const termoBusca = normalizarTexto(filtrosCliente.nome_cliente)
      filtrados = filtrados.filter(cliente =>
        normalizarTexto(cliente.nome_cliente).includes(termoBusca)
      )
    }
    
    if (filtrosCliente.dataInicio) {
      filtrados = filtrados.filter(cliente => {
        if (!cliente.data_instalacao) return false
        // Converter para Date e comparar apenas dia/mês/ano
        const dataCliente = new Date(cliente.data_instalacao)
        const dataInicio = new Date(filtrosCliente.dataInicio + 'T00:00:00')
        return dataCliente >= dataInicio
      })
    }
    
    if (filtrosCliente.dataFim) {
      filtrados = filtrados.filter(cliente => {
        if (!cliente.data_instalacao) return false
        // Converter para Date e comparar apenas dia/mês/ano
        const dataCliente = new Date(cliente.data_instalacao)
        const dataFim = new Date(filtrosCliente.dataFim + 'T23:59:59')
        return dataCliente <= dataFim
      })
    }
    
    if (filtrosCliente.tipoServicoId) {
      filtrados = filtrados.filter(cliente =>
        cliente.tipo_servico_id === filtrosCliente.tipoServicoId
      )
    }
    
    return filtrados
  }, [clientes, filtrosCliente, userRole])
  
  // Clientes filtrados
  const clientesFiltrados = useMemo(() => aplicarFiltrosClientes(), [aplicarFiltrosClientes])
  
  // Abrir formulário de novo cliente
  const openNewClienteForm = () => {
    setEditingCliente(null)
    setObservacoesFormularioBaixa([]) // Limpar observações ao abrir novo formulário
    setClienteFormData({
      nome_cliente: '',
      endereco: '',
      telefone: '',
      data_instalacao: '',
      tipo_servico_id: '',
      tipo_padrao_id: '',
      id_profiles: [],
      equipe_id: '',
      data_cadastro: new Date().toISOString().split('T')[0],
      quantidade_modulos: 0,
      deslocamento: '',
      deslocamento_buscar_material: false,
      configuracao_inversor: false,
      obra_civil: false,
      obra_cancelada: false,
      nota_material: false,
      observacoes: '',
      id_status: 1, // Status padrão: Pendente (ID 1)
      empresa_id: userEmpresa?.id || null // Definir empresa_id baseado no usuário logado
    })
    setShowClienteForm(true)
  }
  
  // Fechar formulário de cliente
  const closeClienteForm = () => {
    // Se o modal não pode ser fechado (finalização obrigatória), não permitir fechar
    if (clienteModalNaoFechavel) {
      showNotification('Você deve finalizar a obra antes de fechar este modal.', 'warning')
      return
    }
    
    setShowClienteForm(false)
    setEditingCliente(null)
    setObservacoesFormularioBaixa([]) // Limpar observações ao fechar formulário
    setClienteFormData({
      nome_cliente: '',
      endereco: '',
      telefone: '',
      data_instalacao: '',
      tipo_servico_id: '',
      tipo_padrao_id: '',
      id_profiles: [],
      equipe_id: '',
      data_cadastro: new Date().toISOString().split('T')[0],
      quantidade_modulos: 0,
      deslocamento: '',
      deslocamento_buscar_material: false,
      configuracao_inversor: false,
      obra_civil: false,
      obra_cancelada: false,
      nota_material: false,
      observacoes: '',
      id_status: 1, // Status padrão: Pendente (ID 1)
      empresa_id: null
    })
  }

  // Funções para gerenciar PDFs dos clientes
  const openClientePDFs = (cliente) => {
    setClientePDFsData({
      id: cliente.id,
      id_cliente_cadastro: cliente.id_cliente_cadastro,
      nome: cliente.nome_cliente
    })
    setShowClientePDFs(true)
  }

  // Funções para gerenciar fotos dos clientes
  const openClienteFotos = async (cliente) => {
    // O formularios_baixa_resolve.cliente_id referencia clientes_cadastro(id)
    // Se o cliente tem id_cliente_cadastro, usar esse; caso contrário, usar o id (assumindo que é de clientes_cadastro)
    const clienteIdParaBuscar = cliente.id_cliente_cadastro || cliente.id
    
    console.log('📸 Abrindo modal de fotos para cliente:', {
      id: cliente.id,
      id_cliente_cadastro: cliente.id_cliente_cadastro,
      nome: cliente.nome_cliente,
      clienteIdParaBuscar: clienteIdParaBuscar
    })
    
    setClienteFotosData({
      id: cliente.id,
      id_cliente_cadastro: cliente.id_cliente_cadastro,
      nome: cliente.nome_cliente
    })
    setShowClienteFotos(true)
    await loadClienteFotos(clienteIdParaBuscar)
  }

  const closeClientePDFs = () => {
    setShowClientePDFs(false)
    setClientePDFsData(null)
  }

  // Carregar fotos do cliente da tabela formularios_baixa_resolve
  const loadClienteFotos = async (clienteId) => {
    try {
      setLoadingFotos(true)
      console.log('🔍 Carregando fotos para cliente (cliente_id):', clienteId)
      
      if (!clienteId) {
        console.warn('⚠️ clienteId é null ou undefined')
        setClienteFotos([])
        setLoadingFotos(false)
        return
      }
      
      // Carregar formulários da tabela formularios_baixa_resolve
      // cliente_id referencia clientes_cadastro(id)
      const { data: formulariosData, error } = await supabase
        .from('formularios_baixa_resolve')
        .select(`
          id,
          cliente_id,
          tipo_formulario,
          tipo_fase,
          fotos,
          created_at,
          updated_at
        `)
        .eq('cliente_id', clienteId)
        .order('created_at', { ascending: false })

      console.log('📊 Dados retornados da consulta:', formulariosData)
      console.log('❌ Erro da consulta:', error)

      if (error) {
        console.error('Erro ao carregar formulários:', error)
        showNotification(`Erro ao carregar fotos: ${error.message}`, 'error')
        return
      }

      if (!formulariosData || formulariosData.length === 0) {
        console.log('⚠️ Nenhum formulário encontrado para o cliente')
        setClienteFotos([])
        return
      }

      // Processar fotos do campo JSONB
      const todasFotos = []
      
      formulariosData.forEach((formulario, formIndex) => {
        console.log(`📋 Processando formulário ${formIndex + 1}:`, formulario)
        
        if (!formulario.fotos) {
          console.log('  - Campo fotos está vazio ou não existe')
          return
        }

        // Parsear fotos se for uma string JSON
        let fotosParsed = formulario.fotos
        if (typeof formulario.fotos === 'string') {
          try {
            fotosParsed = JSON.parse(formulario.fotos)
            console.log('  - Campo fotos parseado de string JSON:', fotosParsed)
          } catch (parseError) {
            console.warn('  - Erro ao parsear JSON de fotos:', parseError)
            return // Pular este formulário se não conseguir parsear
          }
        }
        
        // Função para processar uma URL de foto (formularioId para edição admin; customName = título quando item é { url, titulo })
        const processarFoto = (url, nomeBase, formularioId, indice = null, customName = null) => {
          if (!url || typeof url !== 'string' || !url.includes('http')) {
            return null
          }
          
          // Criar nome amigável baseado na chave
          const nomeAmigavel = {
            'strings': 'Strings',
            'foto_strings': 'Strings',
            'fase1_terra': 'Fase 1 - Terra',
            'foto_fase1_terra_qpca': 'Fase 1 - Terra QPCA',
            'fase2_terra': 'Fase 2 - Terra',
            'foto_fase2_terra_qpca': 'Fase 2 - Terra QPCA',
            'foto_fase3_terra_qpca': 'Fase 3 - Terra QPCA',
            'qpca_aberto': 'QPCA Aberto',
            'foto_qpca': 'QPCA',
            'fase1_neutro': 'Fase 1 - Neutro',
            'foto_fase1_neutro': 'Fase 1 - Neutro',
            'neutro_terra': 'Neutro - Terra',
            'foto_terra_neutro': 'Terra - Neutro',
            'foto_fase1_fase2': 'Fase 1 - Fase 2',
            'foto_fase1_fase2_qpca': 'Fase 1 - Fase 2 QPCA',
            'foto_fase2_neutro': 'Fase 2 - Neutro',
            'foto_fase2_fase3': 'Fase 2 - Fase 3',
            'foto_fase2_fase3_qpca': 'Fase 2 - Fase 3 QPCA',
            'foto_fase3_fase1': 'Fase 3 - Fase 1',
            'foto_fase3_fase1_qpca': 'Fase 3 - Fase 1 QPCA',
            'foto_fase3_neutro': 'Fase 3 - Neutro',
            'disjuntor_qpca': 'Disjuntor QPCA',
            'foto_disjuntor_qpca': 'Disjuntor QPCA',
            'fachada_cliente': 'Fachada do Cliente',
            'foto_fachada': 'Fachada',
            'medicao_strings': 'Medição Strings',
            'foto_medicoes_strings': 'Medições Strings',
            'padrao_completo': 'Padrão Completo',
            'foto_padrao_completo': 'Padrão Completo',
            'aterramento_qpca': 'Aterramento QPCA',
            'foto_aterramento_qpca': 'Aterramento QPCA',
            'disjuntor_padrao': 'Disjuntor Padrão',
            'foto_disjuntor_padrao': 'Disjuntor Padrão',
            'conexoes_inversor': 'Conexões Inversor',
            'foto_conexoes_padrao': 'Conexões Padrão',
            'etiqueta_inversor': 'Etiqueta Inversor',
            'aterramento_padrao': 'Aterramento Padrão',
            'foto_aterramento_padrao': 'Aterramento Padrão',
            'aterramento_modulos': 'Aterramento Módulos',
            'foto_aterramento_modulos': 'Aterramento Módulos',
            'foto_aterramento_trilhos': 'Aterramento Trilhos',
            'etiqueta_datalogger': 'Etiqueta Datalogger',
            'instalacao_inversor': 'Instalação Inversor',
            'foto_instalacao_inversor': 'Instalação Inversor',
            'perfurantes_vampiros': 'Perfurantes Vampiros',
            'planta_monitoramento': 'Planta Monitoramento',
            'foto_planta_monitoramento': 'Planta de Monitoramento',
            'foto_etiqueta_inversor': 'Etiqueta do Inversor',
            'foto_datalogger': 'Datalogger',
            'antes_instalar_modulos': 'Antes Instalar Módulos',
            'foto_antes_modulos': 'Antes Módulos',
            'foto_apos_modulos': 'Após Módulos',
            'aterramento_carcaca_inversor': 'Aterramento Carcaça Inversor',
            'apos_corretiva': 'Após Corretiva',
            'antes_corretiva': 'Antes Corretiva',
            'foto_adicional': 'Foto Adicional'
          }
          
          const nomeBaseAmigavel = nomeAmigavel[nomeBase] || nomeBase.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
          const nomeFinal = customName
            ? (indice !== null && indice > 0 ? `${customName} ${indice + 1}` : customName)
            : (indice !== null ? `${nomeBaseAmigavel} ${indice + 1}` : nomeBaseAmigavel)
          
          return {
            id: `${formulario.id}_${nomeBase}_${indice !== null ? indice : 'single'}`,
            name: nomeFinal,
            url: url,
            size: 0, // Não temos informação de tamanho
            lastModified: formulario.created_at,
            description: `${nomeFinal} - ${formulario.tipo_fase || 'N/A'}`,
            tipoFase: formulario.tipo_fase,
            tipoFormulario: formulario.tipo_formulario,
            categoria: nomeBase,
            formularioId: formulario.id,
            fotoKey: nomeBase,
            fotoIndex: indice !== null ? indice : 0
          }
        }
        
        // PADRÃO NOVO: Objeto com chaves (ex: {"foto_qpca": [...], "foto_fachada": [...]})
        if (fotosParsed && typeof fotosParsed === 'object' && !Array.isArray(fotosParsed)) {
          console.log('  - Campo fotos é um objeto (padrão novo):', fotosParsed)
          
          // Processar cada propriedade do objeto fotos
          Object.entries(fotosParsed).forEach(([chave, valor], index) => {
            console.log(`    Processando ${chave}:`, valor)
            
            // Verificar se é um array de URLs
            if (Array.isArray(valor)) {
              console.log(`    - ${chave} é um array com ${valor.length} itens`)
              valor.forEach((item, arrayIndex) => {
                const url = typeof item === 'string' ? item : item?.url
                const titulo = typeof item === 'object' && item != null && item.titulo != null && item.titulo !== '' ? item.titulo : null
                if (url) {
                  const fotoProcessada = processarFoto(url, chave, formulario.id, arrayIndex, titulo)
                  if (fotoProcessada) {
                    console.log(`      Foto ${arrayIndex + 1} processada:`, fotoProcessada)
                    todasFotos.push(fotoProcessada)
                  }
                }
              })
            } 
            // Verificar se é uma string (URL única)
            else if (typeof valor === 'string' && valor.trim() !== '') {
              const fotoProcessada = processarFoto(valor, chave, formulario.id, null)
              if (fotoProcessada) {
                console.log('    Foto processada:', fotoProcessada)
                todasFotos.push(fotoProcessada)
              }
            }
            else {
              console.log(`    - Ignorando ${chave} (tipo não suportado: ${typeof valor}, valor: ${valor})`)
            }
          })
        } 
        // PADRÃO ANTIGO: Array simples de URLs (ex: ["url1", "url2", ...])
        else if (Array.isArray(fotosParsed) && fotosParsed.length > 0) {
          console.log('  - Campo fotos é um array (padrão antigo) com', fotosParsed.length, 'itens')
          
          fotosParsed.forEach((url, index) => {
            if (url && typeof url === 'string' && url.includes('http')) {
              const fotoProcessada = processarFoto(url, 'foto', formulario.id, index)
              if (fotoProcessada) {
                fotoProcessada.name = `Foto ${index + 1}`
                fotoProcessada.categoria = 'foto'
                console.log(`    Foto ${index + 1} processada (padrão antigo):`, fotoProcessada)
                todasFotos.push(fotoProcessada)
              }
            }
          })
        } 
        else {
          console.log('  - Campo fotos não é um objeto válido, array válido ou está vazio:', formulario.fotos)
        }
      })

      console.log('✅ Total de fotos processadas:', todasFotos.length)
      console.log('📸 Fotos finais:', todasFotos)
      
      setClienteFotos(todasFotos)
      setFormulariosFotosCache(formulariosData.map(f => ({
        id: f.id,
        cliente_id: f.cliente_id,
        fotos: typeof f.fotos === 'string' ? (() => { try { return JSON.parse(f.fotos) } catch { return {} } })() : (f.fotos || {})
      })))
    } catch (error) {
      console.error('Erro ao carregar fotos:', error)
      showNotification('Erro ao carregar fotos do cliente', 'error')
    } finally {
      setLoadingFotos(false)
    }
  }

  // Função para baixar uma foto individual
  const downloadIndividualFoto = async (foto) => {
    try {
      setDownloadingIndividual(prev => ({ ...prev, [foto.id]: true }))
      
      const response = await fetch(foto.url)
      if (!response.ok) throw new Error('Erro ao baixar foto')
      
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      
      const link = document.createElement('a')
      link.href = url
      link.download = `${foto.name.replace(/[^a-zA-Z0-9]/g, '_')}.jpg`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      window.URL.revokeObjectURL(url)
      showNotification(`Foto "${foto.name}" baixada com sucesso!`, 'success')
    } catch (error) {
      console.error('Erro ao baixar foto individual:', error)
      showNotification(`Erro ao baixar foto "${foto.name}": ${error.message}`, 'error')
    } finally {
      setDownloadingIndividual(prev => ({ ...prev, [foto.id]: false }))
    }
  }

  // Função para baixar todas as fotos em uma pasta
  const downloadAllFotos = async () => {
    if (clienteFotos.length === 0) {
      showNotification('Nenhuma foto para baixar', 'warning')
      return
    }

    try {
      setDownloadingAll(true)
      const clienteNome = clienteFotosData?.nome?.replace(/[^a-zA-Z0-9]/g, '_') || 'Cliente'
      
      // Usar JSZip para criar um arquivo ZIP
      const JSZip = (await import('jszip')).default
      const zip = new JSZip()
      const fotosFolder = zip.folder(clienteNome)

      let sucesso = 0
      let erro = 0

      for (const foto of clienteFotos) {
        try {
          const response = await fetch(foto.url)
          if (!response.ok) throw new Error(`HTTP ${response.status}`)
          
          const blob = await response.blob()
          const nomeArquivo = `${foto.name.replace(/[^a-zA-Z0-9]/g, '_')}.jpg`
          fotosFolder.file(nomeArquivo, blob)
          sucesso++
        } catch (error) {
          console.error(`Erro ao baixar ${foto.name}:`, error)
          erro++
        }
      }

      if (sucesso > 0) {
        const zipBlob = await zip.generateAsync({ type: 'blob' })
        const url = window.URL.createObjectURL(zipBlob)
        
        const link = document.createElement('a')
        link.href = url
        link.download = `${clienteNome}_Fotos.zip`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        window.URL.revokeObjectURL(url)
        
        if (erro > 0) {
          showNotification(`Download concluído! ${sucesso} fotos baixadas, ${erro} com erro.`, 'warning')
        } else {
          showNotification(`${sucesso} fotos baixadas com sucesso!`, 'success')
        }
      } else {
        showNotification('Nenhuma foto foi baixada. Verifique as URLs.', 'error')
      }
    } catch (error) {
      console.error('Erro ao baixar todas as fotos:', error)
      showNotification(`Erro ao baixar fotos: ${error.message}`, 'error')
    } finally {
      setDownloadingAll(false)
    }
  }

  // Remover uma foto (apenas administrador) – atualiza formularios_baixa_resolve
  const removeFotoCliente = async (foto) => {
    if (!foto.formularioId || !foto.fotoKey || formulariosFotosCache == null) return
    setRemovingFotoId(foto.id)
    try {
      const form = formulariosFotosCache.find(f => f.id === foto.formularioId)
      if (!form) throw new Error('Formulário não encontrado')
      const fotos = { ...form.fotos }
      const valor = fotos[foto.fotoKey]
      if (Array.isArray(valor)) {
        const novo = valor.filter((_, i) => i !== foto.fotoIndex)
        if (novo.length === 0) delete fotos[foto.fotoKey]
        else fotos[foto.fotoKey] = novo
      } else {
        delete fotos[foto.fotoKey]
      }
      const { error } = await supabase
        .from('formularios_baixa_resolve')
        .update({ fotos })
        .eq('id', foto.formularioId)
      if (error) throw error
      showNotification('Foto removida.', 'success')
      const clienteId = clienteFotosData?.id_cliente_cadastro ?? clienteFotosData?.id
      await loadClienteFotos(clienteId)
    } catch (e) {
      console.error('Erro ao remover foto:', e)
      showNotification(e.message || 'Erro ao remover foto', 'error')
    } finally {
      setRemovingFotoId(null)
    }
  }

  // Adicionar fotos ao formulário mais recente (apenas administrador); título vem de tituloFotoAdicional ou nome do arquivo
  const addFotosCliente = async (e) => {
    const files = Array.from(e.target.files || [])
    if (files.length === 0 || !formulariosFotosCache?.length || !clienteFotosData) return
    const tituloBase = (tituloFotoAdicional || '').trim()
    setAddingFotosCliente(true)
    try {
      const form = formulariosFotosCache[0]
      const timestamp = Date.now()
      const randomStr = Math.random().toString(36).substring(2, 15)
      const key = 'foto_adicional'
      const itemsToAdd = []
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        if (!file.type.startsWith('image/')) continue
        if (file.size > 10 * 1024 * 1024) {
          showNotification(`Imagem ${file.name} muito grande (máx 10MB)`, 'warning')
          continue
        }
        const ext = file.name.split('.').pop() || 'jpg'
        const fileName = `${form.id}_${key}_${timestamp}_${randomStr}_${i}.${ext}`
        const filePath = `fotos-baixa-resolve/${fileName}`
        const { error: uploadError } = await supabase.storage
          .from('fotos-finalizacao')
          .upload(filePath, file, { cacheControl: '3600', upsert: false })
        if (uploadError) {
          showNotification(`Erro ao enviar ${file.name}: ${uploadError.message}`, 'error')
          continue
        }
        const { data: { publicUrl } } = supabase.storage.from('fotos-finalizacao').getPublicUrl(filePath)
        const titulo = tituloBase || file.name.replace(/\.[^/.]+$/, '').replace(/[^a-zA-Z0-9\u00C0-\u00FF\s_-]/g, ' ').trim() || `Foto ${itemsToAdd.length + 1}`
        itemsToAdd.push({ url: publicUrl, titulo })
      }
      if (itemsToAdd.length === 0) {
        setAddingFotosCliente(false)
        e.target.value = ''
        return
      }
      const fotos = { ...form.fotos }
      const existente = Array.isArray(fotos[key]) ? fotos[key] : []
      const existenteNormalizado = existente.map(x => typeof x === 'string' ? { url: x, titulo: null } : x)
      fotos[key] = [...existenteNormalizado, ...itemsToAdd]
      const { error } = await supabase
        .from('formularios_baixa_resolve')
        .update({ fotos })
        .eq('id', form.id)
      if (error) throw error
      showNotification(`${itemsToAdd.length} foto(s) adicionada(s).`, 'success')
      setTituloFotoAdicional('')
      const clienteId = clienteFotosData?.id_cliente_cadastro ?? clienteFotosData?.id
      await loadClienteFotos(clienteId)
    } catch (e) {
      console.error('Erro ao adicionar fotos:', e)
      showNotification(e.message || 'Erro ao adicionar fotos', 'error')
    } finally {
      setAddingFotosCliente(false)
      e.target.value = ''
    }
  }

  const closeClienteFotos = () => {
    setShowClienteFotos(false)
    setClienteFotosData(null)
    setClienteFotos([])
    setFormulariosFotosCache(null)
    setRemovingFotoId(null)
    setAddingFotosCliente(false)
    setTituloFotoAdicional('')
  }
  
  // Gerar relatório PDF do cliente com informações e fotos
  const gerarRelatorioClientePDF = async (cliente) => {
    try {
      // Abrir modal de loading
      setShowRelatorioLoadingModal(true)
      
      // O formularios_baixa_resolve.cliente_id referencia clientes_cadastro(id)
      // Se o cliente tem id_cliente_cadastro, usar esse; caso contrário, usar o id (assumindo que é de clientes_cadastro)
      const clienteIdParaBuscar = cliente.id_cliente_cadastro || cliente.id
      
      console.log('📊 Gerando relatório PDF para cliente:', {
        id: cliente.id,
        id_cliente_cadastro: cliente.id_cliente_cadastro,
        nome: cliente.nome_cliente,
        clienteIdParaBuscar: clienteIdParaBuscar
      })
      
      // Carregar fotos do cliente
      const fotosTemp = []
      try {
        const { data: formulariosData, error: fotosError } = await supabase
          .from('formularios_baixa_resolve')
          .select('id, tipo_formulario, tipo_fase, fotos, created_at')
          .eq('cliente_id', clienteIdParaBuscar)
          .order('created_at', { ascending: false })

        console.log('📸 Formulários encontrados:', formulariosData?.length || 0)

        if (!fotosError && formulariosData) {
          formulariosData.forEach((formulario, formIdx) => {
            console.log(`📋 Processando formulário ${formIdx + 1} (ID: ${formulario.id})`)
            if (!formulario.fotos) {
              return // Pular se não houver fotos
            }

            // Parsear fotos se for uma string JSON
            let fotosParsed = formulario.fotos
            if (typeof formulario.fotos === 'string') {
              try {
                fotosParsed = JSON.parse(formulario.fotos)
              } catch (parseError) {
                console.warn('Erro ao parsear JSON de fotos:', parseError)
                return // Pular este formulário se não conseguir parsear
              }
            }

            // Função para processar uma URL de foto
            const processarFoto = (url, categoria = 'foto') => {
              // Validar URL
              if (!url || typeof url !== 'string' || !url.includes('http')) {
                return null
              }
              return {
                url: url,
                categoria: categoria,
                tipoFase: formulario.tipo_fase,
                tipoFormulario: formulario.tipo_formulario
              }
            }

            // PADRÃO NOVO: Objeto com chaves (ex: {"foto_qpca": [...], "foto_fachada": [...]})
            if (fotosParsed && typeof fotosParsed === 'object' && !Array.isArray(fotosParsed)) {
              const totalChaves = Object.keys(fotosParsed).length
              console.log(`  ✅ Objeto válido (padrão novo) com ${totalChaves} categorias de fotos`)
              
              Object.entries(fotosParsed).forEach(([chave, valor]) => {
                // Processar arrays de fotos (itens podem ser URL string ou objeto { url, titulo })
                if (Array.isArray(valor)) {
                  console.log(`    📁 ${chave}: array com ${valor.length} item(s)`)
                  valor.forEach((item, idx) => {
                    if (!item) {
                      console.log(`      ⚠️ Foto ${idx + 1} ignorada (null/undefined)`)
                      return
                    }
                    const url = typeof item === 'string' ? item : item?.url
                    const titulo = typeof item === 'object' && item?.titulo != null && item.titulo !== '' ? item.titulo : null
                    const foto = processarFoto(url, chave)
                    if (foto) {
                      if (titulo) foto.titulo = titulo
                      fotosTemp.push(foto)
                      console.log(`      ✅ Foto ${idx + 1} adicionada: ${chave}`)
                    } else {
                      console.log(`      ⚠️ Foto ${idx + 1} ignorada (URL inválida):`, url)
                    }
                  })
                } 
                // Processar strings individuais
                else if (typeof valor === 'string' && valor.trim() !== '') {
                  const foto = processarFoto(valor, chave)
                  if (foto) {
                    fotosTemp.push(foto)
                    console.log(`    ✅ ${chave}: foto única adicionada`)
                  } else {
                    console.log(`    ⚠️ ${chave}: foto ignorada (URL inválida)`)
                  }
                }
                // Ignorar null, undefined, arrays vazios, etc.
                else {
                  console.log(`    ⚠️ ${chave}: ignorado (tipo: ${typeof valor}, valor: ${valor})`)
                }
              })
            } 
            // PADRÃO ANTIGO: Array simples de URLs (ex: ["url1", "url2", ...])
            else if (Array.isArray(fotosParsed) && fotosParsed.length > 0) {
              console.log(`  ✅ Array válido (padrão antigo) com ${fotosParsed.length} foto(s)`)
              
              fotosParsed.forEach((url, idx) => {
                if (url && typeof url === 'string' && url.includes('http')) {
                  const foto = processarFoto(url, 'foto')
                  if (foto) {
                    fotosTemp.push(foto)
                    console.log(`    ✅ Foto ${idx + 1} adicionada (padrão antigo)`)
                  } else {
                    console.log(`    ⚠️ Foto ${idx + 1} ignorada (URL inválida): ${url}`)
                  }
                } else {
                  console.log(`    ⚠️ Foto ${idx + 1} ignorada (null/undefined ou URL inválida)`)
                }
              })
            } 
            else {
              console.log(`  ⚠️ Campo fotos não é um objeto válido ou array válido:`, fotosParsed)
            }
          })
          
          console.log(`📊 Total de fotos processadas: ${fotosTemp.length}`)
        }
      } catch (error) {
        console.warn('Erro ao carregar fotos para o relatório:', error)
      }

      // Criar PDF
      const doc = new jsPDF('p', 'mm', 'a4')
      const pageWidth = doc.internal.pageSize.getWidth()
      const pageHeight = doc.internal.pageSize.getHeight()
      const margin = 15
      const maxWidth = pageWidth - 2 * margin
      let yPosition = margin
      
      // Função auxiliar para garantir que o texto seja legível no PDF
      // jsPDF com Helvetica padrão pode ter problemas com caracteres acentuados
      // Esta função converte caracteres acentuados para suas versões sem acento
      const sanitizeText = (text) => {
        if (!text) return ''
        // Converter para string
        let textStr = String(text)
        
        // Mapear caracteres acentuados para versões sem acento
        const charMap = {
          'á': 'a', 'à': 'a', 'ã': 'a', 'â': 'a', 'ä': 'a',
          'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
          'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i',
          'ó': 'o', 'ò': 'o', 'õ': 'o', 'ô': 'o', 'ö': 'o',
          'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
          'ç': 'c', 'ñ': 'n',
          'Á': 'A', 'À': 'A', 'Ã': 'A', 'Â': 'A', 'Ä': 'A',
          'É': 'E', 'È': 'E', 'Ê': 'E', 'Ë': 'E',
          'Í': 'I', 'Ì': 'I', 'Î': 'I', 'Ï': 'I',
          'Ó': 'O', 'Ò': 'O', 'Õ': 'O', 'Ô': 'O', 'Ö': 'O',
          'Ú': 'U', 'Ù': 'U', 'Û': 'U', 'Ü': 'U',
          'Ç': 'C', 'Ñ': 'N'
        }
        
        // Substituir caracteres acentuados
        return textStr.replace(/[áàãâäéèêëíìîïóòõôöúùûüçñÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÔÖÚÙÛÜÇÑ]/g, (char) => charMap[char] || char)
      }

      // Cores melhoradas
      const primaryColor = [25, 118, 210] // Azul moderno
      const secondaryColor = [97, 97, 97] // Cinza médio
      const accentColor = [0, 150, 136] // Verde água
      const backgroundColor = [245, 245, 245] // Fundo claro
      const textColor = [33, 33, 33] // Texto escuro

      // Função auxiliar para adicionar nova página se necessário
      const checkNewPage = (requiredSpace) => {
        if (yPosition + requiredSpace > pageHeight - margin) {
          doc.addPage()
          yPosition = margin
          return true
        }
        return false
      }

      // Cabeçalho com box colorido
      doc.setFillColor(...primaryColor)
      doc.roundedRect(margin - 5, yPosition - 8, pageWidth - 2 * margin + 10, 30, 3, 3, 'F')
      
      doc.setTextColor(255, 255, 255)
      doc.setFontSize(24)
      doc.setFont('helvetica', 'bold')
      doc.text('RELATORIO DO CLIENTE', pageWidth / 2, yPosition + 8, { align: 'center' })
      
      yPosition += 25

      // ============================================
      // SEÇÃO: INFORMACOES DO CLIENTE
      // ============================================
      const infoStartY = yPosition
      checkNewPage(60)
      
      // Título da seção
      doc.setFillColor(...accentColor)
      doc.roundedRect(margin, yPosition - 5, pageWidth - 2 * margin, 15, 3, 3, 'F')
      
      doc.setFontSize(16)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(255, 255, 255)
      doc.text('INFORMACOES DO CLIENTE', margin + 8, yPosition + 8)
      
      yPosition += 18

      // Filtrar apenas informações que existem e sanitizar textos
      const infoCliente = []
      if (cliente.nome_cliente) infoCliente.push(['Nome:', sanitizeText(cliente.nome_cliente)])
      if (cliente.data_instalacao) infoCliente.push(['Data de Instalacao:', sanitizeText(formatarData(cliente.data_instalacao))])
      if (cliente.tipo_servico?.nome) infoCliente.push(['Tipo de Servico:', sanitizeText(cliente.tipo_servico.nome)])
      if (cliente.tipo_padrao?.nome) infoCliente.push(['Tipo de Padrao:', sanitizeText(cliente.tipo_padrao.nome)])
      if (cliente.quantidade_modulos) infoCliente.push(['Quantidade de Modulos:', sanitizeText(String(cliente.quantidade_modulos))])
      if (cliente.status_info?.status) infoCliente.push(['Status:', sanitizeText(cliente.status_info.status)])
      if (cliente.endereco) infoCliente.push(['Endereco:', sanitizeText(cliente.endereco)])
      if (cliente.cidade) infoCliente.push(['Cidade:', sanitizeText(cliente.cidade)])
      if (cliente.estado) infoCliente.push(['Estado:', sanitizeText(cliente.estado)])
      if (cliente.cep) infoCliente.push(['CEP:', sanitizeText(cliente.cep)])
      if (cliente.telefone) infoCliente.push(['Telefone:', sanitizeText(cliente.telefone)])
      if (cliente.email) infoCliente.push(['Email:', sanitizeText(cliente.email)])

      // Organizar informações em duas colunas para melhor aproveitamento do espaço
      const infoLeft = []
      const infoRight = []
      infoCliente.forEach((item, index) => {
        if (index < Math.ceil(infoCliente.length / 2)) {
          infoLeft.push(item)
        } else {
          infoRight.push(item)
        }
      })

      const col1X = margin + 10
      const col2X = pageWidth / 2 + 10
      let maxRows = Math.max(infoLeft.length, infoRight.length)

      // Adicionar informações com fonte maior e melhor espaçamento
      doc.setFontSize(12)
      for (let i = 0; i < maxRows; i++) {
        checkNewPage(12)
        
        // Coluna esquerda
        if (infoLeft[i]) {
          const labelText = sanitizeText(infoLeft[i][0])
          const valueText = sanitizeText(String(infoLeft[i][1]))
          
          doc.setFont('helvetica', 'bold')
          doc.setTextColor(...textColor)
          doc.text(labelText, col1X, yPosition)
          
          // Quebrar linha se o valor for muito longo
          const maxLabelWidth = 60
          const labelWidth = doc.getTextWidth(labelText)
          
          doc.setFont('helvetica', 'normal')
          doc.setTextColor(50, 50, 50)
          
          // Se o valor for muito longo, usar múltiplas linhas
          const lines = doc.splitTextToSize(valueText, maxLabelWidth)
          if (lines.length > 1) {
            doc.text(lines[0], col1X + labelWidth + 5, yPosition)
            for (let j = 1; j < lines.length; j++) {
              yPosition += 6
              checkNewPage(6)
              doc.text(lines[j], col1X + labelWidth + 5, yPosition)
            }
          } else {
            doc.text(valueText, col1X + labelWidth + 5, yPosition)
          }
        }
        
        // Coluna direita
        if (infoRight[i]) {
          doc.setFont('helvetica', 'bold')
          doc.setTextColor(...textColor)
          const labelText = sanitizeText(infoRight[i][0])
          const valueText = sanitizeText(String(infoRight[i][1]))
          
          doc.text(labelText, col2X, yPosition)
          
          const maxLabelWidth = 60
          const labelWidth = doc.getTextWidth(labelText)
          
          doc.setFont('helvetica', 'normal')
          doc.setTextColor(50, 50, 50)
          
          // Se o valor for muito longo, usar múltiplas linhas
          const lines = doc.splitTextToSize(valueText, maxLabelWidth)
          if (lines.length > 1) {
            doc.text(lines[0], col2X + labelWidth + 5, yPosition)
            for (let j = 1; j < lines.length; j++) {
              yPosition += 6
              checkNewPage(6)
              doc.text(lines[j], col2X + labelWidth + 5, yPosition)
            }
          } else {
            doc.text(valueText, col2X + labelWidth + 5, yPosition)
          }
        }
        
        yPosition += 10 // Espaçamento maior entre linhas
      }

      yPosition += 15

      // ============================================
      // SEÇÃO: FOTOS DA INSTALACAO
      // ============================================
      if (fotosTemp.length > 0) {
        checkNewPage(25)
        
        // Cabeçalho da seção de fotos
        doc.setFillColor(...accentColor)
        doc.roundedRect(margin, yPosition - 5, pageWidth - 2 * margin, 15, 3, 3, 'F')
        
        doc.setFontSize(16)
        doc.setFont('helvetica', 'bold')
        doc.setTextColor(255, 255, 255)
        doc.text('FOTOS DA INSTALACAO', margin + 8, yPosition + 8)
        
        doc.setFontSize(11)
        doc.setFont('helvetica', 'normal')
        doc.text(`Total: ${fotosTemp.length} foto(s)`, pageWidth - margin - 8, yPosition + 8, { align: 'right' })
        
        yPosition += 18

        // Configuração do grid (2 fotos lado a lado)
        const photosPerRow = 2
        const photoSpacing = 5
        const photoWidth = (maxWidth - photoSpacing) / photosPerRow
        const maxPhotoHeight = 45
        const photoTitleHeight = 6
        let currentCol = 0
        let rowStartY = yPosition
        let currentRowMaxHeight = 0

        // Adicionar fotos em grid (sem limite - todas as fotos serão incluídas)
        let fotoIndex = 0

        for (const foto of fotosTemp) {
          try {
            // Calcular posição X baseada na coluna
            const photoX = margin + (currentCol * (photoWidth + photoSpacing))

            // Verificar se precisa de nova página antes de adicionar foto
            if (rowStartY + maxPhotoHeight + photoTitleHeight + 15 > pageHeight - margin) {
              doc.addPage()
              rowStartY = margin
              currentCol = 0
              currentRowMaxHeight = 0
            }

            // Adicionar título da foto (pequeno); usar titulo quando existir (fotos adicionadas pelo admin)
            doc.setFontSize(7)
            doc.setFont('helvetica', 'bold')
            doc.setTextColor(...secondaryColor)
            const fotoTitle = (foto.titulo && String(foto.titulo).trim())
              ? sanitizeText(String(foto.titulo).trim().substring(0, 25))
              : (foto.categoria ? foto.categoria.replace(/_/g, ' ').substring(0, 20).toUpperCase() : 'FOTO')
            doc.text(fotoTitle, photoX, rowStartY)
            const titleY = rowStartY + photoTitleHeight

            // Carregar e adicionar imagem
            const img = new Image()
            img.crossOrigin = 'anonymous'
            
            let imgWidth = 0
            let imgHeight = 0
            
            await new Promise((resolve) => {
              img.onload = () => {
                try {
                  // Calcular dimensões mantendo proporção
                  imgWidth = img.width
                  imgHeight = img.height
                  const ratio = Math.min(photoWidth / imgWidth, maxPhotoHeight / imgHeight)
                  imgWidth = imgWidth * ratio
                  imgHeight = imgHeight * ratio

                  // Centralizar imagem no espaço disponível
                  const photoXCentered = photoX + (photoWidth - imgWidth) / 2

                  doc.addImage(img, 'JPEG', photoXCentered, titleY, imgWidth, imgHeight)
                  
                  // Atualizar altura máxima desta linha
                  const totalPhotoHeight = imgHeight + photoTitleHeight
                  currentRowMaxHeight = Math.max(currentRowMaxHeight, totalPhotoHeight)
                  
                  resolve()
                } catch (error) {
                  console.warn('Erro ao adicionar imagem ao PDF:', error)
                  currentRowMaxHeight = Math.max(currentRowMaxHeight, photoTitleHeight)
                  resolve()
                }
              }
              img.onerror = () => {
                console.warn('Erro ao carregar imagem:', foto.url)
                currentRowMaxHeight = Math.max(currentRowMaxHeight, photoTitleHeight)
                resolve()
              }
              img.src = foto.url
              setTimeout(() => {
                if (imgWidth === 0 && imgHeight === 0) {
                  currentRowMaxHeight = Math.max(currentRowMaxHeight, photoTitleHeight)
                  resolve()
                }
              }, 5000)
            })

            // Avançar para próxima coluna/linha
            currentCol++
            if (currentCol >= photosPerRow) {
              currentCol = 0
              // Avançar para próxima linha
              rowStartY += currentRowMaxHeight + photoSpacing
              currentRowMaxHeight = 0
            }

            fotoIndex++
          } catch (error) {
            console.warn('Erro ao processar foto:', error)
            fotoIndex++
          }
        }

        // Ajustar posição final
        if (currentCol > 0) {
          // Se terminou no meio de uma linha, ainda precisa avançar
          rowStartY += currentRowMaxHeight + photoSpacing
        }
        yPosition = rowStartY + 5
      } else {
        checkNewPage(15)
        doc.setFillColor(...backgroundColor)
        doc.roundedRect(margin, yPosition - 3, pageWidth - 2 * margin, 12, 3, 3, 'FD')
        doc.setFontSize(10)
        doc.setFont('helvetica', 'italic')
        doc.setTextColor(...secondaryColor)
        doc.text('Nenhuma foto disponivel para este cliente.', pageWidth / 2, yPosition + 6, { align: 'center' })
        yPosition += 15
      }

      // ============================================
      // SEÇÃO: DATA E HORA DA GERACAO
      // ============================================
      // Adicionar data e hora da geração no final do documento
      const dataHoraGeracao = new Date()
      const dataFormatada = dataHoraGeracao.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
      const horaFormatada = dataHoraGeracao.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      
      // Verificar se precisa de nova página para o rodapé
      checkNewPage(20)
      
      // Adicionar espaço antes do rodapé
      yPosition += 10
      
      // Linha separadora
      doc.setDrawColor(...primaryColor)
      doc.setLineWidth(0.5)
      doc.line(margin, yPosition, pageWidth - margin, yPosition)
      yPosition += 8
      
      // Data e hora da geração
      doc.setFontSize(11)
      doc.setFont('helvetica', 'bold')
      doc.setTextColor(...textColor)
      doc.text('Relatorio gerado em:', pageWidth / 2, yPosition, { align: 'center' })
      yPosition += 8
      
      doc.setFontSize(12)
      doc.setTextColor(...primaryColor)
      doc.text(`${sanitizeText(dataFormatada)} as ${sanitizeText(horaFormatada)}`, pageWidth / 2, yPosition, { align: 'center' })
      yPosition += 10
      
      // Texto "Relatorio gerado pelo ConectSolar"
      doc.setFontSize(10)
      doc.setFont('helvetica', 'italic')
      doc.setTextColor(120, 120, 120)
      doc.text('Relatorio gerado pelo ConectSolar.', pageWidth / 2, yPosition, { align: 'center' })
      yPosition += 8

      // Rodapé com numeração de páginas
      const totalPages = doc.internal.pages.length - 1
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i)
        
        // Número da página no rodapé
        doc.setFontSize(10)
        doc.setFont('helvetica', 'normal')
        doc.setTextColor(150, 150, 150)
        doc.text(
          `Pagina ${i} de ${totalPages}`,
          pageWidth / 2,
          pageHeight - 8,
          { align: 'center' }
        )
      }

      // Salvar PDF
      const fileName = `Relatorio_${cliente.nome_cliente?.replace(/[^a-zA-Z0-9]/g, '_')}_${Date.now()}.pdf`
      doc.save(fileName)

      // Fechar modal de loading
      setShowRelatorioLoadingModal(false)
      
      showNotification('Relatório PDF gerado com sucesso!', 'success')
    } catch (error) {
      console.error('Erro ao gerar relatório PDF:', error)
      
      // Fechar modal de loading em caso de erro
      setShowRelatorioLoadingModal(false)
      
      showNotification('Erro ao gerar relatório PDF: ' + error.message, 'error')
    }
  }
  
  // Abrir modal de visualização do cliente
  const openClienteModal = async (cliente) => {
    setClienteModalData(cliente)
    setShowClienteModal(true)
    // Carregar observações de formularios_baixa_resolve para o modal
    if (cliente.id) {
      await loadObservacoesFormularioBaixaModal(cliente.id)
    }
  }
  
  // Função para carregar observações de formularios_baixa_resolve para o modal de visualização
  const loadObservacoesFormularioBaixaModal = async (clienteId) => {
    if (!clienteId) {
      setObservacoesModalFormularioBaixa([])
      return
    }
    
    try {
      const { data, error } = await supabase
        .from('formularios_baixa_resolve')
        .select('id, observacao, tipo_formulario, tipo_fase, created_at')
        .eq('cliente_id', clienteId)
        .not('observacao', 'is', null)
        .order('created_at', { ascending: false })
      
      if (error) throw error
      
      setObservacoesModalFormularioBaixa(data || [])
    } catch (error) {
      console.error('Erro ao carregar observações do formulário para o modal:', error)
      setObservacoesModalFormularioBaixa([])
    }
  }
  
  // Fechar modal de visualização do cliente
  const closeClienteModal = () => {
    setShowClienteModal(false)
    setClienteModalData(null)
    setObservacoesModalFormularioBaixa([]) // Limpar observações ao fechar modal
  }
  
  // Salvar cliente
  const handleClienteFormSubmit = async (e) => {
    e.preventDefault()
    
    try {
      let clienteId
      
      // Validar campos obrigatórios
      if (!clienteFormData.tipo_servico_id) {
        showNotification('Por favor, selecione um tipo de serviço.', 'error')
        return
      }
      
      if (!clienteFormData.tipo_padrao_id) {
        showNotification('Por favor, selecione um tipo de padrão.', 'error')
        return
      }
      
      // Campo quantidade_modulos agora é opcional
      // Removida validação obrigatória pois nem sempre os módulos serão instalados
      
      // Campos equipe_id e id_profiles agora são opcionais
      // Removidas validações obrigatórias para permitir cadastro sem equipe/responsáveis
      
      // Função auxiliar para garantir que strings vazias em campos UUID sejam null
      const sanitizeUUID = (value) => {
        if (!value || (typeof value === 'string' && value.trim() === '')) {
          return null
        }
        // Se for um UUID válido, retornar; caso contrário, null
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
        if (typeof value === 'string' && !uuidRegex.test(value)) {
          return null
        }
        return value
      }
      
      // Criar uma cópia limpa dos dados do cliente (sem campos de relacionamento)
      const { id_profiles, ...clienteData } = clienteFormData
      
      // Garantir que empresa_id está definido
      if (!clienteData.empresa_id && userEmpresa?.id) {
        clienteData.empresa_id = userEmpresa.id
      }
      
      // Validar se empresa_id está presente
      if (!clienteData.empresa_id) {
        showNotification('Erro: Empresa não identificada. Faça login novamente.', 'error')
        return
      }
      
      // Lista de campos UUID conhecidos na tabela clientes
      const uuidFields = ['tipo_servico_id', 'tipo_padrao_id', 'equipe_id', 'empresa_id', 'id']
      
      // Limpar todos os campos UUID do objeto antes de enviar
      // Garantir que nenhum campo UUID seja enviado como string vazia
      Object.keys(clienteData).forEach(key => {
        const value = clienteData[key]
        
        // Verificar se é um campo UUID conhecido ou que parece ser UUID
        const isUUIDField = uuidFields.includes(key) || 
                           (key.includes('id') && key !== 'cpf' && key !== 'quantidade_modulos') || 
                           key.includes('uuid')
        
        if (isUUIDField) {
          // Se for string vazia, converter para null
          if (typeof value === 'string' && value.trim() === '') {
            console.warn(`⚠️ Campo UUID vazio detectado e convertido para null: ${key}`)
            clienteData[key] = null
          }
          // Se for string mas não for UUID válido, converter para null
          else if (typeof value === 'string' && value.trim() !== '') {
            const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
            if (!uuidRegex.test(value)) {
              console.warn(`⚠️ Campo UUID inválido detectado e convertido para null: ${key} = "${value}"`)
              clienteData[key] = null
            }
          }
        }
      })
      
      // Remover o campo 'id' se existir (não deve ser enviado no insert/update)
      if (clienteData.id !== undefined) {
        delete clienteData.id
      }

      // Deslocamento: valor monetário (0 se vazio)
      clienteData.deslocamento = clienteData.deslocamento === '' || clienteData.deslocamento == null ? 0 : (Number(clienteData.deslocamento) || 0)
      
      // Log para debug
      console.log('📤 Dados a serem salvos (Welcome.js):', JSON.stringify(clienteData, null, 2))
      
      if (editingCliente) {
        // Atualizar cliente existente
        
        const { error } = await supabase
          .from('clientes')
          .update(clienteData)
          .eq('id', editingCliente.id)
        
        if (error) throw error
        
        clienteId = editingCliente.id
        showNotification('Cliente atualizado com sucesso!', 'success')
      } else {
        // Criar novo cliente
        const { data, error } = await supabase
          .from('clientes')
          .insert([clienteData])
          .select('id')
        
        if (error) throw error
        
        clienteId = data[0].id
        showNotification('Cliente cadastrado com sucesso!', 'success')
      }
      
      // Salvar responsáveis na tabela clientes_usuarios
      if (clienteId && id_profiles && id_profiles.length > 0) {
        try {
          await salvarResponsaveisCliente(clienteId, id_profiles)
          showNotification('Cliente e responsáveis salvos com sucesso!', 'success')
        } catch (error) {
          console.error('❌ Erro ao salvar responsáveis:', error)
          showNotification('Cliente salvo, mas houve erro ao salvar responsáveis: ' + error.message, 'warning')
        }
      } else {

      }
      
      closeClienteForm()
      loadClientes()
    } catch (error) {
      console.error('Erro ao salvar cliente:', error)
      showNotification('Erro ao salvar cliente: ' + error.message, 'error')
    }
  }
  
  // Função para editar valores na medição
  const handleEditValorMedicao = async (clienteId, campo, valor) => {
    try {
      // Atualizar o estado local primeiro para feedback imediato
      setMedicaoData(prevData => 
        prevData.map(item => 
          item.id === clienteId 
            ? { ...item, [campo]: valor }
            : item
        )
      )

      // Atualizar no banco de dados
      const { error } = await supabase
        .from('clientes')
        .update({ 
          [campo]: valor,
          data_atualizacao: new Date().toISOString()
        })
        .eq('id', clienteId)

      if (error) throw error

      // Recalcular o total para este cliente
      const clienteAtualizado = medicaoData.find(item => item.id === clienteId)
      if (clienteAtualizado) {
        // Verificar se a obra está cancelada
        const { data: clienteDB } = await supabase
          .from('clientes')
          .select('obra_cancelada')
          .eq('id', clienteId)
          .single()

        let novoTotal
        const valorObraAtual = campo === 'valor_obra' ? valor : clienteAtualizado.valor_obra_civil
        const valorMaterialAtual = campo === 'valor_material' ? valor : clienteAtualizado.valor_material

        if (clienteDB?.obra_cancelada) {
          // Se a obra for cancelada, o TOTAL é 400 + valor de compras
          novoTotal = 400 + (clienteAtualizado.valor_compras || 0)
        } else if (clienteAtualizado.tipo_servico?.toLowerCase() === 'retorno') {
          // Lógica para tipo de serviço "retorno": Total = 400 + valor_material + valor_obra
          novoTotal = 400 + valorMaterialAtual + valorObraAtual
        } else if (clienteAtualizado.tipo_servico === 'Retirada de paineis + Inversor') {
          // Lógica para tipo de serviço "Retirada de paineis + Inversor": Total = (QTD_MÓDULOS × 45 + 350) + valor_material + valor_obra
          novoTotal = ((clienteAtualizado.qtd_modulos || 0) * 45 + 350) + valorMaterialAtual + valorObraAtual
        } else {
          // Calcular total normal
          novoTotal = (90 * (clienteAtualizado.qtd_modulos || 0)) + 
                       clienteAtualizado.valor_padrao + 
                       clienteAtualizado.valor_inversor + 
                       clienteAtualizado.valor_deslocamento + 
                       clienteAtualizado.valor_nota_material + 
                       valorObraAtual + 
                       valorMaterialAtual
        }

        // Atualizar o total no estado local
        setMedicaoData(prevData => 
          prevData.map(item => 
            item.id === clienteId 
              ? { ...item, total: novoTotal }
              : item
          )
        )
      }

      showNotification(`Valor ${campo === 'valor_obra' ? 'da obra civil' : 'do material'} atualizado com sucesso!`, 'success')
    } catch (error) {
      console.error('Erro ao atualizar valor:', error)
      showNotification(`Erro ao atualizar valor: ${error.message}`, 'error')
      
      // Reverter mudança no estado local em caso de erro
      setMedicaoData(prevData => 
        prevData.map(item => 
          item.id === clienteId 
            ? { ...item, [campo]: item[campo] }
            : item
        )
      )
    }
  }
  // Função para gerar recibos em PDF para todos os clientes da medição
  const gerarRecibosPDF = () => {
    if (medicaoData.length === 0) {
      showNotification('Nenhum dado de medição disponível para gerar recibos', 'error')
      return
    }

    try {
      // Configurações padrão do PDF
      const pdf = new jsPDF('p', 'mm', 'a4')
      const pageWidth = pdf.internal.pageSize.getWidth()
      const pageHeight = pdf.internal.pageSize.getHeight()
      
      // Valores padrão de posicionamento
      const MARGIN = 20
      const CONTENT_WIDTH = pageWidth - (2 * MARGIN)
      
      // Larguras específicas para cada coluna para evitar sobreposição
      const COLUMN_WIDTHS = {
        SERVICO: 70,      // Nome do serviço (mais larga sem a coluna cliente)
        QTD: 25,          // Quantidade (números pequenos)
        PRECO: 35,        // Valor unitário
        TOTAL: 40         // Valor total
      }
      
      // Posições das colunas calculadas com base nas larguras específicas
      const COLUMNS = {
        SERVICO: MARGIN + 5,
        QTD: MARGIN + COLUMN_WIDTHS.SERVICO + 10,
        PRECO: MARGIN + COLUMN_WIDTHS.SERVICO + COLUMN_WIDTHS.QTD + 15,
        TOTAL: MARGIN + COLUMN_WIDTHS.SERVICO + COLUMN_WIDTHS.QTD + COLUMN_WIDTHS.PRECO + 20
      }
      
      // Alturas padrão
      const HEIGHTS = {
        TITLE: 15,
        SUBTITLE: 10,
        HEADER: 8,
        ROW: 6,
        SEPARATOR: 5,
        MARGIN_SMALL: 3,
        MARGIN_MEDIUM: 8,
        MARGIN_LARGE: 15
      }
      
      // Cores padrão
      const COLORS = {
        HEADER_BG: [255, 165, 0],
        HEADER_TEXT: [255, 255, 255],
        SEPARATOR: [200, 200, 200],
        SEPARATOR_STRONG: [150, 150, 150],
        TOTAL_LINE: [0, 0, 0]
      }
      
      // Funções utilitárias otimizadas
      const setHeaderStyle = () => {
        pdf.setFont('helvetica', 'bold')
        pdf.setTextColor(...COLORS.HEADER_TEXT)
        pdf.setFontSize(10)
      }
      
      const setNormalStyle = () => {
        pdf.setFont('helvetica', 'normal')
        pdf.setTextColor(0, 0, 0)
        pdf.setFontSize(9)
      }
      
      const setBoldStyle = () => {
        pdf.setFont('helvetica', 'bold')
        pdf.setTextColor(0, 0, 0)
        pdf.setFontSize(10)
      }
      
      const setTitleStyle = () => {
        pdf.setFont('helvetica', 'bold')
        pdf.setTextColor(0, 0, 0)
        pdf.setFontSize(24)
      }
      
      const setSubtitleStyle = () => {
        pdf.setFont('helvetica', 'bold')
        pdf.setTextColor(0, 0, 0)
        pdf.setFontSize(12)
      }
      
      const formatCurrency = (value) => {
        return value.toLocaleString('pt-BR', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
        })
      }
      
      const calcularValorPadrao = (nomePadrao) => {
        if (!nomePadrao) return 0
        const padrao = nomePadrao.toLowerCase()
        const valores = {
          'fachada': 200,
          'poste auxiliar': 300,
          'fachada com ancoragem': 200,
          'saga': 500,
          'não instalado': 0
        }
        return valores[padrao] || 0
      }
      
      const calcularValorTotal = (cliente) => {
        // Verificar se a obra está cancelada
        if (cliente.obra_cancelada) {
          return 400 // Valor fixo para obras canceladas
        }
        
        const valorObraCivil = cliente.valor_obra || 0
        const valorMaterial = cliente.valor_material || 0
        
        // Lógica para tipo de serviço "retorno": Total = 400 + valor_material + valor_obra
        if (cliente.tipo_servico?.toLowerCase() === 'retorno') {
          return 400 + valorMaterial + valorObraCivil
        }

        // Lógica para tipo de serviço "Retirada de paineis + Inversor": Total = (QTD_MÓDULOS × 45 + 350) + valor_material + valor_obra
        if (cliente.tipo_servico === 'Retirada de paineis + Inversor') {
          return ((cliente.qtd_modulos || 0) * 45 + 350) + valorMaterial + valorObraCivil
        }
        
        // Usar a mesma lógica do filtro "Tipo de Medição"
        let total
        if (tipoMedicao === 'kwp') {
          // Para Kwp: se tipo_servico for "Configuração", total é apenas 100
          if (cliente.tipo_servico === 'Configuração') {
            total = 100
          } else {
            // Lógica normal do Kwp (sem somar configuracao_inversor)
            const kwp = (cliente.qtd_modulos || 0) * 0.610
            const valorKwp = getValorKwp(kwp)
            
            total = (kwp * valorKwp) + valorObraCivil + valorMaterial
          }
        } else {
          // Lógica para Módulos (original)
          const valorModulos = 90 * (cliente.qtd_modulos || 0)
          const valorPadrao = calcularValorPadrao(cliente.padrao)
          const valorInversor = cliente.configuracao_inversor === 'Sim' ? 100 : 0
          const valorDeslocamento = cliente.deslocamento_buscar_material === 'Sim' ? 50 : 0
          const valorCompras = cliente.valor_compras || 0
          
          total = valorModulos + valorPadrao + valorInversor + valorDeslocamento + valorCompras + valorObraCivil
        }
        
        // Adicionar valor de configuração se o tipo de serviço for "Configuração" (apenas para módulos)
        if (tipoMedicao === 'modulos' && cliente.tipo_servico === 'Configuração') {
          total += 100
        }
        
        // Adicionar valor para "Placa de Geração" - R$ 50,00 + compras + valor material
        if (cliente.tipo_servico === 'Placa de Geração') {
          const valorCompras = cliente.valor_compras || 0
          total = 50 + valorCompras + valorMaterial
        }
        
        return total
      }
      
      const addNewPageIfNeeded = (requiredSpace) => {
        if (currentY + requiredSpace > pageHeight - MARGIN) {
          pdf.addPage()
          currentY = MARGIN
          return true
        }
        return false
      }
      
      // Variáveis de controle
      let currentY = MARGIN
      let totalGeral = 0
      
      // Cabeçalho principal
      setTitleStyle()
      pdf.text('RECIBO', pageWidth / 2, currentY, { align: 'center' })
      currentY += HEIGHTS.TITLE
      
      // Informações da empresa (coluna esquerda)
      setSubtitleStyle()
      pdf.text('EMPRESA TECSOL', MARGIN, currentY)
      currentY += HEIGHTS.SUBTITLE
      
      setNormalStyle()
      pdf.setFontSize(10)
      const empresaInfo = [
        'CNPJ: 44.376.302.0001/34',
        'CONTATO: (91) 982113496',
        'CIDADE: ANANINDEUA',
        'BAIRRO CENTRO, ESTADO: PARÁ CEP: 67040-690',
        'DADOS BANCÁRIOS: AGÊNCIA: 2831 | CONTA: 92772-4',
        'BANCO BRADESCO',
        'CHAVE PIX 44376302000134'
      ]
      
      empresaInfo.forEach(info => {
        pdf.text(info, MARGIN, currentY)
        currentY += HEIGHTS.ROW
      })
      
      currentY += HEIGHTS.MARGIN_MEDIUM
      
      // Informações do cliente (coluna direita)
      const clientInfoY = MARGIN + HEIGHTS.TITLE
      setSubtitleStyle()
      pdf.text('CLIENTE: RESOLVE ENERGIA SOLAR', MARGIN + CONTENT_WIDTH / 2, clientInfoY)
      
      setNormalStyle()
      pdf.setFontSize(10)
      pdf.text('CONTATO: (91) 98587-3012', MARGIN + CONTENT_WIDTH / 2, clientInfoY + HEIGHTS.ROW)
      pdf.text('DATA: ' + new Date().toLocaleDateString('pt-BR'), MARGIN + CONTENT_WIDTH / 2, clientInfoY + HEIGHTS.ROW * 2)
      
      // Descrição das atividades
      setSubtitleStyle()
      pdf.text('DESCRIÇÃO DE ATIVIDADES: INSTALAÇÃO DE SISTEMA FOTOVOLTAICO CONECTADO A REDE', 
               pageWidth / 2, currentY, { align: 'center' })
      currentY += HEIGHTS.MARGIN_LARGE
      
      // Processar cada cliente
      medicaoData.forEach((cliente, index) => {
        // Verificar espaço necessário para este cliente
        const requiredSpace = 50 // Espaço estimado por cliente
        addNewPageIfNeeded(requiredSpace)
        
        // Nome do cliente e data - AGORA ACIMA DA TABELA
        setBoldStyle()
        const nomeCliente = cliente.cliente || cliente.nome_cliente || 'Cliente sem nome'
        pdf.text('CLIENTE: ' + nomeCliente, MARGIN, currentY)
        currentY += HEIGHTS.ROW
        
        setNormalStyle()
        const dataCliente = cliente.data || cliente.data_instalacao || new Date().toISOString().split('T')[0]
        const dataFormatada = dataCliente ? new Date(dataCliente).toLocaleDateString('pt-BR') : 'N/A'
        pdf.text('DATA: ' + dataFormatada, MARGIN, currentY)
        currentY += HEIGHTS.MARGIN_MEDIUM
        
        // Cabeçalho da tabela para este cliente
        pdf.setFillColor(...COLORS.HEADER_BG)
        pdf.rect(MARGIN, currentY, CONTENT_WIDTH, HEIGHTS.HEADER, 'F')
        
        setHeaderStyle()
        pdf.text('SERVIÇO', COLUMNS.SERVICO, currentY + HEIGHTS.HEADER - 2)
        pdf.text('QTD', COLUMNS.QTD, currentY + HEIGHTS.HEADER - 2)
        pdf.text('VALOR', COLUMNS.PRECO, currentY + HEIGHTS.HEADER - 2)
        pdf.text('TOTAL', COLUMNS.TOTAL, currentY + HEIGHTS.HEADER - 2)
        
        currentY += HEIGHTS.HEADER + HEIGHTS.MARGIN_SMALL
        
        // Serviços - cada serviço em uma linha separada
        setNormalStyle()
        
        // Para Kwp com tipo_servico "Configuração": mostrar apenas o serviço de configuração
        if (tipoMedicao === 'kwp' && cliente.tipo_servico === 'Configuração') {
          const valorUnitario = 100
          const valorTotal = valorUnitario * 1
          pdf.text('SERVIÇO DE CONFIGURAÇÃO', COLUMNS.SERVICO, currentY)
          pdf.text('1', COLUMNS.QTD, currentY)
          pdf.text('100,00', COLUMNS.PRECO, currentY)
          pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
          currentY += HEIGHTS.ROW
        }
        // Para tipo_servico "Placa de Geração": mostrar serviço específico
        else if (cliente.tipo_servico === 'Placa de Geração') {
          const valorBase = 50
          const valorCompras = cliente.valor_compras || 0
          const valorMaterial = cliente.valor_material || 0
          const valorTotal = valorBase + valorCompras + valorMaterial
          
          pdf.text('PLACA DE GERAÇÃO', COLUMNS.SERVICO, currentY)
          pdf.text('1', COLUMNS.QTD, currentY)
          pdf.text(formatCurrency(valorBase), COLUMNS.PRECO, currentY)
          pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
          currentY += HEIGHTS.ROW
          
          // Se houver valor de compras, mostrar como linha separada
          if (valorCompras > 0) {
            pdf.text('VALOR COMPRAS', COLUMNS.SERVICO, currentY)
            pdf.text('1', COLUMNS.QTD, currentY)
            pdf.text(formatCurrency(valorCompras), COLUMNS.PRECO, currentY)
            pdf.text(formatCurrency(valorCompras), COLUMNS.TOTAL, currentY)
            currentY += HEIGHTS.ROW
          }
          
          // Se houver valor de material, mostrar como linha separada
          if (valorMaterial > 0) {
            pdf.text('VALOR MATERIAL', COLUMNS.SERVICO, currentY)
            pdf.text('1', COLUMNS.QTD, currentY)
            pdf.text(formatCurrency(valorMaterial), COLUMNS.PRECO, currentY)
            pdf.text(formatCurrency(valorMaterial), COLUMNS.TOTAL, currentY)
            currentY += HEIGHTS.ROW
          }
        } else {
          // Instalação de módulos ou Kwp (baseado no tipo de medição)
          if (cliente.qtd_modulos > 0) {
            if (tipoMedicao === 'kwp') {
              // Verificar se é tipo de serviço especial (Retorno ou Retirada de paineis + Inversor)
              const tipoServicoLower = cliente.tipo_servico?.toLowerCase() || ''
              
              if (tipoServicoLower === 'retorno') {
                // Tipo de serviço "Retorno": Total = 400 + valor_material + valor_obra
                const valorBase = 400
                const valorObraCivil = cliente.valor_obra || 0
                const valorMaterial = cliente.valor_material || 0
                const valorTotal = valorBase + valorObraCivil + valorMaterial
                
                pdf.text('RETORNO', COLUMNS.SERVICO, currentY)
                pdf.text('1', COLUMNS.QTD, currentY)
                pdf.text(formatCurrency(valorBase), COLUMNS.PRECO, currentY)
                pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
                currentY += HEIGHTS.ROW
                
                // Mostrar valor obra se houver
                if (valorObraCivil > 0) {
                  pdf.text('VALOR OBRA', COLUMNS.SERVICO, currentY)
                  pdf.text('1', COLUMNS.QTD, currentY)
                  pdf.text(formatCurrency(valorObraCivil), COLUMNS.PRECO, currentY)
                  pdf.text(formatCurrency(valorObraCivil), COLUMNS.TOTAL, currentY)
                  currentY += HEIGHTS.ROW
                }
                
                // Mostrar valor material se houver
                if (valorMaterial > 0) {
                  pdf.text('VALOR MATERIAL', COLUMNS.SERVICO, currentY)
                  pdf.text('1', COLUMNS.QTD, currentY)
                  pdf.text(formatCurrency(valorMaterial), COLUMNS.PRECO, currentY)
                  pdf.text(formatCurrency(valorMaterial), COLUMNS.TOTAL, currentY)
                  currentY += HEIGHTS.ROW
                }
              } else if (cliente.tipo_servico === 'Retirada de paineis + Inversor') {
                // Tipo de serviço "Retirada de paineis + Inversor": Total = (QTD_MÓDULOS × 45 + 350) + valor_material + valor_obra
                const valorPaineis = cliente.qtd_modulos * 45
                const valorInversor = 350
                const valorObraCivil = cliente.valor_obra || 0
                const valorMaterial = cliente.valor_material || 0
                
                // Linha 1: RETIRADA DE PAINEIS
                pdf.text('RETIRADA DE PAINEIS', COLUMNS.SERVICO, currentY)
                pdf.text(cliente.qtd_modulos.toString(), COLUMNS.QTD, currentY)
                pdf.text('45,00', COLUMNS.PRECO, currentY)
                pdf.text(formatCurrency(valorPaineis), COLUMNS.TOTAL, currentY)
                currentY += HEIGHTS.ROW
                
                // Linha 2: INVERSOR
                pdf.text('INVERSOR', COLUMNS.SERVICO, currentY)
                pdf.text('1', COLUMNS.QTD, currentY)
                pdf.text('350,00', COLUMNS.PRECO, currentY)
                pdf.text(formatCurrency(valorInversor), COLUMNS.TOTAL, currentY)
                currentY += HEIGHTS.ROW
                
                // Mostrar valor obra se houver
                if (valorObraCivil > 0) {
                  pdf.text('VALOR OBRA', COLUMNS.SERVICO, currentY)
                  pdf.text('1', COLUMNS.QTD, currentY)
                  pdf.text(formatCurrency(valorObraCivil), COLUMNS.PRECO, currentY)
                  pdf.text(formatCurrency(valorObraCivil), COLUMNS.TOTAL, currentY)
                  currentY += HEIGHTS.ROW
                }
                
                // Mostrar valor material se houver
                if (valorMaterial > 0) {
                  pdf.text('VALOR MATERIAL', COLUMNS.SERVICO, currentY)
                  pdf.text('1', COLUMNS.QTD, currentY)
                  pdf.text(formatCurrency(valorMaterial), COLUMNS.PRECO, currentY)
                  pdf.text(formatCurrency(valorMaterial), COLUMNS.TOTAL, currentY)
                  currentY += HEIGHTS.ROW
                }
              } else {
                // Lógica normal para Kwp (instalação)
                const kwp = cliente.qtd_modulos * 0.610
                const valorKwp = getValorKwp(kwp)
                const valorTotal = kwp * valorKwp
                pdf.text('INSTALAÇÃO POR KWP', COLUMNS.SERVICO, currentY)
                pdf.text(kwp.toFixed(2).replace('.', ','), COLUMNS.QTD, currentY)
                pdf.text(formatCurrency(valorKwp), COLUMNS.PRECO, currentY)
                pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
                currentY += HEIGHTS.ROW
              }
            } else {
              // Lógica para Módulos
              const tipoServicoLower = cliente.tipo_servico?.toLowerCase() || ''
              
              if (tipoServicoLower === 'retorno') {
                // Tipo de serviço "Retorno": Total = 400 + valor_material + valor_obra
                const valorBase = 400
                const valorObraCivil = cliente.valor_obra || 0
                const valorMaterial = cliente.valor_material || 0
                const valorTotal = valorBase + valorObraCivil + valorMaterial
                
                pdf.text('RETORNO', COLUMNS.SERVICO, currentY)
                pdf.text('1', COLUMNS.QTD, currentY)
                pdf.text(formatCurrency(valorBase), COLUMNS.PRECO, currentY)
                pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
                currentY += HEIGHTS.ROW
                
                // Mostrar valor obra se houver
                if (valorObraCivil > 0) {
                  pdf.text('VALOR OBRA', COLUMNS.SERVICO, currentY)
                  pdf.text('1', COLUMNS.QTD, currentY)
                  pdf.text(formatCurrency(valorObraCivil), COLUMNS.PRECO, currentY)
                  pdf.text(formatCurrency(valorObraCivil), COLUMNS.TOTAL, currentY)
                  currentY += HEIGHTS.ROW
                }
                
                // Mostrar valor material se houver
                if (valorMaterial > 0) {
                  pdf.text('VALOR MATERIAL', COLUMNS.SERVICO, currentY)
                  pdf.text('1', COLUMNS.QTD, currentY)
                  pdf.text(formatCurrency(valorMaterial), COLUMNS.PRECO, currentY)
                  pdf.text(formatCurrency(valorMaterial), COLUMNS.TOTAL, currentY)
                  currentY += HEIGHTS.ROW
                }
              } else if (cliente.tipo_servico === 'Retirada de paineis + Inversor') {
                // Tipo de serviço "Retirada de paineis + Inversor": Total = (QTD_MÓDULOS × 45 + 350) + valor_material + valor_obra
                const valorPaineis = cliente.qtd_modulos * 45
                const valorInversor = 350
                const valorObraCivil = cliente.valor_obra || 0
                const valorMaterial = cliente.valor_material || 0
                
                // Linha 1: RETIRADA DE PAINEIS
                pdf.text('RETIRADA DE PAINEIS', COLUMNS.SERVICO, currentY)
                pdf.text(cliente.qtd_modulos.toString(), COLUMNS.QTD, currentY)
                pdf.text('45,00', COLUMNS.PRECO, currentY)
                pdf.text(formatCurrency(valorPaineis), COLUMNS.TOTAL, currentY)
                currentY += HEIGHTS.ROW
                
                // Linha 2: INVERSOR
                pdf.text('INVERSOR', COLUMNS.SERVICO, currentY)
                pdf.text('1', COLUMNS.QTD, currentY)
                pdf.text('350,00', COLUMNS.PRECO, currentY)
                pdf.text(formatCurrency(valorInversor), COLUMNS.TOTAL, currentY)
                currentY += HEIGHTS.ROW
                
                // Mostrar valor obra se houver
                if (valorObraCivil > 0) {
                  pdf.text('VALOR OBRA', COLUMNS.SERVICO, currentY)
                  pdf.text('1', COLUMNS.QTD, currentY)
                  pdf.text(formatCurrency(valorObraCivil), COLUMNS.PRECO, currentY)
                  pdf.text(formatCurrency(valorObraCivil), COLUMNS.TOTAL, currentY)
                  currentY += HEIGHTS.ROW
                }
                
                // Mostrar valor material se houver
                if (valorMaterial > 0) {
                  pdf.text('VALOR MATERIAL', COLUMNS.SERVICO, currentY)
                  pdf.text('1', COLUMNS.QTD, currentY)
                  pdf.text(formatCurrency(valorMaterial), COLUMNS.PRECO, currentY)
                  pdf.text(formatCurrency(valorMaterial), COLUMNS.TOTAL, currentY)
                  currentY += HEIGHTS.ROW
                }
              } else {
                // Lógica normal para Módulos (instalação)
                const valorUnitario = 90
                const valorTotal = valorUnitario * cliente.qtd_modulos
                pdf.text('INSTALAÇÃO DE MÓDULO', COLUMNS.SERVICO, currentY)
                pdf.text(cliente.qtd_modulos.toString(), COLUMNS.QTD, currentY)
                pdf.text('90,00', COLUMNS.PRECO, currentY)
                pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
                currentY += HEIGHTS.ROW
              }
            }
          }
        }
        
        // Serviços adicionais (apenas para tipo "Módulos" e não para tipos de serviço especiais)
        const tipoServicoEspecialModulo = cliente.tipo_servico?.toLowerCase() === 'retorno' || cliente.tipo_servico === 'Retirada de paineis + Inversor'
        
        if (tipoMedicao === 'modulos' && !tipoServicoEspecialModulo) {
          // Padrão
          if (cliente.padrao && cliente.padrao !== 'Não Instalado') {
            const valorPadrao = calcularValorPadrao(cliente.padrao)
            const valorTotal = valorPadrao * 1
            pdf.text('INSTALAÇÃO DE PADRÃO', COLUMNS.SERVICO, currentY)
            pdf.text('1', COLUMNS.QTD, currentY)
            pdf.text(formatCurrency(valorPadrao), COLUMNS.PRECO, currentY)
            pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
            currentY += HEIGHTS.ROW
          }
          
          // Configuração de inversor
          if (cliente.configuracao_inversor === 'Sim') {
            const valorUnitario = 100
            const valorTotal = valorUnitario * 1
            pdf.text('CONFIGURAÇÃO', COLUMNS.SERVICO, currentY)
            pdf.text('1', COLUMNS.QTD, currentY)
            pdf.text('100,00', COLUMNS.PRECO, currentY)
            pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
            currentY += HEIGHTS.ROW
          }
          
          // Compra de material
          const valorCompras = (cliente.valor_material || 0) + (cliente.valor_compras || 0)
          if (valorCompras > 0) {
            const valorTotal = valorCompras * 1
            pdf.text('COMPRA DE MATERIAL', COLUMNS.SERVICO, currentY)
            pdf.text('1', COLUMNS.QTD, currentY)
            pdf.text(formatCurrency(valorCompras), COLUMNS.PRECO, currentY)
            pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
            currentY += HEIGHTS.ROW
          }
          
          // Busca de material
          if (cliente.deslocamento_buscar_material === 'Sim') {
            const valorUnitario = 50
            const valorTotal = valorUnitario * 1
            pdf.text('BUSCA DE MATERIAL', COLUMNS.SERVICO, currentY)
            pdf.text('1', COLUMNS.QTD, currentY)
            pdf.text('50,00', COLUMNS.PRECO, currentY)
            pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
            currentY += HEIGHTS.ROW
          }
        }
        
        // Serviço de Configuração (apenas para módulos quando tipo_servico for "Configuração")
        if (tipoMedicao === 'modulos' && cliente.tipo_servico === 'Configuração') {
          const valorUnitario = 100
          const valorTotal = valorUnitario * 1
          pdf.text('SERVIÇO DE CONFIGURAÇÃO', COLUMNS.SERVICO, currentY)
          pdf.text('1', COLUMNS.QTD, currentY)
          pdf.text('100,00', COLUMNS.PRECO, currentY)
          pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
          currentY += HEIGHTS.ROW
        }
        
        // Valor Material (para ambos os tipos) - exceto quando já foi mostrado em tipos de serviço específicos
        const tipoServicoEspecial = cliente.tipo_servico?.toLowerCase() === 'retorno' || cliente.tipo_servico === 'Retirada de paineis + Inversor'
        
        if (cliente.valor_material && cliente.valor_material > 0 && !tipoServicoEspecial) {
          const valorTotal = cliente.valor_material * 1
          pdf.text('VALOR MATERIAL', COLUMNS.SERVICO, currentY)
          pdf.text('1', COLUMNS.QTD, currentY)
          pdf.text(formatCurrency(cliente.valor_material), COLUMNS.PRECO, currentY)
          pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
          currentY += HEIGHTS.ROW
        }
        
        // Obra Cívil - exceto quando já foi mostrado em tipos de serviço específicos
        if (cliente.valor_obra && cliente.valor_obra > 0 && !tipoServicoEspecial) {
          const valorTotal = cliente.valor_obra * 1
          pdf.text('OBRA CÍVIL', COLUMNS.SERVICO, currentY)
          pdf.text('1', COLUMNS.QTD, currentY)
          pdf.text(formatCurrency(cliente.valor_obra), COLUMNS.PRECO, currentY)
          pdf.text(formatCurrency(valorTotal), COLUMNS.TOTAL, currentY)
          currentY += HEIGHTS.ROW
        }
        
        // Serviço de Cancelamento (para obras canceladas)
        if (cliente.obra_cancelada) {
          const valorCancelamento = 400
          const valorCompras = cliente.valor_compras || 0
          
          pdf.text('CANCELAMENTO', COLUMNS.SERVICO, currentY)
          pdf.text('1', COLUMNS.QTD, currentY)
          pdf.text(formatCurrency(valorCancelamento), COLUMNS.PRECO, currentY)
          pdf.text(formatCurrency(valorCancelamento), COLUMNS.TOTAL, currentY)
          currentY += HEIGHTS.ROW
          
          // Adicionar linha de compras se houver valor
          if (valorCompras > 0) {
            pdf.text('COMPRAS', COLUMNS.SERVICO, currentY)
            pdf.text('1', COLUMNS.QTD, currentY)
            pdf.text(formatCurrency(valorCompras), COLUMNS.PRECO, currentY)
            pdf.text(formatCurrency(valorCompras), COLUMNS.TOTAL, currentY)
            currentY += HEIGHTS.ROW
          }
        }
        
        // Linha separadora
        pdf.setDrawColor(...COLORS.SEPARATOR)
        pdf.line(MARGIN, currentY, pageWidth - MARGIN, currentY)
        currentY += HEIGHTS.SEPARATOR
        
        // Total do cliente
        const totalCliente = calcularValorTotal(cliente)
        totalGeral += totalCliente
        
        setBoldStyle()
        pdf.text('TOTAL FINAL: R$ ' + formatCurrency(totalCliente), MARGIN, currentY)
        currentY += HEIGHTS.MARGIN_LARGE
        
        // Linha separadora entre clientes
        if (index < medicaoData.length - 1) {
          pdf.setDrawColor(...COLORS.SEPARATOR_STRONG)
          pdf.line(MARGIN, currentY, pageWidth - MARGIN, currentY)
          currentY += HEIGHTS.MARGIN_MEDIUM
        }
      })
      
      // Verificar espaço para o total geral
      addNewPageIfNeeded(40)
      
      // Linha separadora antes do total geral
      pdf.setDrawColor(...COLORS.TOTAL_LINE)
      pdf.setLineWidth(2)
      pdf.line(MARGIN, currentY, pageWidth - MARGIN, currentY)
      currentY += HEIGHTS.MARGIN_LARGE
      
      // Total geral
      setBoldStyle()
      pdf.setFontSize(16)
      pdf.text('TOTAL GERAL DE TODOS OS RECIBOS: R$ ' + formatCurrency(totalGeral), 
               pageWidth / 2, currentY, { align: 'center' })
      currentY += HEIGHTS.SUBTITLE
      
      // Informações adicionais
      setNormalStyle()
      pdf.setFontSize(10)
      pdf.text(`Total de clientes: ${medicaoData.length}`, pageWidth / 2, currentY, { align: 'center' })
      currentY += HEIGHTS.ROW
      pdf.text(`Data de geração: ${new Date().toLocaleDateString('pt-BR')}`, pageWidth / 2, currentY, { align: 'center' })
      
      // Salvar o PDF
      const fileName = `recibos_medicao_${new Date().toISOString().split('T')[0]}.pdf`
      pdf.save(fileName)
      
      showNotification(`Recibos gerados com sucesso! ${medicaoData.length} cliente(s) incluído(s).`, 'success')
      
    } catch (error) {
      console.error('Erro ao gerar PDF:', error)
      showNotification('Erro ao gerar PDF: ' + error.message, 'error')
    }
  }

  // Editar cliente
  // Função para carregar observações de formularios_baixa_resolve
  const loadObservacoesFormularioBaixa = async (clienteId) => {
    if (!clienteId) {
      setObservacoesFormularioBaixa([])
      return
    }
    
    try {
      const { data, error } = await supabase
        .from('formularios_baixa_resolve')
        .select('id, observacao, tipo_formulario, tipo_fase, created_at')
        .eq('cliente_id', clienteId)
        .not('observacao', 'is', null)
        .order('created_at', { ascending: false })
      
      if (error) throw error
      
      setObservacoesFormularioBaixa(data || [])
    } catch (error) {
      console.error('Erro ao carregar observações do formulário:', error)
      setObservacoesFormularioBaixa([])
    }
  }

  const handleEditCliente = async (cliente) => {
    try {
      // Carregar responsáveis do cliente
      const responsaveisIds = await loadResponsaveisCliente(cliente.id)
      
      // Carregar observações de formularios_baixa_resolve
      await loadObservacoesFormularioBaixa(cliente.id)
      
      // Garantir que o modal pode ser fechado para edição normal
      setClienteModalNaoFechavel(false)
      
      setEditingCliente(cliente)
      const novoFormData = {
        nome_cliente: cliente.nome_cliente || '',
        endereco: cliente.endereco || '',
        telefone: cliente.telefone || '',
        data_instalacao: cliente.data_instalacao || '',
        tipo_servico_id: cliente.tipo_servico_id || '',
        tipo_padrao_id: cliente.tipo_padrao_id || '',
        id_profiles: responsaveisIds,
        equipe_id: cliente.equipe_id || '',
        data_cadastro: cliente.data_cadastro || new Date().toISOString().split('T')[0],
        quantidade_modulos: cliente.quantidade_modulos || 0,
        deslocamento_buscar_material: cliente.deslocamento_buscar_material || false,
        configuracao_inversor: cliente.configuracao_inversor || false,
        obra_civil: cliente.obra_civil || false,
        obra_cancelada: cliente.obra_cancelada || false,
        nota_material: cliente.nota_material || false,
        observacoes: cliente.observacoes || '',
        id_status: cliente.id_status || 1, // Status padrão: Pendente (ID 1)
        deslocamento: cliente.deslocamento != null && cliente.deslocamento !== '' ? Number(cliente.deslocamento) : ''
      }
      
      setClienteFormData(novoFormData)
      
      setShowClienteForm(true)
    } catch (error) {
      console.error('Erro ao carregar responsáveis do cliente:', error)
      showNotification('Erro ao carregar dados do cliente', 'error')
    }
  }
  
  // Excluir cliente
  const handleDeleteCliente = async (cliente) => {
    if (!security.hasPermission(userRole, 'CLIENT_MANAGEMENT', 'REMOVE')) {
      showNotification('Você não tem permissão para excluir clientes.', 'error')
      return
    }
    
    try {
      // Verificar se o cliente tem registros de presença
      const { data: presencas, error: presencaError } = await supabase
        .from('presenca')
        .select('id, data_presenca')
        .eq('cliente_id', cliente.id)
      
      if (presencaError) throw presencaError
      
      if (presencas && presencas.length > 0) {
        // Cliente tem presenças, mostrar aviso
        setClienteParaExcluir(cliente)
        setPresencasCliente(presencas)
        setShowPresencaWarningModal(true)
        return
      }
      
      // Se não tem presenças, confirmar exclusão normal
      if (!window.confirm(`Tem certeza que deseja excluir o cliente "${cliente.nome_cliente}"?`)) {
        return
      }
      
      // Excluir cliente (não tem presenças)
      const { error } = await supabase
        .from('clientes')
        .delete()
        .eq('id', cliente.id)
      
      if (error) throw error
      
      showNotification('Cliente excluído com sucesso!', 'success')
      loadClientes()
    } catch (error) {
      console.error('Erro ao excluir cliente:', error)
      
      if (error.message.includes('foreign key constraint')) {
        showNotification(`Erro ao excluir cliente: Este cliente possui registros de presença relacionados. 
        Exclua primeiro os registros de presença.`, 'error')
      } else {
        showNotification('Erro ao excluir cliente: ' + error.message, 'error')
      }
    }
  }
  
  // Fechar modal de aviso de presenças
  const closePresencaWarningModal = () => {
    setShowPresencaWarningModal(false)
    setClienteParaExcluir(null)
    setPresencasCliente([])
  }
  
  // Excluir presenças e cliente
  const handleDeletePresencasAndCliente = async () => {
    if (!clienteParaExcluir) return
    
    try {
      // Primeiro excluir as presenças
      const { error: deletePresencaError } = await supabase
        .from('presenca')
        .delete()
        .eq('cliente_id', clienteParaExcluir.id)
      
      if (deletePresencaError) throw deletePresencaError
      
      showNotification(`${presencasCliente.length} registro(s) de presença excluído(s) com sucesso.`, 'success')
      
      // Depois excluir o cliente
      const { error: deleteClienteError } = await supabase
        .from('clientes')
        .delete()
        .eq('id', clienteParaExcluir.id)
      
      if (deleteClienteError) throw deleteClienteError
      
      showNotification('Cliente excluído com sucesso!', 'success')
      loadClientes()
      closePresencaWarningModal()
    } catch (error) {
      console.error('Erro ao excluir cliente:', error)
      showNotification('Erro ao excluir cliente: ' + error.message, 'error')
    }
  }
  
  // Abrir formulário de presença
  const openNewPresencaForm = (cliente = null, obrigatorio = false) => {
    setEditingPresenca(null)
    setPresencaFormData({
      data_presenca: new Date().toISOString().split('T')[0],
      data_cadastro_preenchido: new Date().toISOString().split('T')[0],
      cliente_id: cliente ? cliente.id : '',
      equipe_id: '',
      veiculo_id: '',
      km_inicial: '',
      observacoes: '',
      colaboradores: [] // Inicializar array vazio de colaboradores
    })
    setShowPresencaForm(true)
  }
  
  // Fechar formulário de presença
  const closePresencaForm = () => {
    // Se o modal não pode ser fechado (presença obrigatória), não permitir fechar
    if (presencaModalNaoFechavel) {
      showNotification('Você deve preencher a lista de presença antes de fechar este modal.', 'warning')
      return
    }
    
    setShowPresencaForm(false)
    setEditingPresenca(null)
    setPresencaFormData({
      data_presenca: '',
      data_cadastro_preenchido: '',
      cliente_id: '',
      equipe_id: '',
      veiculo_id: '',
      km_inicial: '',
      observacoes: '',
      colaboradores: []
    })
  }

  // Abrir modal de importação de planilha
  const openImportPresencaModal = () => {
    setShowImportPresencaModal(true)
    setImportFile(null)
    setImportData([])
  }
  // Fechar modal de importação
  const closeImportPresencaModal = () => {
    setShowImportPresencaModal(false)
    setImportFile(null)
    setImportData([])
  }

  // Processar arquivo de planilha
  const handleFileUpload = (event) => {
    const file = event.target.files[0]
    if (!file) return

    setImportFile(file)
    setImportLoading(true)

    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })

        // Validar cabeçalho
        if (jsonData.length < 2) {
          showNotification('Planilha deve ter pelo menos 2 linhas (cabeçalho + dados)', 'error')
          setImportLoading(false)
          return
        }

        const header = jsonData[0]
        const expectedHeader = ['Data', 'Colaborador', 'Carro', 'Email', 'Km Inicial']
        
        if (!expectedHeader.every((col, index) => header[index] === col)) {
          showNotification('Cabeçalho inválido. Esperado: Data, Colaborador, Carro, Email, Km Inicial', 'error')
          setImportLoading(false)
          return
        }

        // Processar dados
        const processedData = []
        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i]
          if (row.length >= 5 && row[0] && row[1]) {
            // Converter data do formato brasileiro (25/06/2025) para ISO (2025-06-25)
            let dataFormatada = row[0]
            if (typeof row[0] === 'string' && row[0].includes('/')) {
              // Formato brasileiro: DD/MM/YYYY
              const partes = row[0].split('/')
              if (partes.length === 3) {
                const dia = partes[0].padStart(2, '0')
                const mes = partes[1].padStart(2, '0')
                const ano = partes[2]
                
                // Validar se a data é válida
                const dataTeste = new Date(`${ano}-${mes}-${dia}`)
                if (isNaN(dataTeste.getTime())) {
                  console.warn(`Data inválida na linha ${i + 1}: ${row[0]}`)
                  continue // Pular esta linha
                }
                
                dataFormatada = `${ano}-${mes}-${dia}`
              }
            } else if (row[0] instanceof Date) {
              // Se já for um objeto Date, converter para ISO
              dataFormatada = row[0].toISOString().split('T')[0]
            } else if (typeof row[0] === 'number') {
              // Se for um número (Excel serial date), converter
              const data = new Date((row[0] - 25569) * 86400 * 1000)
              dataFormatada = data.toISOString().split('T')[0]
            }

            processedData.push({
              data: dataFormatada,
              colaborador: row[1],
              carro: row[2] || '',
              km_inicial: row[4] || ''
            })
          }
        }

        setImportData(processedData)
        showNotification(`${processedData.length} registros carregados com sucesso!`, 'success')
      } catch (error) {
        console.error('Erro ao processar planilha:', error)
        showNotification('Erro ao processar planilha. Verifique o formato do arquivo.', 'error')
      } finally {
        setImportLoading(false)
      }
    }

    reader.readAsArrayBuffer(file)
  }

  // Buscar colaboradores para o searchbox
  const buscarColaboradores = async (termo) => {
    if (!termo || termo.length < 2) {
      setSearchResults([])
      return
    }

    setSearchLoading(true)
    try {
      const { data, error } = await supabase
        .from('colaboradores')
        .select('id, nome, cargo')
        .ilike('nome', `%${termo}%`)
        .eq('ativo', true)
        .limit(10)

      if (error) throw error
      setSearchResults(data || [])
    } catch (error) {
      console.error('Erro ao buscar colaboradores:', error)
      setSearchResults([])
    } finally {
      setSearchLoading(false)
    }
  }

  // Associar colaborador manualmente
  const associarColaborador = (colaboradorNaoEncontrado, colaboradorEncontrado) => {
    setColaboradoresNaoEncontrados(prev => 
      prev.filter(item => item !== colaboradorNaoEncontrado)
    )
    setColaboradoresEncontrados(prev => [
      ...prev,
      {
        ...colaboradorNaoEncontrado,
        colaborador_associado: colaboradorEncontrado
      }
    ])
    setSearchTerm('')
    setSearchResults([])
  }

  // Gerar resumo da importação
  const gerarResumoImportacao = () => {
    const dadosPorData = {}
    colaboradoresEncontrados.forEach(item => {
      if (!dadosPorData[item.data]) {
        dadosPorData[item.data] = {
          data: item.data,
          colaboradores: [],
          veiculos: new Set(),
          km_inicial: item.km_inicial || 0
        }
      }
      dadosPorData[item.data].colaboradores.push({
        nome_planilha: item.colaborador,
        nome_sistema: item.colaborador_associado.nome,
        cargo: item.colaborador_associado.cargo
      })
      if (item.carro) {
        dadosPorData[item.data].veiculos.add(item.carro)
      }
    })

    const resumo = {
      total_colaboradores: colaboradoresEncontrados.length,
      total_datas: Object.keys(dadosPorData).length,
      dados_por_data: Object.values(dadosPorData).map(data => ({
        ...data,
        veiculos: Array.from(data.veiculos),
        total_colaboradores_data: data.colaboradores.length
      })),
      colaboradores_nao_encontrados: colaboradoresNaoEncontrados.length
    }

    setResumoImportacao(resumo)
    setShowResumoConfirmacaoModal(true)
  }

  // Processar importação final
  const processarImportacaoFinal = async () => {
    setShowResumoConfirmacaoModal(false)
    setImportLoading(true)
    setShowImportProgressModal(true)
    setImportProgress({ current: 0, total: colaboradoresEncontrados.length, status: 'Iniciando importação...' })

    try {
      let successCount = 0
      let errorCount = 0

      // Agrupar dados por data para processar em lote
      const dadosPorData = {}
      colaboradoresEncontrados.forEach(item => {
        if (!dadosPorData[item.data]) {
          dadosPorData[item.data] = []
        }
        dadosPorData[item.data].push(item)
      })

      // Processar cada data
      for (const [data, itens] of Object.entries(dadosPorData)) {
        setImportProgress({
          current: Object.keys(dadosPorData).indexOf(data) + 1,
          total: Object.keys(dadosPorData).length,
          status: `Processando data: ${data}...`
        })

        try {
          // Verificar se já existe presença para esta data
          const { data: presencaExistente, error: errorPresenca } = await supabase
            .from('presenca')
            .select('id')
            .eq('data_presenca', data)
            .single()

          let presencaId = null

          if (presencaExistente) {
            presencaId = presencaExistente.id
          } else {
            // Criar nova presença
            let veiculoParaPresenca = null
            for (const item of itens) {
              if (item.carro && item.carro.trim()) {
                const { data: veiculoExato, error: errorVeiculoExato } = await supabase
                  .from('veiculos')
                  .select('id, veiculo')
                  .eq('veiculo', item.carro)
                  .eq('ativo', true)
                  .single()

                if (veiculoExato && !errorVeiculoExato) {
                  veiculoParaPresenca = veiculoExato
                  break
                } else {
                  const { data: veiculosParciais, error: errorVeiculoParcial } = await supabase
                    .from('veiculos')
                    .select('id, veiculo')
                    .ilike('veiculo', `%${item.carro}%`)
                    .eq('ativo', true)

                  if (veiculosParciais && veiculosParciais.length > 0) {
                    veiculoParaPresenca = veiculosParciais[0]
                    break
                  }
                }
              }
            }

            if (!veiculoParaPresenca) {
              console.error(`Nenhum veículo válido encontrado para a data ${data}`)
              errorCount += itens.length
              continue
            }

            const { data: novaPresenca, error: presencaError } = await supabase
              .from('presenca')
              .insert([{
                data_presenca: data,
                data_cadastro_preenchido: new Date().toISOString().split('T')[0],
                cliente_id: null,
                equipe_id: null,
                veiculo_id: veiculoParaPresenca.id,
                km_inicial: itens[0].km_inicial || 0,
                observacoes: `Importado via planilha`
              }])
              .select('id')

            if (presencaError) {
              console.error('Erro ao criar presença:', presencaError)
              errorCount += itens.length
              continue
            }

            presencaId = novaPresenca[0].id
          }

          // Processar cada colaborador da data
          for (const item of itens) {
            try {
              const colaborador = item.colaborador_associado

              // Verificar se colaborador já está na presença
              const { data: colaboradorJaPresente, error: checkError } = await supabase
                .from('presenca_colaboradores')
                .select('id')
                .eq('presenca_id', presencaId)
                .eq('colaborador_id', colaborador.id)
                .single()

              if (colaboradorJaPresente) {
                console.log(`Colaborador ${colaborador.nome} já está na presença da data ${data}`)
                continue
              }

              // Adicionar colaborador à presença
              const { error: colaboradorPresencaError } = await supabase
                .from('presenca_colaboradores')
                .insert([{
                  presenca_id: presencaId,
                  colaborador_id: colaborador.id,
                  presente: true,
                  observacoes: 'Presente'
                }])

              if (colaboradorPresencaError) {
                console.error('Erro ao adicionar colaborador à presença:', colaboradorPresencaError)
                errorCount++
                continue
              }

              successCount++
            } catch (error) {
              console.error('Erro ao processar colaborador:', error)
              errorCount++
            }
          }
        } catch (error) {
          console.error(`Erro ao processar data ${data}:`, error)
          errorCount += itens.length
        }
      }

      setImportProgress({ 
        current: colaboradoresEncontrados.length, 
        total: colaboradoresEncontrados.length, 
        status: 'Finalizando...' 
      })
      
      showNotification(`Importação concluída! ${colaboradoresEncontrados.length} registros processados.`, 'success')
      
      // Fechar modais
      setShowImportProgressModal(false)
      setShowColaboradoresNaoEncontradosModal(false)
      setImportData([])
      setColaboradoresNaoEncontrados([])
      setColaboradoresEncontrados([])
      
      // Recarregar dados
      loadPresencas()
      
    } catch (error) {
      console.error('Erro na importação:', error)
      showNotification('Erro na importação: ' + error.message, 'error')
    } finally {
      setImportLoading(false)
    }
  }

  // Importar dados para o banco
  const importPresencaData = async () => {
    if (importData.length === 0) {
      showNotification('Nenhum dado para importar', 'error')
      return
    }

    setImportLoading(true)
    setShowImportProgressModal(true)
    setImportProgress({ current: 0, total: importData.length, status: 'Analisando colaboradores...' })

    try {
      let colaboradoresNaoEncontradosTemp = []
      let colaboradoresEncontradosTemp = []

      // Agrupar dados por data para processar em lote
      const dadosPorData = {}
      importData.forEach(item => {
        if (!dadosPorData[item.data]) {
          dadosPorData[item.data] = []
        }
        dadosPorData[item.data].push(item)
      })
      

      // Processar cada data
      for (const [data, itens] of Object.entries(dadosPorData)) {
        setImportProgress({
          current: Object.keys(dadosPorData).indexOf(data) + 1,
          total: Object.keys(dadosPorData).length,
          status: `Analisando data: ${data}...`
        })

        // Processar cada colaborador da data
        for (const item of itens) {
          // Dividir a string de colaboradores em uma lista individual
          const colaboradoresLista = item.colaborador.split(',').map(c => c.trim()).filter(c => c.length > 0)
          
          // Processar cada colaborador individualmente
          for (const nomeColaborador of colaboradoresLista) {
            try {
              // Buscar colaborador por nome (busca inteligente)
              let colaborador = null
            
              // Normalizar nome da planilha (remover acentos e converter para minúsculo)
              const normalizarTexto = (texto) => {
                return texto
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '') // Remove acentos
                  .trim()
              }
              
              const nomePlanilha = normalizarTexto(nomeColaborador)
              const partesNomePlanilha = nomePlanilha.split(' ').filter(p => p.length > 0)
            
              if (partesNomePlanilha.length >= 2) {
                const primeiroNome = partesNomePlanilha[0]
                const segundoNome = partesNomePlanilha[1]
                
                // Buscar colaboradores que contenham o primeiro nome
                const { data: colaboradoresComPrimeiroNome, error: errorPrimeiro } = await supabase
                  .from('colaboradores')
                  .select('id, nome')
                  .eq('ativo', true)
                
                if (colaboradoresComPrimeiroNome && !errorPrimeiro) {
                  // Filtrar colaboradores que contenham o primeiro nome
                  const candidatos = colaboradoresComPrimeiroNome.filter(c => {
                    const nomeColaborador = normalizarTexto(c.nome)
                    return nomeColaborador.includes(primeiroNome)
                  })
                  
                  if (candidatos.length > 0) {
                    // Entre os candidatos, encontrar o que tem o segundo nome
                    const melhorMatch = candidatos.find(c => {
                      const nomeColaborador = normalizarTexto(c.nome)
                      const partesColaborador = nomeColaborador.split(' ').filter(p => p.length > 0)
                      
                      // Verificar se o segundo nome da planilha está nas partes do colaborador
                      return partesColaborador.some(parte => parte.includes(segundoNome))
                    })
                    
                    colaborador = melhorMatch || candidatos[0]
                  }
                }
              }
            
              // Se não encontrou com a lógica inteligente, tentar busca simples
              if (!colaborador) {
                const { data: colaboradorSimples, error: errorSimples } = await supabase
                  .from('colaboradores')
                  .select('id, nome')
                  .ilike('nome', `%${nomeColaborador}%`)
                  .eq('ativo', true)
                  .limit(1)
                
                if (colaboradorSimples && colaboradorSimples.length > 0) {
                  colaborador = colaboradorSimples[0]
                }
              }

              if (!colaborador) {
                colaboradoresNaoEncontradosTemp.push({
                  ...item,
                  colaborador: nomeColaborador
                })
              } else {
                colaboradoresEncontradosTemp.push({
                  ...item,
                  colaborador: nomeColaborador,
                  colaborador_associado: colaborador
                })
              }
            } catch (error) {
              console.error('Erro ao processar colaborador:', error)
              colaboradoresNaoEncontradosTemp.push({
                ...item,
                colaborador: nomeColaborador
              })
            }
          }
        }
      }

      // Fechar modal de progresso
      setShowImportProgressModal(false)
      setImportLoading(false)


      // Se há colaboradores não encontrados, mostrar modal de resumo
      if (colaboradoresNaoEncontradosTemp.length > 0) {
        setColaboradoresNaoEncontrados(colaboradoresNaoEncontradosTemp)
        setColaboradoresEncontrados(colaboradoresEncontradosTemp)
        setShowColaboradoresNaoEncontradosModal(true)
      } else {
        // Se todos foram encontrados, processar diretamente
        setColaboradoresEncontrados(colaboradoresEncontradosTemp)
        processarImportacaoFinal()
      }

      setImportProgress({ 
        current: importData.length, 
        total: importData.length, 
        status: 'Finalizando...' 
      })
      
      showNotification(`Importação concluída! ${colaboradoresEncontrados.length} registros processados.`, 'success')
      
      // Aguardar um pouco antes de fechar os modais
      setTimeout(() => {
        setShowImportProgressModal(false)
        closeImportPresencaModal()
        loadPresencas() // Recarregar lista de presenças
      }, 1500)
      
    } catch (error) {
      console.error('Erro na importação:', error)
      showNotification('Erro durante a importação', 'error')
      setShowImportProgressModal(false)
    } finally {
      setImportLoading(false)
    }
  }
  
  // Salvar presença
  const handlePresencaFormSubmit = async (e) => {
    e.preventDefault()
    
    // Prevenir múltiplos cliques
    const submitButton = e.target.querySelector('button[type="submit"]')
    if (submitButton) {
      submitButton.disabled = true
      submitButton.textContent = 'Salvando...'
    }
    
    // Campo cliente agora é opcional na versão web
    // Removida validação obrigatória para permitir presença sem cliente específico
    
    // Validação: veículo é obrigatório
    if (!presencaFormData.veiculo_id) {
      showNotification('Por favor, selecione um carro/veículo.', 'error')
      return
    }
    
    // Validação: pelo menos um colaborador deve ser selecionado
    if (!presencaFormData.colaboradores || presencaFormData.colaboradores.length === 0) {
      showNotification('Por favor, selecione pelo menos um colaborador.', 'error')
      return
    }
    
    try {
      let presencaId
      
      // Preparar dados para salvar
      const dadosParaSalvar = {
        data_presenca: presencaFormData.data_presenca,
        data_cadastro_preenchido: presencaFormData.data_cadastro_preenchido,
        cliente_id: presencaFormData.cliente_id,
        equipe_id: presencaFormData.equipe_id,
        veiculo_id: presencaFormData.veiculo_id,
        km_inicial: presencaFormData.km_inicial,
        observacoes: presencaFormData.observacoes
      }
      
      if (editingPresenca) {
        // Atualizar presença existente
        const { error } = await supabase
          .from('presenca')
          .update(dadosParaSalvar)
          .eq('id', editingPresenca.id)
        
        if (error) throw error
        
        presencaId = editingPresenca.id
        showNotification('Presença atualizada com sucesso!', 'success')
      } else {
        // Criar nova presença
        const { data, error } = await supabase
          .from('presenca')
          .insert([dadosParaSalvar])
          .select('id')
        
        if (error) throw error
        
        presencaId = data[0].id
        showNotification('Presença cadastrada com sucesso!', 'success')
      }
      
      // Salvar colaboradores na tabela presenca_colaboradores
      if (presencaId && presencaFormData.colaboradores && presencaFormData.colaboradores.length > 0) {
        try {
          // Se for edição, primeiro deletar colaboradores existentes
          if (editingPresenca) {
            const { error: deleteError } = await supabase
              .from('presenca_colaboradores')
              .delete()
              .eq('presenca_id', presencaId)
            
            if (deleteError) {
              console.error('Erro ao deletar colaboradores existentes:', deleteError)
              throw deleteError
            }
          }
          
          // Inserir novos colaboradores
          const colaboradoresData = presencaFormData.colaboradores.map(colaboradorId => ({
            presenca_id: presencaId,
            colaborador_id: colaboradorId,
            presente: true, // Por padrão, todos estão presentes
            observacoes: 'Presente'
          }))
          
          const { error: colaboradoresError } = await supabase
            .from('presenca_colaboradores')
            .insert(colaboradoresData)
          
          if (colaboradoresError) {
            console.error('Erro ao salvar colaboradores:', colaboradoresError)
            throw colaboradoresError
          }
          
  
        } catch (error) {
          console.error('Erro ao salvar colaboradores:', error)
          showNotification('Presença salva, mas houve erro ao salvar colaboradores: ' + error.message, 'warning')
        }
      }
      
      // Fechar o modal automaticamente após salvar com sucesso
      if (presencaModalNaoFechavel) {
        // Se era obrigatório, permitir fechar e fechar automaticamente
        setPresencaModalNaoFechavel(false)
        showNotification('Lista de presença salva com sucesso! Modal será fechado automaticamente.', 'success')
        
        // Fechar o modal automaticamente após 2 segundos para o usuário ver a mensagem
        setTimeout(() => {
          // Fechar modal diretamente sem usar closePresencaForm
          setShowPresencaForm(false)
          setEditingPresenca(null)
          setPresencaFormData({
            data_presenca: '',
            data_cadastro_preenchido: '',
            cliente_id: '',
            equipe_id: '',
            veiculo_id: '',
            km_inicial: '',
            observacoes: '',
            colaboradores: []
          })
        }, 2000)
      } else {
        // Se não era obrigatório, fechar normalmente
        closePresencaForm()
      }
      
      // Reabilitar botão após sucesso
      const submitButton = e.target.querySelector('button[type="submit"]')
      if (submitButton) {
        submitButton.disabled = false
        submitButton.textContent = editingPresenca ? 'Atualizar' : 'Cadastrar' + ' Presença'
      }
      loadPresencas()
    } catch (error) {
      console.error('Erro ao salvar presença:', error)
      showNotification('Erro ao salvar presença: ' + error.message, 'error')
      
      // Reabilitar botão em caso de erro
      const submitButton = e.target.querySelector('button[type="submit"]')
      if (submitButton) {
        submitButton.disabled = false
        submitButton.textContent = editingPresenca ? 'Atualizar' : 'Cadastrar' + ' Presença'
      }
    }
  }
  // Renderizar dashboard
  const renderDashboard = () => {
    // Para instaladores, redirecionar para gestão de instalação
    if (userRole === 'instalador') {
      // O useEffect já deve ter redirecionado, mas caso não tenha, forçar aqui
      if (currentView === 'dashboard') {
        setCurrentView('gestao_instalacao')
        return null
      }
    }
    
    return (
    <div className="container-fluid py-4" style={{backgroundColor: '#f8f9fa', minHeight: '100vh'}}>
      {/* Header do Dashboard - Design Moderno */}
      <div className="row mb-5">
        <div className="col-12">
          <div className="position-relative overflow-hidden rounded-4 shadow-lg dashboard-header gradient-bg" 
               style={{
                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                 padding: '2.5rem',
                 color: 'white',
                 position: 'relative'
               }}>
            
            {/* Elementos decorativos de fundo */}
            <div className="position-absolute top-0 end-0 opacity-25 header-icon" style={{fontSize: '8rem', transform: 'translate(20px, -20px)'}}>
              ⚡
            </div>
            <div className="position-absolute bottom-0 start-0 opacity-25 header-icon" style={{fontSize: '6rem', transform: 'translate(-20px, 20px)'}}>
              🚀
            </div>
            
            {/* Conteúdo principal */}
            <div className="row align-items-center">
              <div className="col-lg-8">
                <div className="mb-3">
                  <img 
                    src="/LogoConectSolar.png" 
                    alt="Logo ConectSolar" 
                    className="mb-3"
                    style={{
                      maxHeight: '80px',
                      width: 'auto',
                      objectFit: 'contain',
                      filter: 'brightness(0) invert(1) drop-shadow(2px 2px 4px rgba(0,0,0,0.3))'
                    }}
                  />
                  <p className="lead mb-0 text-white-75" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.2)'}}>
                    Sistema completo de gestão empresarial com tecnologia de ponta
                  </p>
                </div>
                
                {/* Indicador da empresa do usuário */}
                {userEmpresa && userRole !== USER_ROLES.ADMINISTRADOR && (
                  <div className="mt-3">
                    <span className="badge rounded-pill px-3 py-2 glass-badge" 
                          style={{
                            backgroundColor: 'rgba(255,255,255,0.2)', 
                            color: 'white',
                            border: '1px solid rgba(255,255,255,0.3)',
                            backdropFilter: 'blur(10px)'
                          }}>
                      🏢 <strong>{userEmpresa.empresa}</strong>
                    </span>
                  </div>
                )}
              </div>
              
              <div className="col-lg-4 text-lg-end">
                <div className="text-center text-lg-end">
                  <div className="h4 fw-bold mb-2 text-white" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.2)'}}>
                    🕐 {currentTime.toLocaleDateString('pt-BR', { 
                      weekday: 'long', 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </div>
                  <div className="h5 fw-light text-white-75 mb-3" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.2)'}}>
                    {currentTime.toLocaleTimeString('pt-BR', { 
                      hour: '2-digit', 
                      minute: '2-digit', 
                      second: '2-digit' 
                    })}
                  </div>
                  
                  {/* Status do sistema */}
                  <div className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill glass-badge" 
                       style={{
                         backgroundColor: 'rgba(255,255,255,0.15)',
                         border: '1px solid rgba(255,255,255,0.2)',
                         backdropFilter: 'blur(10px)'
                       }}>
                    <div className="d-inline-block rounded-circle" 
                         style={{
                           width: '8px', 
                           height: '8px', 
                           backgroundColor: '#4ade80',
                           animation: 'pulse 2s infinite'
                         }}></div>
                    <small className="text-white-75 fw-medium">Sistema Online</small>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Barra de progresso decorativa */}
            <div className="position-absolute bottom-0 start-0 w-100" style={{height: '4px'}}>
              <div className="h-100" style={{
                background: 'linear-gradient(90deg, #4ade80 0%, #3b82f6 50%, #8b5cf6 100%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 3s ease-in-out infinite'
              }}></div>
            </div>
          </div>
        </div>
      </div>

      {/* Card Eventos do Calendário - DESTAQUE: primeira seção para usuários com acesso */}
      {security.canAccessMenu(userRole, 'calendario', permissoesMenusCache, hasPermissoesCustomizadas) && (
      <div className="row g-4 mb-4">
        <div className="col-12">
          <DashboardEventosCalendario
            eventos={eventosCalendario}
            loading={loadingEventosCalendario}
            filtro={filtroEventosCalendario}
            onFiltroChange={setFiltroEventosCalendario}
            onAbrirCalendario={() => setCurrentView('calendario')}
          />
        </div>
      </div>
      )}

      {security.canAccessMenu(userRole, 'monitoramento', permissoesMenusCache, hasPermissoesCustomizadas) && (
        <MonitoramentoAlertas
          userEmpresa={userEmpresa}
          onAbrirMonitoramento={() => setCurrentView('monitoramento')}
        />
      )}
      
      {/* Cards de Estatísticas */}
      <div className="row g-3 mb-4">
        {/* Card Total de Clientes - apenas para usuários com acesso a clientes */}
            {security.canAccessMenu(userRole, 'clientes', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div className="card border-0 shadow h-100" style={{backgroundColor: '#e3f2fd', borderLeft: '4px solid #2196f3'}}>
              <div className="card-body text-center">
                <div className="display-6 mb-2" style={{color: '#2196f3'}}>👥</div>
                <h2 className="card-title mb-1" style={{color: '#1976d2'}}>{clientes.length}</h2>
                <p className="card-text mb-2 text-dark">Total de Clientes</p>
                <small className="text-secondary">📈 Ativos no sistema</small>
              </div>
            </div>
          </div>
        )}
        
        {/* Card Presenças Registradas - apenas para usuários com acesso a presença */}
        {security.canAccessMenu(userRole, 'presenca', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div className="card border-0 shadow h-100" style={{backgroundColor: '#e8f5e8', borderLeft: '4px solid #4caf50'}}>
              <div className="card-body text-center">
                <div className="display-6 mb-2" style={{color: '#4caf50'}}>📋</div>
                <h2 className="card-title mb-1" style={{color: '#388e3c'}}>{presencas.length}</h2>
                <p className="card-text mb-2 text-dark">Presenças Registradas</p>
                <small className="text-secondary">📅 Controle de frequência</small>
              </div>
            </div>
          </div>
        )}
        
        {/* Card Colaboradores - apenas para usuários com acesso a colaboradores */}
        {security.canAccessMenu(userRole, 'colaboradores', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div className="card border-0 shadow h-100" style={{backgroundColor: '#e0f2f1', borderLeft: '4px solid #00bcd4'}}>
              <div className="card-body text-center">
                <div className="display-6 mb-2" style={{color: '#00bcd4'}}>👷</div>
                <h2 className="card-title mb-1" style={{color: '#0097a7'}}>{colaboradores.length}</h2>
                <p className="card-text mb-2 text-dark">Colaboradores</p>
                <small className="text-secondary">⚡ Equipe ativa</small>
              </div>
            </div>
          </div>
        )}
        
        {/* Card Veículos - apenas para usuários com acesso a veículos */}
        {security.canAccessMenu(userRole, 'veiculos', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div className="card border-0 shadow h-100" style={{backgroundColor: '#fff3e0', borderLeft: '4px solid #ff9800'}}>
              <div className="card-body text-center">
                <div className="display-6 mb-2" style={{color: '#ff9800'}}>🚗</div>
                <h2 className="card-title mb-1" style={{color: '#f57c00'}}>{veiculos.length}</h2>
                <p className="card-text mb-2 text-dark">Veículos</p>
                <small className="text-secondary">🛣️ Frota disponível</small>
              </div>
            </div>
          </div>
        )}
        
        {/* Card Cargos - apenas para usuários com acesso a cargos */}
        {security.canAccessMenu(userRole, 'cargos', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div className="card border-0 shadow h-100" style={{backgroundColor: '#f3e5f5', borderLeft: '4px solid #9c27b0'}}>
              <div className="card-body text-center">
                <div className="display-6 mb-2" style={{color: '#9c27b0'}}>🎯</div>
                <h2 className="card-title mb-1" style={{color: '#7b1fa2'}}>{cargos.length}</h2>
                <p className="card-text mb-2 text-dark">Cargos</p>
                <small className="text-secondary">👔 Estrutura organizacional</small>
              </div>
            </div>
          </div>
        )}
        
        {/* Card Propostas - apenas para usuários com acesso a consulta de propostas */}
        {security.canAccessMenu(userRole, 'consulta_propostas', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div className="card border-0 shadow h-100" style={{backgroundColor: '#f3e5f5', borderLeft: '4px solid #9c27b0'}}>
              <div className="card-body text-center">
                <div className="display-6 mb-2" style={{color: '#9c27b0'}}>📋</div>
                <h2 className="card-title mb-1" style={{color: '#7b1fa2'}}>{propostas.length}</h2>
                <p className="card-text mb-2 text-dark">Propostas</p>
                <small className="text-secondary">💰 Propostas geradas</small>
              </div>
            </div>
          </div>
        )}

        {/* Card Usuários - apenas para administradores */}
        {security.canManageUsers(userRole) && (
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div className="card border-0 shadow h-100" style={{backgroundColor: '#fafafa', borderLeft: '4px solid #607d8b'}}>
              <div className="card-body text-center">
                <div className="display-6 mb-2" style={{color: '#607d8b'}}>👤</div>
                <h2 className="card-title mb-1" style={{color: '#455a64'}}>{usuarios.length}</h2>
                <p className="card-text mb-2 text-dark">Usuários</p>
                <small className="text-secondary">🔐 Acesso ao sistema</small>
              </div>
            </div>
          </div>
        )}

        {/* Card Vistorias Atribuídas - para usuários com acesso a vistorias */}
        {security.canAccessMenu(userRole, 'vistorias', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
            <div className="card border-0 shadow h-100" style={{backgroundColor: '#fff3e0', borderLeft: '4px solid #ff9800'}}>
              <div className="card-body text-center">
                <div className="display-6 mb-2" style={{color: '#ff9800'}}>📋</div>
                <h2 className="card-title mb-1" style={{color: '#f57c00'}}>{vistorias.length}</h2>
                <p className="card-text mb-2 text-dark">Vistorias Atribuídas</p>
                <small className="text-secondary">📊 Total de vistorias sob sua responsabilidade</small>
              </div>
            </div>
          </div>
        )}
      </div>
      
      {/* Seções do Dashboard */}
      <div className="row g-4 mb-4">
        {/* Ações Rápidas */}
        <div className="col-lg-6">
          <div className="card border-0 shadow h-100" style={{backgroundColor: 'white'}}>
            <div className="card-header border-0" style={{backgroundColor: '#f8f9fa'}}>
              <h5 className="card-title mb-0 text-dark">🚀 Ações Rápidas</h5>
            </div>
            <div className="card-body">
              <div className="row g-2">
                {userRole === 'instalador' ? (
                  /* Para instaladores, mostrar apenas botão de gestão de instalação */
                  <div className="col-12">
                    <button 
                      onClick={() => navigateToView('gestao_instalacao', true)} 
                      className="btn w-100 py-3" 
                      style={{backgroundColor: '#fff3e0', color: '#e65100', border: '1px solid #ffe0b2'}}
                    >
                      <div className="h4 mb-2">⚡</div>
                      <span>Gestão de Instalação</span>
                    </button>
                  </div>
                ) : (
                  <>
                {security.canAccessMenu(userRole, 'clientes_ii', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => navigateToView('clientes_ii', true)} 
                      className="btn w-100 py-3" 
                      style={{backgroundColor: '#f3e5f5', color: '#7b1fa2', border: '1px solid #e1bee7'}}
                    >
                      <div className="h4 mb-2">💼</div>
                      <span>Gestão de Clientes</span>
                    </button>
                  </div>
                )}
                
                {security.canAccessMenu(userRole, 'ordem_servicos', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => navigateToView('ordem_servicos', true)} 
                      className="btn w-100 py-3" 
                      style={{backgroundColor: '#e8f5e9', color: '#2e7d32', border: '1px solid #c8e6c9'}}
                    >
                      <div className="h4 mb-2">🔧</div>
                      <span>Ordem de Serviços</span>
                    </button>
                  </div>
                )}

                {security.canAccessMenu(userRole, 'servicos', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => navigateToView('servicos', true)} 
                      className="btn w-100 py-3" 
                      style={{backgroundColor: '#f5f5f5', color: '#616161', border: '1px solid #e0e0e0'}}
                    >
                      <div className="h4 mb-2">📄</div>
                      <span>Serviços</span>
                    </button>
                  </div>
                )}
                
                {security.canAccessMenu(userRole, 'gestao_instalacao', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => navigateToView('gestao_instalacao', true)} 
                      className="btn w-100 py-3" 
                      style={{backgroundColor: '#fff3e0', color: '#e65100', border: '1px solid #ffe0b2'}}
                    >
                      <div className="h4 mb-2">⚡</div>
                      <span>Gestão Instalação</span>
                    </button>
                  </div>
                )}
                
                {security.canAccessMenu(userRole, 'vistorias', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => navigateToView('vistorias', true)} 
                      className="btn w-100 py-3" 
                      style={{backgroundColor: '#fff3e0', color: '#e65100', border: '1px solid #ffe0b2'}}
                    >
                      <div className="h4 mb-2">📋</div>
                      <span>Vistorias</span>
                    </button>
                  </div>
                )}
                
                {security.canAccessMenu(userRole, 'presenca', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => setCurrentView('presenca')} 
                      className="btn w-100 py-3"
                      style={{backgroundColor: '#e8f5e8', color: '#388e3c', border: '1px solid #c8e6c9'}}
                    >
                      <div className="h4 mb-2">📅</div>
                      <span>Nova Presença</span>
                    </button>
                  </div>
                )}
                
                {security.canAccessMenu(userRole, 'colaboradores', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => setCurrentView('colaboradores')} 
                      className="btn w-100 py-3"
                      style={{backgroundColor: '#e0f2f1', color: '#0097a7', border: '1px solid #b2dfdb'}}
                    >
                      <div className="h4 mb-2">👷</div>
                      <span>Novo Colaborador</span>
                    </button>
                  </div>
                )}
                
                {security.canAccessMenu(userRole, 'pagamento_colaborador', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => setCurrentView('pagamento-colaboradores')} 
                      className="btn w-100 py-3"
                      style={{backgroundColor: '#fff3e0', color: '#f57c00', border: '1px solid #ffcc02'}}
                    >
                      <div className="h4 mb-2">💰</div>
                      <span>Pagamento Colaboradores</span>
                    </button>
                  </div>
                )}
                
                {security.canAccessMenu(userRole, 'adiantamento', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => setCurrentView('adiantamento')} 
                      className="btn w-100 py-3"
                      style={{backgroundColor: '#e8f5e8', color: '#2e7d32', border: '1px solid #4caf50'}}
                    >
                      <div className="h4 mb-2">💸</div>
                      <span>Lançamentos</span>
                    </button>
                  </div>
                )}
                
                {security.canAccessMenu(userRole, 'kit_solar', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => setCurrentView('kit_solar')} 
                      className="btn w-100 py-3"
                      style={{backgroundColor: '#fff8e1', color: '#f57c00', border: '1px solid #ffcc02'}}
                    >
                      <div className="h4 mb-2">🔋</div>
                      <span>Kit Solar</span>
                    </button>
                  </div>
                )}
                
                {security.canAccessMenu(userRole, 'monte_seu_kit', permissoesMenusCache, hasPermissoesCustomizadas) && (
                  <div className="col-6">
                    <button 
                      onClick={() => setCurrentView('monte_seu_kit')} 
                      className="btn w-100 py-3"
                      style={{backgroundColor: '#e8f5e8', color: '#2e7d32', border: '1px solid #4caf50'}}
                    >
                      <div className="h4 mb-2">🔧</div>
                      <span>Monte seu Kit</span>
                    </button>
                  </div>
                )}
                
                {security.canManageUsers(userRole) && (
                  <div className="col-6">
                    <button 
                      onClick={() => setCurrentView('usuarios')} 
                      className="btn w-100 py-3"
                      style={{backgroundColor: '#fafafa', color: '#455a64', border: '1px solid #eceff1'}}
                    >
                      <div className="h4 mb-2">👤</div>
                      <span>Novo Usuário</span>
                    </button>
                  </div>
                )}
                
                {/* Botão Calculadora Solar - disponível para todos */}
        {security.canAccessMenu(userRole, 'calculadora_solar', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-6">
            <button 
              onClick={() => setCurrentView('calculadora_solar')} 
              className="btn w-100 py-3"
              style={{backgroundColor: '#fff8e1', color: '#ff8f00', border: '1px solid #ffb74d'}}
            >
              <div className="h4 mb-2">☀️</div>
              <span>Calculadora Solar</span>
            </button>
          </div>
        )}

        {/* Botão Calendário */}
        {security.canAccessMenu(userRole, 'calendario', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-6">
            <button 
              onClick={() => setCurrentView('calendario')} 
              className="btn w-100 py-3"
              style={{backgroundColor: '#e8f5e9', color: '#2e7d32', border: '1px solid #81c784'}}
            >
              <div className="h4 mb-2">📅</div>
              <span>Calendário</span>
            </button>
          </div>
        )}
                
        {/* Botão Valores de Kit - apenas para administradores e administrativos */}
        {security.canAccessMenu(userRole, 'valor_kit', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-6">
            <button
              onClick={() => setShowValorKitManager(true)}
              className="btn w-100 py-3"
              style={{backgroundColor: '#f3e5f5', color: '#7b1fa2', border: '1px solid #ba68c8'}}
            >
              <div className="h4 mb-2">💰</div>
              <span>Valores de Kit</span>
            </button>
          </div>
        )}

        {/* Botão Kits Personalizados */}
        {security.canAccessMenu(userRole, 'kits_personalizados', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-6">
            <button
              onClick={() => setShowKitsPersonalizados(true)}
              className="btn w-100 py-3"
              style={{backgroundColor: '#fff7ed', color: '#c2410c', border: '1px solid #fdba74'}}
            >
              <div className="h4 mb-2">🔧</div>
              <span>Kits Personalizados</span>
            </button>
          </div>
        )}

        {security.canAccessMenu(userRole, 'kit_fornecedores', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-6">
            <button
              onClick={() => handleNavItemClick('kit_fornecedores')}
              className="btn w-100 py-3"
              style={{backgroundColor: '#fffbeb', color: '#b45309', border: '1px solid #fcd34d'}}
            >
              <div className="h4 mb-2">🚚</div>
              <span>Kit Fornecedores</span>
            </button>
          </div>
        )}

        {/* Botão Consulta de Propostas - disponível para todos */}
        {security.canAccessMenu(userRole, 'consulta_propostas', permissoesMenusCache, hasPermissoesCustomizadas) && (
          <div className="col-6">
            <button
              onClick={() => setShowConsultaPropostas(true)}
              className="btn w-100 py-3"
              style={{backgroundColor: '#e3f2fd', color: '#1976d2', border: '1px solid #90caf9'}}
            >
              <div className="h4 mb-2">📋</div>
              <span>Consulta de Propostas</span>
            </button>
          </div>
        )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        
        {/* Informações do Sistema */}
        <div className="col-lg-6">
          <div className="card border-0 shadow h-100" style={{backgroundColor: 'white'}}>
            <div className="card-header border-0" style={{backgroundColor: '#f8f9fa'}}>
              <h5 className="card-title mb-0 text-dark">ℹ️ Informações do Sistema</h5>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-12">
                  <div className="d-flex align-items-center p-3 rounded" style={{backgroundColor: '#f8f9fa'}}>
                    <div className="h3 me-3" style={{color: '#2196f3'}}>🔒</div>
                    <div>
                      <h6 className="mb-1 text-dark">Segurança</h6>
                      <small className="text-secondary">Sistema protegido com autenticação avançada</small>
                    </div>
                  </div>
                </div>
                
                <div className="col-12">
                  <div className="d-flex align-items-center p-3 rounded" style={{backgroundColor: '#f8f9fa'}}>
                    <div className="h3 me-3" style={{color: '#4caf50'}}>📱</div>
                    <div>
                      <h6 className="mb-1 text-dark">Responsivo</h6>
                      <small className="text-secondary">Interface adaptável para todos os dispositivos</small>
                    </div>
                  </div>
                </div>
                
                <div className="col-12">
                  <div className="d-flex align-items-center p-3 rounded" style={{backgroundColor: '#f8f9fa'}}>
                    <div className="h3 me-3" style={{color: '#ff9800'}}>⚡</div>
                    <div>
                      <h6 className="mb-1 text-dark">Performance</h6>
                      <small className="text-secondary">Otimizado para máxima velocidade</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Atividade Recente */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow" style={{backgroundColor: 'white'}}>
            <div className="card-header border-0" style={{backgroundColor: '#f8f9fa'}}>
              <h5 className="card-title mb-0 text-dark">📊 Atividade Recente</h5>
            </div>
            <div className="card-body">
              <div className="row g-3">
                {userRole === 'instalador' ? (
                  /* Para instaladores, mostrar apenas informações de gestão de instalação */
                  <div className="col-12">
                    <div className="text-center p-3">
                      <div className="h2 mb-2" style={{color: '#ff9800'}}>⚡</div>
                      <h4 style={{color: '#f57c00'}}>
                        Gestão de Instalação
                      </h4>
                      <p className="text-secondary mb-0">Acesse a tela de gestão para gerenciar instalações</p>
                      <small className="text-muted">Clique no menu lateral para acessar</small>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="col-md-4">
                      <div className="text-center p-3">
                        <div className="h2 mb-2" style={{color: '#2196f3'}}>👥</div>
                        <h4 style={{color: '#1976d2'}}>
                          {clientes.filter(c => c.status_info?.status === 'Pendente').length}
                        </h4>
                        <p className="text-secondary mb-0">Clientes Pendentes</p>
                      </div>
                    </div>
                    
                    <div className="col-md-4">
                      <div className="text-center p-3">
                        <div className="h2 mb-2" style={{color: '#4caf50'}}>📅</div>
                        <h4 style={{color: '#388e3c'}}>
                          {presencas.filter(p => {
                            const presencaDate = new Date(p.data_presenca);
                            const today = new Date();
                            const diffTime = Math.abs(today - presencaDate);
                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                            return diffDays <= 7;
                          }).length}
                        </h4>
                        <p className="text-secondary mb-0">Presenças Esta Semana</p>
                      </div>
                    </div>
                    
                    <div className="col-md-4">
                      <div className="text-center p-3">
                        <div className="h2 mb-2" style={{color: '#00bcd4'}}>👷</div>
                        <h4 style={{color: '#0097a7'}}>
                          {colaboradores.filter(c => c.ativo).length}
                        </h4>
                        <p className="text-secondary mb-0">Colaboradores Ativos</p>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer do Dashboard */}
      <div className="row">
        <div className="col-12">
          <div className="card border-0" style={{backgroundColor: '#f8f9fa'}}>
            <div className="card-body text-center">
              <p className="mb-2 text-dark">
                💡 <strong>Dica:</strong> Use o menu de navegação para acessar todas as funcionalidades do sistema.
              </p>
              <div className="row text-secondary">
                <div className="col-md-6">
                  🔄 Última atualização: {new Date().toLocaleTimeString('pt-BR')}
                </div>
                <div className="col-md-6">
                  👤 Logado como: {user?.nome || user?.email}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
  }
  
  // Renderizar lista de clientes
  const renderClientes = () => {
    // Verificar se o usuário tem permissão para visualizar clientes
    if (!security.canAccessMenu(userRole, 'clientes', permissoesMenusCache, hasPermissoesCustomizadas)) {
      return (
        <div className="menu-content">
          <div className="menu-header">
            <h2>Instalação Realizadas</h2>
            <button onClick={goBack} className="back-button">
              ← Voltar ao Dashboard
            </button>
          </div>
          
          <div className="access-denied-message">
            <div className="access-denied-icon">🚫</div>
            <h3>Acesso Negado</h3>
            <p>Você não tem permissão para visualizar esta seção.</p>
            <p>Entre em contato com o administrador para solicitar acesso.</p>
          </div>
        </div>
      )
    }

    return (
      <div className="menu-content">
        <div className="menu-header">
          <h2>Instalação Realizadas</h2>
          {userRole !== 'instalador' && (
            <button onClick={goBack} className="back-button">
              ← Voltar ao Dashboard
            </button>
          )}
        </div>
        
        {userRole === 'administrador' && (
          <div className="clientes-actions">
            <button onClick={openNewClienteForm} className="action-button primary">
              ➕ Nova Instalação
            </button>
          </div>
        )}
        
        {/* Filtros de Pesquisa */}
        <div className="filtros-container">
          <h3>🔍 Filtros de Pesquisa</h3>
          <div className="filtros-grid">
            {/* Filtro por Empresa (dropdown checklist) - Administrador e administrativo privilegiado */}
            {podeFiltrarEmpresaClientes && empresasDisponiveis.length > 0 && (
              <div className="filtro-item filtro-empresa-admin">
                <label className="filtro-empresa-label">
                  🏢 Filtrar por Empresa:
                </label>
                <div className="filtro-empresa-dropdown" ref={empresaFiltroDropdownRef}>
                  <button
                    type="button"
                    className="filtro-empresa-dropdown-toggle"
                    onClick={() => setEmpresaFiltroDropdownAberto((aberto) => !aberto)}
                  >
                    <span>
                      {empresasFiltroMultiClientes.length === 0
                        ? 'Todas as Empresas'
                        : empresasFiltroMultiClientes.length === empresasDisponiveis.length
                          ? 'Todas as Empresas'
                          : `${empresasFiltroMultiClientes.length} empresa(s) selecionada(s)`}
                    </span>
                    <span className={`filtro-empresa-dropdown-caret ${empresaFiltroDropdownAberto ? 'aberto' : ''}`}>▾</span>
                  </button>
                  {empresaFiltroDropdownAberto && (
                    <div className="filtro-empresa-dropdown-menu">
                      <label className="filtro-empresa-check-item filtro-empresa-check-todas">
                        <input
                          type="checkbox"
                          checked={empresasFiltroMultiClientes.length === empresasDisponiveis.length && empresasDisponiveis.length > 0}
                          onChange={(e) => setEmpresasFiltroMultiClientes(
                            e.target.checked ? empresasDisponiveis.map((emp) => emp.id) : []
                          )}
                        />
                        <span>Todas as Empresas</span>
                      </label>
                      {empresasDisponiveis.map((empresa) => (
                        <label key={empresa.id} className="filtro-empresa-check-item">
                          <input
                            type="checkbox"
                            checked={empresasFiltroMultiClientes.includes(empresa.id)}
                            onChange={(e) => setEmpresasFiltroMultiClientes(
                              e.target.checked
                                ? [...empresasFiltroMultiClientes, empresa.id]
                                : empresasFiltroMultiClientes.filter((id) => id !== empresa.id)
                            )}
                          />
                          <span>{empresa.empresa}</span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
                <small className="filtro-empresa-info">
                  {empresasFiltroMultiClientes.length > 0 && empresasFiltroMultiClientes.length < empresasDisponiveis.length
                    ? `Mostrando: ${empresasFiltroMultiClientes.length} empresa(s) selecionada(s)`
                    : 'Mostrando clientes de todas as empresas'}
                </small>
              </div>
            )}
            
            {/* Filtro de Status - Disponível para todos os usuários */}
            {statusClientes.length > 0 && (
              <div className="filtro-item filtro-status-todos">
                <label htmlFor="filtro-status" className="filtro-status-label">
                  📊 Filtrar por Status:
                </label>
                <select
                  id="filtro-status"
                  className="filtro-status-select"
                  value={statusFiltroClientes}
                  onChange={(e) => setStatusFiltroClientes(e.target.value)}
                >
                  <option value="">Todos os Status</option>
                  {statusClientes.map((status) => (
                    <option key={status.id} value={status.id}>
                      {status.status}
                    </option>
                  ))}
                </select>
                <small className="filtro-status-info">
                  {statusFiltroClientes && statusFiltroClientes !== ''
                    ? `Filtrando: ${statusClientes.find(s => s.id === parseInt(statusFiltroClientes))?.status || 'N/A'}`
                    : 'Mostrando clientes com todos os status'}
                </small>
              </div>
            )}
            
            <div className="filtro-item">
              <label htmlFor="filtro-nome">Nome do Cliente:</label>
              <input
                type="text"
                id="filtro-nome"
                value={filtrosCliente.nome_cliente}
                onChange={(e) => setFiltrosCliente({...filtrosCliente, nome_cliente: e.target.value})}
                placeholder="Digite o nome do cliente"
              />
            </div>
            
            {userRole !== 'instalador' && (
              <>
                <div className="filtro-item">
                  <label htmlFor="filtro-data-inicio">Data de Instalação - Início:</label>
                  <input
                    type="date"
                    id="filtro-data-inicio"
                    value={filtrosCliente.dataInicio}
                    onChange={(e) => setFiltrosCliente({...filtrosCliente, dataInicio: e.target.value})}
                  />
                </div>
                
                <div className="filtro-item">
                  <label htmlFor="filtro-data-fim">Data de Instalação - Fim:</label>
                  <input
                    type="date"
                    id="filtro-data-fim"
                    value={filtrosCliente.dataFim}
                    onChange={(e) => setFiltrosCliente({...filtrosCliente, dataFim: e.target.value})}
                  />
                </div>
                
                <div className="filtro-item">
                  <label htmlFor="filtro-tipo-servico">Tipo de Serviço:</label>
                  <select
                    id="filtro-tipo-servico"
                    value={filtrosCliente.tipoServicoId}
                    onChange={(e) => setFiltrosCliente({...filtrosCliente, tipoServicoId: e.target.value})}
                  >
                    <option value="">Todos os tipos</option>
                    {tiposServico.map((tipo) => (
                      <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
                    ))}
                  </select>
                </div>
              </>
            )}
          </div>
        </div>
        
        <div className="clientes-list">
          <h3>Instalações Realizadas ({clientesFiltrados.length} de {clientes.length})</h3>
          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Nome do Cliente</th>
                  <th>Data da Instalação</th>
                  <th>Tipo de Serviço</th>
                  <th>Tipo de Padrão</th>
                  <th>Quantidade de Módulos</th>
                  <th>Deslocamento</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {clientesFiltrados.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="no-data">
                      {clientes.length === 0 ? 'Nenhum cliente cadastrado ainda.' : 'Nenhum cliente encontrado com os filtros aplicados.'}
                    </td>
                  </tr>
                ) : (
                  clientesFiltrados.map((cliente) => (
                    <tr key={cliente.id}>
                      <td>
                        <button 
                          onClick={() => openClienteModal(cliente)} 
                          className="cliente-name-button"
                          title="Clique para ver detalhes do cliente"
                        >
                          {cliente.nome_cliente}
                        </button>
                      </td>
                      <td>{formatarData(cliente.data_instalacao)}</td>
                      <td>{cliente.tipo_servico?.nome || 'N/A'}</td>
                      <td>{cliente.tipo_padrao?.nome || 'N/A'}</td>
                      <td>{cliente.quantidade_modulos || 'N/A'}</td>
                      <td>{cliente.deslocamento != null && cliente.deslocamento !== '' ? Number(cliente.deslocamento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '–'}</td>
                      <td>
                        <span className={`status-badge status-${cliente.status_info?.status?.toLowerCase() || 'pendente'}`}>
                          {cliente.status_info?.status === 'Pendente' ? '⏳ Pendente' : 
                           cliente.status_info?.status === 'Em andamento' ? '🔄 Em Andamento' : 
                           cliente.status_info?.status === 'Finalizado' ? '✅ Finalizado' : 
                           cliente.status_info?.status === 'Validado' ? '🔍 Validado' : 
                           '⏳ Pendente'}
                        </span>
                      </td>
                      <td>
                        <div className="action-buttons">
                          {/* Botão Iniciar Obra - apenas para clientes Pendentes */}
                          {userRole === 'instalador' && cliente.status_info?.status === 'Pendente' && (
                            <button 
                              onClick={() => handleIniciarObra(cliente)} 
                              className="action-btn small primary"
                              title="Iniciar obra"
                            >
                              🚀 Iniciar Obra
                            </button>
                          )}
                          
                          {/* Botão Finalizar - apenas para clientes Em andamento */}
                          {userRole === 'instalador' && cliente.status_info?.status === 'Em andamento' && (
                            <button 
                              onClick={() => handleFinalizarObra(cliente)} 
                              className="action-btn small success"
                              title="Finalizar obra"
                            >
                              ✅ Finalizar
                            </button>
                          )}
                          
                          {/* Botão para gerenciar PDFs */}
                          <button 
                            onClick={() => openClientePDFs(cliente)} 
                            className="action-btn small info"
                            title="Gerenciar PDFs do cliente"
                          >
                            📄 PDFs
                          </button>

                          {/* Botão para gerar relatório PDF */}
                          <button 
                            onClick={() => gerarRelatorioClientePDF(cliente)} 
                            className="action-btn small warning"
                            title="Gerar relatório PDF com informações e fotos do cliente"
                          >
                            📊 Relatório
                          </button>

                          {/* Botão para visualizar fotos */}
                          <button 
                            onClick={() => openClienteFotos(cliente)} 
                            className="action-btn small success"
                            title="Visualizar fotos do cliente"
                          >
                            📸 Fotos
                          </button>

                          {security.hasPermission(userRole, 'CLIENT_MANAGEMENT', 'EDIT') && (
                            <button 
                              onClick={() => handleEditCliente(cliente)} 
                              className="action-btn small"
                              title="Editar cliente"
                            >
                              ✏️ Editar
                            </button>
                          )}
                          
                          {security.canRemoveClient(userRole) && (
                            <button 
                              onClick={() => handleDeleteCliente(cliente)} 
                              className="action-btn small danger"
                              title="Excluir cliente"
                            >
                              🗑️ Remover
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
  // Renderizar lista de colaboradores
  const renderColaboradores = () => (
    <div className="menu-content">
      <div className="menu-header">
        <h2>Gerenciamento de Colaboradores</h2>
        <button onClick={() => setCurrentView('dashboard')} className="back-button">
          ← Voltar ao Dashboard
        </button>
      </div>
      
             <div className="colaboradores-actions">
         <button onClick={() => {
           // Garantir que os cargos e tipos de pagamento estejam carregados antes de abrir o formulário
           if (cargos.length === 0) {
             loadCargos()
           }
           if (tiposPagamento.length === 0) {
             loadTiposPagamento()
           }
           setShowColaboradorForm(true)
         }} className="action-button primary">
           ➕ Novo Colaborador
         </button>
       </div>
      
      <div className="colaboradores-list">
        <h3>Colaboradores ({colaboradores.length})</h3>
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Cargo</th>
                <th>Email</th>
                <th>Chave PIX</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {colaboradores.length === 0 ? (
                <tr>
                  <td colSpan="6" className="no-data">
                    Nenhum colaborador cadastrado ainda.
                  </td>
                </tr>
              ) : (
                colaboradores.map((colaborador) => (
                  <tr key={colaborador.id}>
                    <td>{colaborador.nome}</td>
                    <td>{colaborador.cargo}</td>
                    <td>{colaborador.email || 'N/A'}</td>
                    <td>{colaborador.chave_pix || 'N/A'}</td>
                    <td>
                      <span className={`status-badge ${colaborador.ativo ? 'status-ativo' : 'status-inativo'}`}>
                        {colaborador.ativo ? '✅ Ativo' : '❌ Inativo'}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                                                 <button 
                           onClick={() => {
                             // Garantir que os cargos estejam carregados antes de abrir o formulário
                             if (cargos.length === 0) {
                               loadCargos()
                             }
                             handleEditColaborador(colaborador)
                           }} 
                           className="action-btn small"
                           title="Editar colaborador"
                         >
                           ✏️ Editar
                         </button>
                        <button 
                          onClick={() => handleDeleteColaborador(colaborador)} 
                          className="action-btn small danger"
                          title="Excluir colaborador"
                        >
                          🗑️ Remover
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )

  // Renderizar lista de equipes
  const renderEquipes = () => (
    <div className="menu-content">
      <div className="menu-header">
        <h2>Gerenciamento de Equipes</h2>
        <button onClick={() => setCurrentView('dashboard')} className="back-button">
          ← Voltar ao Dashboard
        </button>
      </div>
      
      <div className="equipes-actions">
        <button onClick={() => {
          // Garantir que as empresas estejam carregadas antes de abrir o formulário
          if (empresas.length === 0) {
            loadEmpresas()
          }
          // Garantir que colaboradores estejam carregados para o dropdown de líder
          if (colaboradores.length === 0) {
            loadColaboradores()
          }
          setEquipeFormData({
            nome: '',
            descricao: '',
            ativo: true,
            empresa_id: userRole === USER_ROLES.ADMINISTRADOR ? '' : userEmpresa?.id,
            lider_equipe: '',
            telefone: '',
            exibir_presenca: true,
            exibir_baixa: true,
            id_formularios_baixa: 1,
            multiequipes: false
          })
          loadColaboradores() // ✅ Carregar colaboradores para o dropdown
          loadFormulariosBaixa() // ✅ Carregar formulários de baixa para o dropdown
          setShowEquipeForm(true)
        }} className="action-button primary">
          ➕ Nova Equipe
        </button>
        

      </div>
      
      <div className="equipes-list">
        <h3>Equipes ({equipes.length})</h3>
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Descrição</th>
                <th>Empresa</th>
                <th>Líder</th>
                <th>Telefone</th>
                <th>Formulário</th>
                <th>Multiequipes</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {equipes.length === 0 ? (
                <tr>
                  <td colSpan="9" className="no-data">
                    Nenhuma equipe cadastrada ainda.
                  </td>
                </tr>
              ) : (
                equipes.map((equipe) => (
                  <tr key={equipe.id}>
                    <td>{equipe.nome}</td>
                    <td>{equipe.descricao || 'N/A'}</td>
                    <td>{equipe.empresa_nome || 'N/A'}</td>
                    <td>{equipe.lider_nome || 'N/A'}</td>
                    <td>{equipe.telefone || 'N/A'}</td>
                    <td>
                      <span className="formulario-badge">
                        {equipe.formulario_baixa_nome || 'N/A'}
                      </span>
                    </td>
                    <td>{equipe.multiequipes ? '✅ Sim' : '—'}</td>
                    <td>
                      <span className={`status-badge ${equipe.ativo ? 'status-ativo' : 'status-inativo'}`}>
                        {equipe.ativo ? '✅ Ativa' : '❌ Inativa'}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button 
                          onClick={() => handleEditEquipe(equipe)} 
                          className="action-btn small"
                          title="Editar equipe"
                        >
                          ✏️ Editar
                        </button>
                        <button 
                          onClick={() => handleDeleteEquipe(equipe)} 
                          className="action-btn small danger"
                          title="Excluir equipe"
                        >
                          🗑️ Remover
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )

  // Renderizar lista de cargos
  const renderCargos = () => (
    <div className="menu-content">
      <div className="menu-header">
        <h2>Gerenciamento de Cargos</h2>
        <button onClick={() => setCurrentView('dashboard')} className="back-button">
          ← Voltar ao Dashboard
        </button>
      </div>
      
             <div className="cargos-actions">
         <button onClick={() => setShowCargoForm(true)} className="action-button primary">
           ➕ Novo Cargo
         </button>
         {!isAdministrador() && (
           <div className="security-notice">
             <span className="security-icon">🔒</span>
             <span>Nota: Apenas administradores podem criar cargos de "administrador" e "administrativo"</span>
           </div>
         )}
       </div>
      
      <div className="cargos-list">
        <h3>Cargos ({cargos.length})</h3>
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Cargo</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {cargos.length === 0 ? (
                <tr>
                  <td colSpan="3" className="no-data">
                    Nenhum cargo cadastrado ainda.
                  </td>
                </tr>
              ) : (
                cargos.map((cargo) => (
                  <tr key={cargo.id}>
                    <td>{cargo.cargo}</td>
                    <td>
                      <span className={`status-badge ${cargo.ativo ? 'status-ativo' : 'status-inativo'}`}>
                        {cargo.ativo ? '✅ Ativo' : '❌ Inativo'}
                      </span>
                    </td>
                                         <td>
                       <div className="action-buttons">
                         {podeGerenciarCargo(cargo.cargo) ? (
                           <>
                             <button 
                               onClick={() => handleEditCargo(cargo)} 
                               className="action-btn small"
                               title="Editar cargo"
                             >
                               ✏️ Editar
                             </button>
                             <button 
                               onClick={() => handleDeleteCargo(cargo)} 
                               className="action-btn small danger"
                               title="Excluir cargo"
                             >
                               🗑️ Remover
                             </button>
                           </>
                         ) : (
                           <span className="permission-notice" title="Apenas administradores podem gerenciar este cargo">
                             🔒 Sem permissão
                           </span>
                         )}
                       </div>
                     </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
     // Renderizar lista de veículos
   const renderVeiculos = () => (
     <div className="menu-content">
       <div className="menu-header">
         <h2>Gerenciamento de Veículos</h2>
         <button onClick={() => setCurrentView('dashboard')} className="back-button">
           ← Voltar ao Dashboard
         </button>
       </div>
       
       <div className="veiculos-actions">
         <button onClick={() => setShowVeiculoForm(true)} className="action-button primary">
           ➕ Novo Veículo
         </button>
       </div>
       
       <div className="veiculos-list">
         <h3>Veículos ({veiculos.length})</h3>
         <div className="table-container">
           <table className="data-table">
             <thead>
               <tr>
                 <th>Veículo</th>
                 <th>Placa</th>
                 <th>Status</th>
                 <th>Ações</th>
               </tr>
             </thead>
             <tbody>
               {veiculos.length === 0 ? (
                 <tr>
                   <td colSpan="4" className="no-data">
                     Nenhum veículo cadastrado ainda.
                   </td>
                 </tr>
               ) : (
                 veiculos.map((veiculo) => (
                   <tr key={veiculo.id}>
                     <td>{veiculo.veiculo}</td>
                     <td>{veiculo.placa}</td>
                     <td>
                       <span className={`status-badge ${veiculo.ativo ? 'status-ativo' : 'status-inativo'}`}>
                         {veiculo.ativo ? '✅ Ativo' : '❌ Inativo'}
                       </span>
                     </td>
                     <td>
                       <div className="action-buttons">
                         <button 
                           onClick={() => handleEditVeiculo(veiculo)} 
                           className="action-btn small"
                           title="Editar veículo"
                         >
                           ✏️ Editar
                         </button>
                         <button 
                           onClick={() => handleDeleteVeiculo(veiculo)} 
                           className="action-btn small danger"
                           title="Excluir veículo"
                         >
                           🗑️ Remover
                         </button>
                       </div>
                     </td>
                   </tr>
                 ))
               )}
             </tbody>
           </table>
         </div>
       </div>
     </div>
   )
   
   // Renderizar lista de tipos de serviço
   const renderTiposServico = () => (
     <div className="menu-content">
       <div className="menu-header">
         <h2>Gerenciamento de Tipos de Serviço</h2>
         <button onClick={() => setCurrentView('dashboard')} className="back-button">
           ← Voltar ao Dashboard
         </button>
       </div>
       
       <div className="tipos-servico-actions">
         <button onClick={() => setShowTipoServicoForm(true)} className="action-button primary">
           ➕ Novo Tipo de Serviço
         </button>
       </div>
       
       <div className="tipos-servico-list">
         <h3>Tipos de Serviço ({tiposServico.length})</h3>
         <div className="table-container">
           <table className="data-table">
             <thead>
               <tr>
                 <th>Nome</th>
                 <th>Descrição</th>
                 <th>Valor</th>
                 <th>Status</th>
                 <th>Ações</th>
               </tr>
             </thead>
             <tbody>
               {tiposServico.length === 0 ? (
                 <tr>
                   <td colSpan="5" className="no-data">
                     Nenhum tipo de serviço cadastrado ainda.
                   </td>
                 </tr>
               ) : (
                 tiposServico.map((tipo) => (
                   <tr key={tipo.id}>
                     <td className="tipo-nome">{tipo.nome}</td>
                     <td className="tipo-descricao">
                       {tipo.descricao || <span className="no-data-inline">Sem descrição</span>}
                     </td>
                     <td className="tipo-valor">
                       {tipo.valor_servico 
                         ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(tipo.valor_servico)
                         : 'R$ 0,00'}
                     </td>
                     <td>
                       <span className={`status-badge ${tipo.ativo ? 'status-ativo' : 'status-inativo'}`}>
                         {tipo.ativo ? '✅ Ativo' : '❌ Inativo'}
                       </span>
                     </td>
                     <td>
                       <div className="action-buttons">
                         <button 
                           onClick={() => handleEditTipoServico(tipo)} 
                           className="action-btn small"
                           title="Editar tipo de serviço"
                         >
                           ✏️ Editar
                         </button>
                         <button 
                           onClick={() => handleDeleteTipoServico(tipo)} 
                           className="action-btn small danger"
                           title="Excluir tipo de serviço"
                         >
                           🗑️ Remover
                         </button>
                       </div>
                     </td>
                   </tr>
                 ))
               )}
             </tbody>
           </table>
         </div>
       </div>
     </div>
   )
   
   // Renderizar lista de tipos de padrão
   const renderTiposPadrao = () => (
     <div className="menu-content">
       <div className="menu-header">
         <h2>Gerenciamento de Tipos de Padrão</h2>
         <button onClick={() => setCurrentView('dashboard')} className="back-button">
           ← Voltar ao Dashboard
         </button>
       </div>
       
       <div className="tipos-padrao-actions">
         <button onClick={() => setShowTipoPadraoForm(true)} className="action-button primary">
           ➕ Novo Tipo de Padrão
         </button>
       </div>
       
       <div className="tipos-padrao-list">
         <h3>Tipos de Padrão ({tiposPadrao.length})</h3>
         <div className="table-container">
           <table className="data-table">
             <thead>
               <tr>
                 <th>Nome</th>
                 <th>Status</th>
                 <th>Ações</th>
               </tr>
             </thead>
             <tbody>
               {tiposPadrao.length === 0 ? (
                 <tr>
                   <td colSpan="3" className="no-data">
                     Nenhum tipo de padrão cadastrado ainda.
                   </td>
                 </tr>
               ) : (
                 tiposPadrao.map((tipo) => (
                   <tr key={tipo.id}>
                     <td>{tipo.nome}</td>
                     <td>
                       <span className={`status-badge ${tipo.ativo ? 'status-ativo' : 'status-inativo'}`}>
                         {tipo.ativo ? '✅ Ativo' : '❌ Inativo'}
                       </span>
                     </td>
                     <td>
                       <div className="action-buttons">
                         <button 
                           onClick={() => handleEditTipoPadrao(tipo)} 
                           className="action-btn small"
                           title="Editar tipo de padrão"
                         >
                           ✏️ Editar
                         </button>
                         <button 
                           onClick={() => handleDeleteTipoPadrao(tipo)} 
                           className="action-btn small danger"
                           title="Excluir tipo de padrão"
                         >
                           🗑️ Remover
                         </button>
                       </div>
                     </td>
                   </tr>
                 ))
               )}
             </tbody>
           </table>
         </div>
       </div>
     </div>
   )
   
   // Renderizar tela de medição
   const renderMedicao = () => (
     <div className="menu-content">
       <div className="menu-header">
         <h2>📊 Medição de Clientes</h2>
         <button onClick={() => setCurrentView('dashboard')} className="back-button">
           ← Voltar ao Dashboard
         </button>
       </div>
       
       <div className="medicao-controls">
         <div className="controls-header">
           <h3>📊 Filtros de Medição</h3>
         </div>
         
         <div className="controls-grid">
           {/* Período */}
           <div className="control-group">
             <label className="control-label">📅 Período</label>
             <div className="date-range">
               <div className="date-input-group">
                 <label htmlFor="periodo-inicio" className="date-label">De:</label>
                 <input
                   type="date"
                   id="periodo-inicio"
                   value={medicaoPeriodo.inicio}
                   onChange={(e) => setMedicaoPeriodo(prev => ({ ...prev, inicio: e.target.value }))}
                   className="date-input"
                 />
               </div>
               <div className="date-input-group">
                 <label htmlFor="periodo-fim" className="date-label">Até:</label>
                 <input
                   type="date"
                   id="periodo-fim"
                   value={medicaoPeriodo.fim}
                   onChange={(e) => setMedicaoPeriodo(prev => ({ ...prev, fim: e.target.value }))}
                   className="date-input"
                 />
               </div>
             </div>
           </div>
           
           {/* Tipo de Medição */}
           <div className="control-group">
             <label className="control-label">⚙️ Tipo de Medição</label>
             <div className="select-wrapper">
               <select
                 id="tipo-medicao"
                 value={tipoMedicao}
                 onChange={(e) => setTipoMedicao(e.target.value)}
                 className="elegant-select"
               >
                 <option value="modulos">📦 Módulos</option>
                 <option value="kwp">⚡ Kwp</option>
               </select>
             </div>
           </div>
           
           {/* Botão de Busca */}
           <div className="control-group">
             <label className="control-label">&nbsp;</label>
             <button onClick={loadMedicao} className="search-button">
               <span className="search-icon">🔍</span>
               <span className="search-text">Buscar Dados</span>
             </button>
           </div>
         </div>
       </div>
         
         {security.canExportMedicao(userRole) && (
           <div className="export-controls">
             <button onClick={() => exportarMedicaoCSV()} className="action-button secondary">
               📄 Exportar CSV
             </button>
             <button onClick={() => exportarMedicaoExcel()} className="action-button secondary">
               📊 Exportar Excel
             </button>
           </div>
         )}
         
         <div className="medicao-summary">
         <div className="summary-card">
           <h4>Total de Clientes</h4>
           <span className="summary-value">{medicaoData.length}</span>
         </div>
         <div className="summary-card">
           <h4>Valor Total</h4>
           <span className="summary-value">
             R$ {medicaoData.reduce((sum, item) => sum + item.total, 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
           </span>
         </div>
         <div className="summary-card">
           <h4>Módulos Totais</h4>
           <span className="summary-value">
             {medicaoData.reduce((sum, item) => sum + item.qtd_modulos, 0)}
           </span>
         </div>
         {tipoMedicao === 'modulos' && (
           <div className="summary-card compras-card">
             <h4>Total de Compras</h4>
             <span className="summary-value compras-value">
               R$ {medicaoData.reduce((sum, item) => sum + (item.valor_compras || 0), 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
             </span>
           </div>
         )}
       </div>
       
       <div className="medicao-list">
         <div className="medicao-header">
           <h3>Dados de Medição ({medicaoData.length})</h3>
           {medicaoData.length > 0 && (
             <button 
               onClick={gerarRecibosPDF} 
               className="action-button primary"
               title="Gerar recibos em PDF para todos os clientes"
             >
               📄 Gerar Recibos PDF
             </button>
           )}
         </div>
         {medicaoLoading ? (
           <div className="loading-container">
             <div className="loading-spinner"></div>
             <p>Carregando dados de medição...</p>
           </div>
         ) : (
           <div className="medicao-table-container">
             <table className="data-table medicao-table">
               <thead>
                 <tr>
                   <th>CLIENTE</th>
                   <th>DATA DE INSTALAÇÃO</th>
                   <th>TIPO DE SERVIÇO</th>
                   <th>QTD MÓDULOS</th>
                   <th>KWP</th>
                   <th>PADRÃO</th>
                   <th>CONFIG. INVERSOR</th>
                   <th>DESLOCAMENTO</th>
                   <th>NOTA MATERIAL</th>
                   <th>OBRA CIVIL</th>
                   <th>VALOR OBRA</th>
                   <th>VALOR MATERIAL</th>
                   {tipoMedicao === 'modulos' && <th>COMPRAS</th>}
                   <th>TOTAL</th>
                   <th>OBSERVAÇÃO</th>
                 </tr>
               </thead>
               <tbody>
                 {medicaoData.length === 0 ? (
                   <tr>
                     <td colSpan={tipoMedicao === 'kwp' ? 14 : 15} className="no-data">
                       Nenhum dado de medição encontrado para o período selecionado.
                     </td>
                   </tr>
                 ) : (
                   medicaoData.map((item) => (
                     <tr key={item.id}>
                       <td>{item.cliente}</td>
                       <td>{item.data ? new Date(item.data).toLocaleDateString('pt-BR') : 'N/A'}</td>
                       <td>{item.tipo_servico}</td>
                       <td className="text-center">{item.qtd_modulos}</td>
                       <td className="text-center">{((item.qtd_modulos || 0) * 0.610).toFixed(2).replace('.', ',')}</td>
                       <td>{item.padrao}</td>
                       <td className="text-center">{item.configuracao_inversor}</td>
                       <td className="text-center">{item.deslocamento_buscar_material}</td>
                       <td className="text-center">{item.nota_material}</td>
                       <td className="text-center">{item.obra_civil}</td>
                       <td className="text-center">
                         <div className="valor-container">
                           <span className="valor-prefix">R$</span>
                           <input
                             type="number"
                             value={item.valor_obra}
                             onChange={(e) => handleEditValorMedicao(item.id, 'valor_obra', parseFloat(e.target.value) || 0)}
                             className="valor-input"
                             min="0"
                             step="0.01"
                             title="Editar valor da obra civil"
                             placeholder="0,00"
                           />
                         </div>
                       </td>
                       <td className="text-center">
                         <div className="valor-container">
                           <span className="valor-prefix">R$</span>
                           <input
                             type="number"
                             value={item.valor_material}
                             onChange={(e) => handleEditValorMedicao(item.id, 'valor_material', parseFloat(e.target.value) || 0)}
                             className="valor-input"
                             min="0"
                             step="0.01"
                             title="Editar valor do material"
                             placeholder="0,00"
                           />
                         </div>
                       </td>
                       {tipoMedicao === 'modulos' && (
                         <td className="text-center compras-value">
                           R$ {item.valor_compras.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                         </td>
                       )}
                       <td className="text-center total-value">
                         R$ {item.total.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                       </td>
                       <td className="observacao-cell">{item.observacao}</td>
                     </tr>
                   ))
                 )}
               </tbody>
             </table>
           </div>
         )}
       </div>
     </div>
   )

  // Renderizar lista de presenças
  const renderPresenca = () => (
    <div className="menu-content presenca-page-modern">
      <div className="presenca-header-modern">
        <div className="presenca-header-content">
          <div className="presenca-title-section">
            <h2 className="presenca-title">📋 Lista de Presença</h2>
            <p className="presenca-subtitle">Total de {presencas.length} registro{presencas.length !== 1 ? 's' : ''}</p>
          </div>
          <button onClick={() => setCurrentView('dashboard')} className="back-button-modern">
            ← Voltar
          </button>
        </div>
      </div>
      
      {security.canAccessMenu(userRole, 'presenca', permissoesMenusCache, hasPermissoesCustomizadas) && (
        <div className="presenca-controls-modern">
          <button onClick={openNewPresencaForm} className="presenca-btn presenca-btn-primary">
            <span className="btn-icon">➕</span>
            <span className="btn-text">Nova Presença</span>
          </button>
          <button onClick={loadPresencas} className="presenca-btn presenca-btn-secondary">
            <span className="btn-icon">🔄</span>
            <span className="btn-text">Atualizar</span>
          </button>
          <button onClick={openImportPresencaModal} className="presenca-btn presenca-btn-success">
            <span className="btn-icon">📊</span>
            <span className="btn-text">Importar</span>
          </button>
        </div>
      )}
      
      {presencas.length === 0 ? (
        <div className="presenca-empty-state">
          <div className="empty-state-icon">📋</div>
          <h3>Nenhuma presença registrada</h3>
          <p>Comece registrando uma nova presença para ver os dados aqui.</p>
          {security.canAccessMenu(userRole, 'presenca', permissoesMenusCache, hasPermissoesCustomizadas) && (
            <button onClick={openNewPresencaForm} className="presenca-btn presenca-btn-primary">
              ➕ Criar Primeira Presença
            </button>
          )}
        </div>
      ) : (
        <>
          {/* Versão Desktop - Tabela */}
          <div className="presenca-table-container-desktop">
            <div className="table-wrapper-modern">
              <table className="presenca-table-modern">
                <thead>
                  <tr>
                    <th>📅 Data</th>
                    <th>🔢 OS</th>
                    <th>👤 Cliente</th>
                    <th>👥 Equipe</th>
                    <th>🚗 Veículo</th>
                    <th>📏 KM</th>
                    <th>👷 Colaboradores</th>
                    <th>📝 Observações</th>
                    <th>⚙️ Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {presencas.map((presenca) => (
                    <tr key={presenca.id} className="presenca-row-modern">
                      <td>
                        <div className="presenca-date-cell">
                          <span className="date-icon">📅</span>
                          <span>{formatarData(presenca.data_presenca)}</span>
                        </div>
                      </td>
                      <td>
                        {presenca.ordem_servico?.id ? (
                          <span className="badge-modern badge-os">
                            OS #{presenca.ordem_servico.id}
                          </span>
                        ) : presenca.id_os ? (
                          <span className="badge-modern badge-os">
                            OS #{presenca.id_os}
                          </span>
                        ) : (
                          <span className="badge-modern badge-empty">Sem OS</span>
                        )}
                      </td>
                      <td>
                        {presenca.cliente?.nome_cliente ? (
                          <div className="cliente-cell-modern">
                            <span className="cliente-icon">👤</span>
                            <span className="cliente-name">{presenca.cliente.nome_cliente}</span>
                          </div>
                        ) : (
                          <span className="badge-modern badge-empty">Sem cliente</span>
                        )}
                      </td>
                      <td>
                        {presenca.equipe?.nome ? (
                          <span className="badge-modern badge-equipe">
                            {presenca.equipe.nome}
                          </span>
                        ) : (
                          <span className="badge-modern badge-empty">Sem equipe</span>
                        )}
                      </td>
                      <td>
                        {presenca.veiculo ? (
                          <div className="veiculo-cell-modern">
                            <span className="veiculo-icon">🚗</span>
                            <div className="veiculo-info">
                              <span className="veiculo-name">{presenca.veiculo.veiculo}</span>
                              <span className="veiculo-placa">{presenca.veiculo.placa}</span>
                            </div>
                          </div>
                        ) : (
                          <span className="badge-modern badge-empty">N/A</span>
                        )}
                      </td>
                      <td>
                        {presenca.km_inicial ? (
                          <span className="km-badge-modern">
                            {presenca.km_inicial.toLocaleString()} km
                          </span>
                        ) : (
                          <span className="badge-modern badge-empty">N/A</span>
                        )}
                      </td>
                      <td>
                        {presenca.colaboradores && presenca.colaboradores.length > 0 ? (
                          <div className="colaboradores-container-modern">
                            {presenca.colaboradores.map((colaboradorId, index) => {
                              const colaborador = colaboradores.find(c => c.id === colaboradorId)
                              return colaborador ? (
                                <span key={colaboradorId} className="colaborador-badge-modern" title={colaborador.nome}>
                                  {colaborador.nome.length > 15 ? colaborador.nome.substring(0, 15) + '...' : colaborador.nome}
                                </span>
                              ) : null
                            })}
                            {presenca.colaboradores.length > 2 && (
                              <span className="colaborador-count-badge">+{presenca.colaboradores.length - 2}</span>
                            )}
                          </div>
                        ) : (
                          <span className="badge-modern badge-empty">Nenhum</span>
                        )}
                      </td>
                      <td>
                        <div className="observacoes-cell-modern">
                          {presenca.observacoes ? (
                            <span className="observacoes-text" title={presenca.observacoes}>
                              {presenca.observacoes.length > 30 ? presenca.observacoes.substring(0, 30) + '...' : presenca.observacoes}
                            </span>
                          ) : (
                            <span className="text-muted">N/A</span>
                          )}
                        </div>
                      </td>
                      <td>
                        <button 
                          onClick={() => {
                            setEditingPresenca(presenca)
                            setPresencaFormData({
                              data_presenca: presenca.data_presenca,
                              data_cadastro_preenchido: presenca.data_cadastro_preenchido,
                              id_os: presenca.id_os || presenca.ordem_servico?.id || '',
                              cliente_id: presenca.cliente_id || '',
                              equipe_id: presenca.equipe_id,
                              veiculo_id: presenca.veiculo_id || '',
                              km_inicial: presenca.km_inicial || '',
                              observacoes: presenca.observacoes,
                              colaboradores: presenca.colaboradores || []
                            })
                            setShowPresencaForm(true)
                          }} 
                          className="action-btn-modern"
                          title="Editar presença"
                        >
                          ✏️
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Versão Mobile - Cards */}
          <div className="presenca-cards-container-mobile">
            {presencas.map((presenca) => (
              <div key={presenca.id} className="presenca-card-mobile">
                <div className="presenca-card-header">
                  <div className="presenca-card-date">
                    <span className="date-icon-mobile">📅</span>
                    <span>{formatarData(presenca.data_presenca)}</span>
                  </div>
                  <button 
                    onClick={() => {
                      setEditingPresenca(presenca)
                      setPresencaFormData({
                        data_presenca: presenca.data_presenca,
                        data_cadastro_preenchido: presenca.data_cadastro_preenchido,
                        id_os: presenca.id_os || presenca.ordem_servico?.id || '',
                        cliente_id: presenca.cliente_id || '',
                        equipe_id: presenca.equipe_id,
                        veiculo_id: presenca.veiculo_id || '',
                        km_inicial: presenca.km_inicial || '',
                        observacoes: presenca.observacoes,
                        colaboradores: presenca.colaboradores || []
                      })
                      setShowPresencaForm(true)
                    }} 
                    className="action-btn-mobile"
                    title="Editar presença"
                  >
                    ✏️
                  </button>
                </div>
                
                <div className="presenca-card-body">
                  <div className="presenca-card-row">
                    <span className="card-label">🔢 Ordem de Serviço:</span>
                    <span className="card-value">
                      {presenca.ordem_servico?.id ? (
                        <span className="badge-modern badge-os">OS #{presenca.ordem_servico.id}</span>
                      ) : presenca.id_os ? (
                        <span className="badge-modern badge-os">OS #{presenca.id_os}</span>
                      ) : (
                        <span className="badge-modern badge-empty">Sem OS</span>
                      )}
                    </span>
                  </div>
                  
                  <div className="presenca-card-row">
                    <span className="card-label">👤 Cliente:</span>
                    <span className="card-value">
                      {presenca.cliente?.nome_cliente || <span className="text-muted">Sem cliente</span>}
                    </span>
                  </div>
                  
                  <div className="presenca-card-row">
                    <span className="card-label">👥 Equipe:</span>
                    <span className="card-value">
                      {presenca.equipe?.nome ? (
                        <span className="badge-modern badge-equipe">{presenca.equipe.nome}</span>
                      ) : (
                        <span className="text-muted">Sem equipe</span>
                      )}
                    </span>
                  </div>
                  
                  <div className="presenca-card-row">
                    <span className="card-label">🚗 Veículo:</span>
                    <span className="card-value">
                      {presenca.veiculo ? (
                        <span>{presenca.veiculo.veiculo} - {presenca.veiculo.placa}</span>
                      ) : (
                        <span className="text-muted">N/A</span>
                      )}
                    </span>
                  </div>
                  
                  <div className="presenca-card-row">
                    <span className="card-label">📏 KM Inicial:</span>
                    <span className="card-value">
                      {presenca.km_inicial ? (
                        <span className="km-badge-modern">{presenca.km_inicial.toLocaleString()} km</span>
                      ) : (
                        <span className="text-muted">N/A</span>
                      )}
                    </span>
                  </div>
                  
                  <div className="presenca-card-row">
                    <span className="card-label">👷 Colaboradores:</span>
                    <div className="card-value">
                      {presenca.colaboradores && presenca.colaboradores.length > 0 ? (
                        <div className="colaboradores-container-modern">
                          {presenca.colaboradores.map((colaboradorId) => {
                            const colaborador = colaboradores.find(c => c.id === colaboradorId)
                            return colaborador ? (
                              <span key={colaboradorId} className="colaborador-badge-modern">
                                {colaborador.nome}
                              </span>
                            ) : null
                          })}
                        </div>
                      ) : (
                        <span className="text-muted">Nenhum</span>
                      )}
                    </div>
                  </div>
                  
                  {presenca.observacoes && (
                    <div className="presenca-card-row">
                      <span className="card-label">📝 Observações:</span>
                      <span className="card-value card-observacoes">{presenca.observacoes}</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  )

  // Carregar dados quando o componente montar (e quando userEmpresa estiver disponível para não-admin/avulso)
  useEffect(() => {
    if (!userRole) return
    // Para não-administrador (incluindo avulso), só carregar clientes quando userEmpresa estiver definido
    const podeCarregarClientes = userRole === USER_ROLES.ADMINISTRADOR || userEmpresa?.id
    if (podeCarregarClientes) {
      loadClientes()
    }

    // Carregar dados necessários para todos os usuários
    setTimeout(() => {
      if (userRole !== 'instalador') {
        loadPresencas()
        loadColaboradores()
        loadUsuarios()
        loadCargos()
        loadVeiculos()
        loadEmpresas()
      } else {
        loadColaboradores()
        loadVeiculos()
      }
    }, 100)
  }, [userRole, userEmpresa?.id])

  // Carregar dados específicos quando a view mudar
  useEffect(() => {
    if (userRole && !isLoading) {
      switch (currentView) {
        case 'clientes':
          loadClientes()
          break
        case 'colaboradores':
          loadColaboradores()
          break
        case 'equipes':
          loadEquipes()
          break
        case 'veiculos':
          loadVeiculos()
          break
        case 'usuarios':
          loadUsuarios()
          break
        case 'presencas':
          loadPresencas()
          break
        case 'medicao':
          loadMedicao()
          break
        default:
          break
      }
    }
  }, [currentView, userRole, isLoading])
  
  // Renderizar conteúdo baseado na view atual
  const renderContent = () => {
    // Usuário PAP: apenas tela Cadastrar Lead
    if (userRole === 'pap') {
      return (
        <CadastrarLeads
          onBack={() => setCurrentView('dashboard')}
          userEmpresa={userEmpresa}
          userId={userId}
          userRole={userRole}
          onLogout={openLogoutConfirmation}
        />
      )
    }

    // Verificar se deve mostrar o gerenciador de valores de kit
    if (showValorKitManager) {
      return (
        <ValorKitManager
          userRole={userRole}
          userEmpresa={userEmpresa}
          permissoesMenusCache={permissoesMenusCache}
          onBack={() => setShowValorKitManager(false)}
        />
      )
    }

    if (showKitsPersonalizados) {
      return (
        <KitsPersonalizados
          userRole={userRole}
          userEmpresa={userEmpresa}
          onBack={() => setShowKitsPersonalizados(false)}
        />
      )
    }

    if (showConsultaPropostas) {
      return (
        <ConsultaPropostas
          userRole={userRole}
          userId={userId}
          userName={userName}
          userEmpresa={userEmpresa}
          onBack={() => setShowConsultaPropostas(false)}
          onIniciarEsteira={(dadosCliente) => {
            setDadosIniciaisCliente(dadosCliente)
            setShowConsultaPropostas(false)
            setCurrentView('clientes_ii')
          }}
        />
      )
    }
    
    // Verificar se deve mostrar a lista de material
    if (showListaMaterial) {
      return (
        <ListaMaterial 
          onBack={handleBackFromListaMaterial}
          userRole={userRole}
          userEmpresa={userEmpresa}
        />
      )
    }
    
    // Verificar se deve mostrar o menu de empresas
    if (showEmpresas) {
      return (
        <Empresas 
          userRole={userRole}
          onClose={() => setShowEmpresas(false)}
        />
      )
    }
    
    // Chamar o switch para renderizar a view atual
    return renderContentSwitch()
  }
  
  // Renderizar conteúdo baseado na view atual (switch case)
  const renderContentSwitch = () => {
    switch (currentView) {
      case 'clientes':
        return renderClientes()
      case 'presenca':
        return renderPresenca()
      case 'colaboradores':
        return renderColaboradores()
      case 'equipes':
        return renderEquipes()
      case 'usuarios':
        return (
          <Usuarios
            onBack={() => setCurrentView('dashboard')}
            userRole={userRole}
            usuarios={usuarios}
            empresas={empresas}
            onNovo={() => {
              loadEmpresas()
              setShowUsuarioForm(true)
            }}
            onEdit={handleEditUsuario}
            onDelete={handleDeleteUsuario}
            onToggleChatZap={handleToggleChatZap}
            onToggleWhatsappGestor={handleToggleWhatsappGestor}
            onToggleWhatsappProposta={handleToggleWhatsappProposta}
          />
        )
      case 'cargos':
        return renderCargos()
      case 'veiculos':
        return renderVeiculos()
      case 'tipos_servico':
        return renderTiposServico()
      case 'tipos_padrao':
        return renderTiposPadrao()
      case 'pagamento_colaborador':
        return <PagamentoColaborador userRole={userRole} userEmpresa={userEmpresa} />
      case 'adiantamento':
        return <Adiantamento userRole={userRole} userEmpresa={userEmpresa} />
      case 'medicao':
        return renderMedicao()
      case 'kit_solar':
        return <KitSolar onBack={() => setCurrentView('dashboard')} userRole={userRole} />
      case 'monte_seu_kit':
        return <MonteSeuKit onBack={() => setCurrentView('dashboard')} userRole={userRole} />
        case 'calculadora_solar':
          return <CalculadoraSolar userRole={userRole} userId={userId} userEmpresa={userEmpresa} />
      case 'kit_fornecedores':
        if (!security.canAccessMenu(userRole, 'kit_fornecedores', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar Kit Fornecedores.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <KitFornecedores
            userEmpresa={userEmpresa}
            userRole={userRole}
            onBack={() => setCurrentView('dashboard')}
          />
        )
      case 'calendario':
        return <Calendario onBack={() => setCurrentView('dashboard')} userId={userId} userName={userName} userRole={userRole} userEmpresa={userEmpresa} />
      case 'vendas':
        return <Vendas onBack={() => setCurrentView('dashboard')} userRole={userRole} userId={userId} userEmpresa={userEmpresa} permissoesMenusCache={permissoesMenusCache} />
      case 'clientes_ii':
        return (
          <ClientesII 
            onBack={() => {
              setCurrentView('dashboard')
              setDadosIniciaisCliente(null) // Limpar dados ao voltar
            }} 
            userRole={userRole} 
            userEmpresa={userEmpresa}
            userId={userId}
            dadosIniciais={dadosIniciaisCliente}
            permissoesMenusCache={permissoesMenusCache}
            hasPermissoesCustomizadas={hasPermissoesCustomizadas}
          />
        )
      case 'cadastrar_clientes':
        return (
          <CadastrarClientes
            onBack={() => setCurrentView('dashboard')}
            userRole={userRole}
            userEmpresa={userEmpresa}
            userId={userId}
            permissoesMenusCache={permissoesMenusCache}
            hasPermissoesCustomizadas={hasPermissoesCustomizadas}
          />
        )
      case 'ordem_servicos':
        if (!security.canAccessMenu(userRole, 'ordem_servicos', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar Ordem de Serviços.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <OrdemServico 
            onBack={() => {
              setCurrentView('dashboard')
              setClienteParaOrdemServico(null)
            }} 
            userRole={userRole} 
            userEmpresa={userEmpresa}
            userId={userId}
            initialClienteParaOS={clienteParaOrdemServico}
            onConsumedInitialCliente={() => setClienteParaOrdemServico(null)}
          />
        )
      case 'servicos':
        return (
          <Servicos 
            onBack={() => setCurrentView('dashboard')} 
            userRole={userRole} 
            userEmpresa={userEmpresa}
            userId={userId}
          />
        )
      case 'propostas_cadastro':
        if (!security.canAccessMenu(userRole, 'propostas_cadastro', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar Propostas (Cadastro).</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <PropostasCadastro 
            onBack={() => setCurrentView('dashboard')} 
            userRole={userRole} 
            userEmpresa={userEmpresa}
          />
        )
      case 'financeiro':
        if (!security.canAccessMenu(userRole, 'financeiro', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar o Financeiro.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <Financeiro
            onBack={() => setCurrentView('dashboard')}
            userRole={userRole}
            userEmpresa={userEmpresa}
            userId={userId}
            permissoesMenusCache={permissoesMenusCache}
          />
        )
      case 'cadastro_tipos_movimentacao':
        if (!security.canAccessMenu(userRole, 'cadastro_tipos_movimentacao', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar este cadastro.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <CadastroTiposMovimentacao
            onBack={() => setCurrentView('dashboard')}
          />
        )
      case 'cadastro_inversores_modulos':
        if (!security.canAccessMenu(userRole, 'cadastro_inversores_modulos', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para cadastrar inversores e módulos.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <CadastroInversoresModulos
            onBack={() => setCurrentView('dashboard')}
          />
        )
      case 'lancar_movimentacoes':
        if (!security.canAccessMenu(userRole, 'lancar_movimentacoes', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para lançar movimentações.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>Voltar ao Dashboard</button>
            </div>
          )
        }
        return (
          <LancarMovimentacoes
            onBack={() => setCurrentView('dashboard')}
            userId={userId}
            userEmpresa={userEmpresa}
            onVerFinanceiro={() => setCurrentView('financeiro')}
          />
        )
      case 'orcamentos':
        if (!security.canAccessMenu(userRole, 'orcamentos', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar Orçamentos.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>Voltar ao Dashboard</button>
            </div>
          )
        }
        return (
          <Orcamentos
            onBack={() => setCurrentView('dashboard')}
            userEmpresa={userEmpresa}
            userId={userId}
          />
        )
      case 'dashboard_v2':
        if (!security.canAccessMenu(userRole, 'dashboard_v2', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar o Dashboard V2.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <DashboardV2
            onBack={() => setCurrentView('dashboard')}
            userRole={userRole}
            userEmpresa={userEmpresa}
            userId={userId}
          />
        )
      case 'monitoramento':
        if (!security.canAccessMenu(userRole, 'monitoramento', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar o Monitoramento.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <Monitoramento
            onBack={() => setCurrentView('dashboard')}
            userRole={userRole}
            userEmpresa={userEmpresa}
          />
        )
      case 'gestao_instalacao':
        return (
          <GestaoInstalacao 
            onBack={() => setCurrentView('dashboard')} 
            userRole={userRole} 
            userEmpresa={userEmpresa}
            userId={userId}
          />
        )
      case 'permissoes_menus':
        // Apenas administrador pode acessar
        if (userRole !== USER_ROLES.ADMINISTRADOR) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar esta tela. Apenas administradores podem gerenciar permissões de menus.</p>
              <button 
                className="btn btn-primary" 
                onClick={() => setCurrentView('dashboard')}
              >
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <PermissoesMenus 
            onBack={() => setCurrentView('dashboard')} 
            userRole={userRole}
          />
        )
      case 'leads':
        if (!security.canAccessMenu(userRole, 'leads', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar a tela de Leads.</p>
              <button 
                className="btn btn-primary" 
                onClick={() => setCurrentView('dashboard')}
              >
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <Leads 
            onBack={() => setCurrentView('dashboard')} 
            userRole={userRole} 
            userEmpresa={userEmpresa}
            userId={userId}
            onIniciarEsteira={(dadosCliente) => {
              setDadosIniciaisCliente(dadosCliente)
              setCurrentView('clientes_ii')
            }}
          />
        )
      case 'gestao_leads':
        if (!security.canAccessMenu(userRole, 'gestao_leads', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar Gestão Leads.</p>
              <button
                className="btn btn-primary"
                onClick={() => setCurrentView('dashboard')}
              >
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <GestaoLeads
            onBack={() => setCurrentView('dashboard')}
            userRole={userRole}
            userEmpresa={userEmpresa}
            userId={userId}
            userName={userName}
          />
        )
      case 'cadastrar_leads':
        if (!security.canAccessMenu(userRole, 'cadastrar_leads', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar Cadastrar Leads.</p>
              <button 
                className="btn btn-primary" 
                onClick={() => setCurrentView('dashboard')}
              >
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return (
          <CadastrarLeads 
            onBack={() => setCurrentView('dashboard')} 
            userEmpresa={userEmpresa}
            userId={userId}
            userRole={userRole}
            onLogout={openLogoutConfirmation}
          />
        )
      case 'leads_sdr':
        if (!security.canAccessMenu(userRole, 'leads_sdr', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar Leads SDR.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>Voltar ao Dashboard</button>
            </div>
          )
        }
        return (
          <LeadsSDR
            onBack={() => setCurrentView('dashboard')}
            userRole={userRole}
            userEmpresa={userEmpresa}
            userId={userId}
          />
        )
      case 'leads_capacitacao':
        if (!security.canAccessMenu(userRole, 'leads_capacitacao', permissoesMenusCache, hasPermissoesCustomizadas)) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar Leads Capacitação.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>Voltar ao Dashboard</button>
            </div>
          )
        }
        return (
          <LeadsCapacitacao
            onBack={() => setCurrentView('dashboard')}
            userId={userId}
            userName={userName}
            userEmpresa={userEmpresa}
            userRole={userRole}
          />
        )
      case 'tipos_servico':
        return (
          <TipoServicoManager 
            onBack={goBack} 
            userRole={userRole}
          />
        )
      case 'simulacao_fotus':
        if (userRole !== USER_ROLES.ADMINISTRADOR) {
          return (
            <div className="access-denied">
              <h3>Acesso Negado</h3>
              <p>Você não tem permissão para acessar esta tela. Apenas administradores podem acessar Simulação Fotus.</p>
              <button className="btn btn-primary" onClick={() => setCurrentView('dashboard')}>
                Voltar ao Dashboard
              </button>
            </div>
          )
        }
        return <SimulacaoFotus onBack={() => setCurrentView('dashboard')} />
      case 'whatsapp':
        return <WhatsApp onBack={() => setCurrentView('dashboard')} userRole={userRole} userId={userId} chatZap={user?.chat_zap} whatsappGestor={user?.whatsapp_gestor} whatsappProposta={user?.whatsapp_proposta} />
      case 'vistorias':
        return (
          <Vistorias 
            onBack={goBack} 
            userRole={userRole}
            userEmpresa={userEmpresa}
            userId={userId}
          />
        )
      case 'engenharia_homologacao':
        return (
          <EngenhariaHomologacao
            onBack={goBack}
            userRole={userRole}
            userEmpresa={userEmpresa}
            userId={userId}
          />
        )
      case 'fluxo_cliente':
        return (
          <FluxoCliente
            onBack={goBack}
            userRole={userRole}
            userEmpresa={userEmpresa}
            userId={userId}
          />
        )
      case 'painel_processos':
        return (
          <PainelProcessosClientes
            onBack={goBack}
            userRole={userRole}
            userEmpresa={userEmpresa}
            userId={userId}
          />
        )
      case 'engenharia_inversores':
        return (
          <EngenhariaInversores
            onBack={goBack}
          />
        )
      default:
        return renderDashboard()
    }
  }
  
  // Função para iniciar obra (mudar status para "Em andamento" e abrir presença)
  const handleIniciarObra = async (cliente) => {
    try {
      // Buscar o ID do status "Em andamento"
      const { data: statusData, error: statusError } = await supabase
        .from('status_clientes')
        .select('id')
        .eq('status', 'Em andamento')
        .eq('ativo', true)
        .single()
      
      if (statusError) {
        console.error('❌ Erro ao buscar status "Em andamento":', statusError)
        showNotification('Erro ao buscar status do cliente.', 'error')
        return
      }
      
      if (!statusData) {
        showNotification('Status "Em andamento" não encontrado.', 'error')
        return
      }
      
      // Atualizar o status do cliente para "Em andamento"
      const { error: updateError } = await supabase
        .from('clientes')
        .update({ id_status: statusData.id })
        .eq('id', cliente.id)
      
      if (updateError) {
        console.error('❌ Erro ao atualizar status do cliente:', updateError)
        showNotification('Erro ao atualizar status do cliente.', 'error')
        return
      }
      
      // Abrir formulário de presença com cliente pré-preenchido
      setPresencaFormData({
        data_presenca: new Date().toISOString().split('T')[0],
        data_cadastro_preenchido: new Date().toISOString().split('T')[0],
        cliente_id: cliente.id,
        equipe_id: '',
        veiculo_id: '',
        km_inicial: '',
        observacoes: '',
        colaboradores: []
      })
      
      // Marcar que o modal não pode ser fechado até completar a presença
      setPresencaModalNaoFechavel(true)
      
      // Abrir modal de presença
      setShowPresencaForm(true)
      
      // Recarregar clientes para atualizar o status na interface
      const recarregarClientes = async () => {
        try {
          let query = supabase
            .from('clientes')
            .select(`
              *,
              tipo_servico:tipo_servico(nome),
              tipo_padrao:tipo_padrao(nome),
              equipe:equipes(nome),
              status_info:status_clientes(status)
            `)
            .order('created_at', { ascending: false })

          const { data, error } = await query
          if (error) throw error
          setClientes(data || [])
        } catch (error) {
          console.error('Erro ao recarregar clientes:', error)
        }
      }
      
      recarregarClientes()
      
      showNotification('Obra iniciada! Preencha a lista de presença.', 'success')
    } catch (error) {
      console.error('❌ Erro ao iniciar obra:', error)
      showNotification('Erro ao iniciar obra: ' + error.message, 'error')
    }
  }
  
  // Função para finalizar obra (abrir modal de cliente para edição)
  const handleFinalizarObra = (cliente) => {
    // Abrir modal de cliente para edição dos campos específicos
    setClienteFormData({
      nome_cliente: cliente.nome_cliente || '',
      endereco: cliente.endereco || '',
      telefone: cliente.telefone || '',
      data_instalacao: cliente.data_instalacao || '',
      tipo_servico_id: cliente.tipo_servico_id || '',
      tipo_padrao_id: cliente.tipo_padrao_id || '',
      id_profiles: [],
      equipe_id: cliente.equipe_id || '',
      data_cadastro: cliente.data_cadastro || '',
      obra_cancelada: cliente.obra_cancelada || false,
      nota_material: cliente.nota_material || false,
      quantidade_modulos: cliente.quantidade_modulos || '',
      configuracao_inversor: cliente.configuracao_inversor || false,
      deslocamento_buscar_material: cliente.deslocamento_buscar_material || false,
      obra_civil: cliente.obra_civil || false,
      observacoes: cliente.observacoes || '',
      id_status: cliente.id_status || 1,
      deslocamento: cliente.deslocamento != null && cliente.deslocamento !== '' ? Number(cliente.deslocamento) : ''
    })
    
    // Carregar responsáveis do cliente
    loadResponsaveisCliente(cliente.id).then(responsaveisIds => {
      setClienteFormData(prev => ({
        ...prev,
        id_profiles: responsaveisIds
      }))
    })
    
    // Marcar que este modal é para finalização (não é o modal de presença obrigatório)
    setPresencaModalNaoFechavel(false)
    
    // Marcar que este modal de cliente não pode ser fechado até finalizar
    setClienteModalNaoFechavel(true)
    
    setEditingCliente(cliente)
    setShowClienteForm(true)
  }
  
  // Função para salvar cliente após finalização (mudar status para "Finalizado")
  const handleFinalizarClienteSubmit = async (e) => {
    e.preventDefault()
    
    try {
      // Buscar o ID do status "Finalizado"
      const { data: statusData, error: statusError } = await supabase
        .from('status_clientes')
        .select('id')
        .eq('status', 'Finalizado')
        .eq('ativo', true)
        .single()
      
      if (statusError) {
        console.error('❌ Erro ao buscar status "Finalizado":', statusError)
        showNotification('Erro ao buscar status do cliente.', 'error')
        return
      }
      
      if (!statusData) {
        showNotification('Status "Finalizado" não encontrado.', 'error')
        return
      }
      
      // Destructuring para separar id_profiles dos dados do cliente
      const { id_profiles, ...dadosCliente } = clienteFormData
      
      // Atualizar o cliente com os dados do formulário e status "Finalizado"
      const clienteData = {
        ...dadosCliente,
        id_status: statusData.id
      }
      clienteData.deslocamento = clienteData.deslocamento === '' || clienteData.deslocamento == null ? 0 : (Number(clienteData.deslocamento) || 0)
      
      const { error: updateError } = await supabase
        .from('clientes')
        .update(clienteData)
        .eq('id', editingCliente.id)
      
      if (updateError) {
        console.error('❌ Erro ao atualizar cliente:', updateError)
        showNotification('Erro ao atualizar cliente: ' + updateError.message, 'error')
        return
      }
      
      // Salvar responsáveis na tabela clientes_usuarios
      if (id_profiles && id_profiles.length > 0) {
        try {
          await salvarResponsaveisCliente(editingCliente.id, id_profiles)
          console.log('✅ Responsáveis atualizados com sucesso')
        } catch (error) {
          console.error('❌ Erro ao salvar responsáveis:', error)
          throw error
        }
      }
      
      showNotification('Cliente finalizado com sucesso!', 'success')
      setShowClienteForm(false)
      setEditingCliente(null)
      setClienteModalNaoFechavel(false) // Permitir fechar o modal após finalizar
      loadClientes()
    } catch (error) {
      console.error('❌ Erro ao finalizar cliente:', error)
      showNotification('Erro ao finalizar cliente: ' + error.message, 'error')
    }
  }
  


  return (
    <>
      {/* Modal de Aviso de Presenças */}
      {showPresencaWarningModal && (
        <div className="presenca-warning-overlay">
          <div className="presenca-warning-modal">
            <div className="warning-header">
              <h3>⚠️ Atenção - Cliente com Presenças</h3>
              <button onClick={closePresencaWarningModal} className="close-button">×</button>
            </div>
            
            <div className="warning-content">
              <div className="warning-icon">⚠️</div>
              <p>
                O cliente <strong>{clienteParaExcluir?.nome_cliente}</strong> possui 
                <strong> {presencasCliente.length} registro(s) de presença</strong> relacionado(s).
              </p>
              
              <div className="presenca-details">
                <h4>Presenças encontradas:</h4>
                <ul>
                  {presencasCliente.map((presenca) => (
                    <li key={presenca.id}>
                      📅 {formatarData(presenca.data_presenca)}
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="warning-options">
                <p><strong>Opções disponíveis:</strong></p>
                <ol>
                  <li>Excluir todas as presenças E o cliente (recomendado)</li>
                  <li>Cancelar a exclusão e manter o cliente</li>
                </ol>
              </div>
            </div>
            
            <div className="warning-actions">
              <button onClick={closePresencaWarningModal} className="cancel-button">
                ❌ Cancelar
              </button>
              <button onClick={handleDeletePresencasAndCliente} className="confirm-button">
                🗑️ Excluir Tudo
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal de Senha Temporária */}
      {showPasswordModal && (
        <div className="modal-overlay" onClick={closePasswordModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header success">
              <h3>🎉 Usuário Criado com Sucesso!</h3>
            </div>
            
            <div className="modal-body">
              <div className="password-modal-content">
                <div className="user-info">
                  <p><strong>Nome:</strong> {tempPasswordData.nome}</p>
                  <p><strong>Email:</strong> {tempPasswordData.email}</p>
                </div>
                
                <div className="password-section">
                  <h4>🔐 Senha Temporária</h4>
                  <div className="password-display">
                    <input
                      type="text"
                      value={tempPasswordData.senha}
                      readOnly
                      className="password-input"
                    />
                    <button
                      type="button"
                      onClick={() => navigator.clipboard.writeText(tempPasswordData.senha)}
                      className="copy-button"
                      title="Copiar senha"
                    >
                      📋
                    </button>
                  </div>
                </div>
                
                <div className="warning-box">
                  <p><strong>⚠️ Importante:</strong></p>
                  <ul>
                    <li>Esta senha é temporária e expira em 24 horas</li>
                    <li>O usuário deverá alterá-la no primeiro login</li>
                    <li>Compartilhe esta senha com segurança</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="modal-footer">
              <button
                type="button"
                onClick={closePasswordModal}
                className="btn btn-primary"
              >
                Entendi
              </button>
            </div>
          </div>
        </div>
      )}
      
      <div className="welcome-container">
        {/* Loading state */}
        {isLoading && (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '200px',
            fontSize: '18px',
            color: '#666'
          }}>
            Carregando...
          </div>
        )}
        

        
        {/* Notificações */}
        <div className="notifications-container">
          {notifications.map((notification) => (
            <div key={notification.id} className={`notification ${notification.type}`}>
              {notification.message}
            </div>
          ))}
        </div>
        
        {/* Menu no layout AdminLTE — oculto para usuário PAP */}
        {!isLoading && userRole !== 'pap' && (
          <AppSidebar
            user={user}
            userRole={userRole}
            chatZap={user?.chat_zap}
            whatsappProposta={user?.whatsapp_proposta}
            currentView={currentView}
            permissoesMenusCache={permissoesMenusCache}
            hasPermissoesCustomizadas={hasPermissoesCustomizadas}
            onNavigate={handleNavItemClick}
            onOpenValorKit={() => setShowValorKitManager(true)}
            onOpenKitsPersonalizados={() => setShowKitsPersonalizados(true)}
            onOpenConsultaPropostas={() => setShowConsultaPropostas(true)}
            onOpenListaMaterial={() => setShowListaMaterial(true)}
            onOpenEmpresas={() => setShowEmpresas(true)}
            onOpenChangePassword={openChangePasswordForm}
            onLogout={openLogoutConfirmation}
          />
        )}

        
        {/* Conteúdo principal */}
        {!isLoading && (
        <main className={`welcome-main ${['propostas_cadastro', 'calendario', 'financeiro', 'cadastro_tipos_movimentacao', 'cadastro_inversores_modulos', 'lancar_movimentacoes', 'orcamentos', 'cadastrar_clientes', 'fluxo_cliente', 'painel_processos', 'whatsapp', 'clientes_ii', 'monitoramento', 'kit_fornecedores'].includes(currentView) ? 'welcome-main-full-width' : ''} ${currentView === 'whatsapp' ? 'welcome-main-whatsapp' : ''} ${currentView === 'calendario' ? 'welcome-main-calendario' : ''}`}>
          {renderContent()}
        </main>
        )}

        {!isLoading && Number(user?.chat_zap) === 1 && userId && (
          <WhatsAppFloatingChat
            userId={userId}
            userRole={userRole}
            chatZap={user?.chat_zap}
            ocultar={currentView === 'whatsapp'}
          />
        )}
        
        {/* Formulário de Cliente */}
        {showClienteForm && (
          <div className="form-overlay">
            <div className="form-modal">
              <div className="modal-header">
                <h3>
                  {editingCliente && clienteModalNaoFechavel ? 'Finalizar Obra - Editar Instalação' : 
                   editingCliente ? 'Editar Instalação' : 'Cadastrar Instalação'}
                </h3>
                {/* Botão de fechar só aparece se o modal não for obrigatório */}
                {!clienteModalNaoFechavel && (
                  <button onClick={closeClienteForm} className="close-button" title="Fechar">×</button>
                )}
              </div>
              
              <form onSubmit={
                editingCliente && clienteModalNaoFechavel ? handleFinalizarClienteSubmit : handleClienteFormSubmit
              } className="cliente-form cliente-form-instalacao">
                <div className="form-section">
                  <h4 className="section-title">Dados da Instalação</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="nome_cliente">Nome do Cliente</label>
                      <input
                        type="text"
                        id="nome_cliente"
                        value={clienteFormData.nome_cliente}
                        onChange={(e) => setClienteFormData({...clienteFormData, nome_cliente: e.target.value})}
                        required
                        placeholder="Nome completo do cliente"
                        disabled={clienteModalNaoFechavel}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="data_instalacao">Data da Instalação</label>
                      <input
                        type="date"
                        id="data_instalacao"
                        value={clienteFormData.data_instalacao}
                        onChange={(e) => setClienteFormData({...clienteFormData, data_instalacao: e.target.value})}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="tipo_servico">Tipo de Serviço</label>
                      <select
                        id="tipo_servico"
                        value={clienteFormData.tipo_servico_id}
                        onChange={(e) => setClienteFormData({...clienteFormData, tipo_servico_id: e.target.value})}
                        required
                      >
                        <option value="">Selecione um tipo de serviço</option>
                        {tiposServico.map((tipo) => (
                          <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="tipo_padrao">Tipo de Padrão</label>
                      <select
                        id="tipo_padrao"
                        value={clienteFormData.tipo_padrao_id}
                        onChange={(e) => setClienteFormData({...clienteFormData, tipo_padrao_id: e.target.value})}
                        required
                      >
                        <option value="">Selecione um tipo de padrão</option>
                        {tiposPadrao.map((tipo) => (
                          <option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="quantidade_modulos">Quantidade de Módulos</label>
                      <input
                        type="number"
                        id="quantidade_modulos"
                        value={clienteFormData.quantidade_modulos || ''}
                        onChange={(e) => setClienteFormData({...clienteFormData, quantidade_modulos: parseInt(e.target.value) || 0})}
                        min="0"
                        placeholder="Ex: 10 (opcional)"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="equipe">Equipe Responsável</label>
                      <select
                        id="equipe"
                        value={clienteFormData.equipe_id}
                        onChange={(e) => setClienteFormData({...clienteFormData, equipe_id: e.target.value})}
                        disabled={clienteModalNaoFechavel}
                      >
                        <option value="">Selecione uma equipe</option>
                        {equipes.map((equipe) => (
                          <option key={equipe.id} value={equipe.id}>{equipe.nome}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="id_status">Status do Projeto</label>
                      <select
                        id="id_status"
                        value={clienteFormData.id_status || ''}
                        onChange={(e) => setClienteFormData({...clienteFormData, id_status: e.target.value ? parseInt(e.target.value) : null})}
                        required
                        disabled={clienteModalNaoFechavel}
                      >
                        <option value="">Selecione um status</option>
                        {statusClientes.map((status) => (
                          <option key={status.id} value={status.id}>
                            {status.status}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="deslocamento">Deslocamento (R$)</label>
                      <input
                        type="number"
                        id="deslocamento"
                        value={clienteFormData.deslocamento === '' || clienteFormData.deslocamento == null ? '' : clienteFormData.deslocamento}
                        onChange={(e) => {
                          const v = e.target.value
                          setClienteFormData({...clienteFormData, deslocamento: v === '' ? '' : (parseFloat(v) || 0)})
                        }}
                        min="0"
                        step="0.01"
                        placeholder="0,00"
                        disabled={clienteModalNaoFechavel}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-actions">
                  {!clienteModalNaoFechavel && (
                    <button type="button" onClick={closeClienteForm} className="cancel-button">
                      Cancelar
                    </button>
                  )}
                  <button type="submit" className="submit-button">
                    {editingCliente && clienteModalNaoFechavel ? 'Finalizar Obra' : 
                     editingCliente ? 'Atualizar Instalação' : 'Cadastrar Instalação'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        
        {/* Formulário de Veículo */}
        {showVeiculoForm && (
          <div className="form-overlay">
            <div className="form-modal">
              <div className="modal-header">
                <h3>{editingVeiculo ? 'Editar Veículo' : 'Cadastrar Novo Veículo'}</h3>
                <button onClick={closeVeiculoForm} className="close-button">×</button>
              </div>
              
              <form onSubmit={handleVeiculoFormSubmit} className="veiculo-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="veiculo_nome">Nome/Modelo: *</label>
                    <input
                      type="text"
                      id="veiculo_nome"
                      value={veiculoFormData.veiculo}
                      onChange={(e) => setVeiculoFormData({...veiculoFormData, veiculo: e.target.value})}
                      required
                      placeholder="Ex: Fiat Strada, Ford Transit, etc."
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="veiculo_placa">Placa: *</label>
                    <input
                      type="text"
                      id="veiculo_placa"
                      value={veiculoFormData.placa}
                      onChange={(e) => setVeiculoFormData({...veiculoFormData, placa: e.target.value})}
                      required
                      placeholder="Ex: ABC-1234"
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="veiculo_ativo">Status:</label>
                  <select
                    id="veiculo_ativo"
                    value={veiculoFormData.ativo}
                    onChange={(e) => setVeiculoFormData({...veiculoFormData, ativo: e.target.value === 'true'})}
                  >
                    <option value={true}>✅ Ativo</option>
                    <option value={false}>❌ Inativo</option>
                  </select>
                </div>
                
                <div className="form-actions">
                  <button type="button" onClick={closeVeiculoForm} className="cancel-button">
                    Cancelar
                  </button>
                  <button type="submit" className="submit-button">
                    {editingVeiculo ? 'Atualizar' : 'Cadastrar'} Veículo
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        
        {/* Formulário de Cargo */}
        {showCargoForm && (
          <div className="form-overlay">
            <div className="form-modal">
              <div className="modal-header">
                <h3>{editingCargo ? 'Editar Cargo' : 'Cadastrar Novo Cargo'}</h3>
                <button onClick={closeCargoForm} className="close-button">×</button>
              </div>
              
              <form onSubmit={handleCargoFormSubmit} className="cargo-form">
                <div className="form-group">
                  <label htmlFor="cargo_nome">Nome do Cargo: *</label>
                  <input
                    type="text"
                    id="cargo_nome"
                    value={cargoFormData.cargo}
                    onChange={(e) => setCargoFormData({...cargoFormData, cargo: e.target.value})}
                    required
                    placeholder="Ex: Pedreiro, Eletricista, etc."
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="cargo_ativo">Status:</label>
                  <select
                    id="cargo_ativo"
                    value={cargoFormData.ativo}
                    onChange={(e) => setCargoFormData({...cargoFormData, ativo: e.target.value === 'true'})}
                  >
                    <option value={true}>✅ Ativo</option>
                    <option value={false}>❌ Inativo</option>
                  </select>
                </div>
                
                <div className="form-actions">
                  <button type="button" onClick={closeCargoForm} className="cancel-button">
                    Cancelar
                  </button>
                  <button type="submit" className="submit-button">
                    {editingCargo ? 'Atualizar' : 'Cadastrar'} Cargo
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Formulário de Colaborador */}
        {showColaboradorForm && (
          <div className="form-overlay">
            <div className="form-modal">
              <div className="modal-header">
                <h3>{editingColaborador ? 'Editar Colaborador' : 'Cadastrar Novo Colaborador'}</h3>
                <button onClick={closeColaboradorForm} className="close-button">×</button>
              </div>
              
              <form onSubmit={handleColaboradorFormSubmit} className="colaborador-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="nome_colaborador">Nome: *</label>
                    <input
                      type="text"
                      id="nome_colaborador"
                      value={colaboradorFormData.nome}
                      onChange={(e) => setColaboradorFormData({...colaboradorFormData, nome: e.target.value})}
                      required
                    />
                  </div>
                  
                                     <div className="form-group">
                     <label htmlFor="cargo_colaborador">Cargo: *</label>
                     <select
                       id="cargo_colaborador"
                       value={colaboradorFormData.cargo}
                       onChange={(e) => setColaboradorFormData({...colaboradorFormData, cargo: e.target.value})}
                       required
                     >
                       <option value="">Selecione um cargo</option>
                       {cargos.map((cargo) => (
                         <option key={cargo.id} value={cargo.cargo}>
                           {cargo.ativo ? '✅' : '❌'} {cargo.cargo}
                         </option>
                       ))}
                     </select>
                   </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email_colaborador">Email:</label>
                    <input
                      type="email"
                      id="email_colaborador"
                      value={colaboradorFormData.email}
                      onChange={(e) => setColaboradorFormData({...colaboradorFormData, email: e.target.value})}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="chave_pix_colaborador">Chave PIX:</label>
                    <input
                      type="text"
                      id="chave_pix_colaborador"
                      value={colaboradorFormData.chave_pix}
                      onChange={(e) => setColaboradorFormData({...colaboradorFormData, chave_pix: e.target.value})}
                      placeholder="Chave PIX para pagamentos"
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="ativo_colaborador">Status:</label>
                    <select
                      id="ativo_colaborador"
                      value={colaboradorFormData.ativo}
                      onChange={(e) => setColaboradorFormData({...colaboradorFormData, ativo: e.target.value === 'true'})}
                    >
                      <option value={true}>✅ Ativo</option>
                      <option value={false}>❌ Inativo</option>
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="tipo_pagamento_colaborador">Tipo de Pagamento: *</label>
                    <select
                      id="tipo_pagamento_colaborador"
                      value={colaboradorFormData.tipo_pagamento_id}
                      onChange={(e) => setColaboradorFormData({...colaboradorFormData, tipo_pagamento_id: e.target.value})}
                      required
                    >
                      <option value="">Selecione um tipo de pagamento</option>
                      {tiposPagamento.map((tipo) => (
                        <option key={tipo.id} value={tipo.id}>
                          {tipo.tipo_pagamento}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="valor_pagamento_colaborador">Valor do Pagamento: *</label>
                    <input
                      type="number"
                      id="valor_pagamento_colaborador"
                      value={colaboradorFormData.valor_pagamento}
                      onChange={(e) => setColaboradorFormData({...colaboradorFormData, valor_pagamento: e.target.value})}
                      required
                      min="0"
                      step="0.01"
                      placeholder="0.00"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label>&nbsp;</label>
                    <div className="form-help-text">
                      💡 Informe o valor conforme o tipo de pagamento selecionado
                    </div>
                  </div>
                </div>
                
                <div className="form-actions">
                  <button type="button" onClick={closeColaboradorForm} className="cancel-button">
                    Cancelar
                  </button>
                  <button type="submit" className="submit-button">
                    {editingColaborador ? 'Atualizar' : 'Cadastrar'} Colaborador
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        
        {/* Formulário de Equipe */}
        {showEquipeForm && (
          <div className="form-overlay">
            <div className="form-modal">
              <div className="modal-header">
                <h3>{editingEquipe ? 'Editar Equipe' : 'Cadastrar Nova Equipe'}</h3>
                <button onClick={closeEquipeForm} className="close-button">×</button>
              </div>
              
              <form onSubmit={handleEquipeFormSubmit} className="equipe-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="nome_equipe">Nome da Equipe: *</label>
                    <input
                      type="text"
                      id="nome_equipe"
                      value={equipeFormData.nome}
                      onChange={(e) => setEquipeFormData({...equipeFormData, nome: e.target.value})}
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="descricao_equipe">Descrição:</label>
                    <input
                      type="text"
                      id="descricao_equipe"
                      value={equipeFormData.descricao}
                      onChange={(e) => setEquipeFormData({...equipeFormData, descricao: e.target.value})}
                      placeholder="Descrição da equipe (opcional)"
                    />
                  </div>
                </div>
                
                {userRole === USER_ROLES.ADMINISTRADOR && (
                  <div className="form-group">
                    <label htmlFor="empresa_equipe">Empresa: *</label>
                    <select
                      id="empresa_equipe"
                      value={equipeFormData.empresa_id}
                      onChange={(e) => setEquipeFormData({...equipeFormData, empresa_id: e.target.value})}
                      required
                    >
                      <option value="">Selecione uma empresa</option>
                      {empresas.map((empresa) => (
                        <option key={empresa.id} value={empresa.id}>
                          {empresa.empresa}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="lider_equipe">Líder da Equipe: *</label>
                    <select
                      id="lider_equipe"
                      value={equipeFormData.lider_equipe}
                      onChange={(e) => {
                        const colaboradorSelecionado = colaboradores.find(c => c.id === e.target.value)
                        setEquipeFormData({
                          ...equipeFormData, 
                          lider_equipe: e.target.value,
                          telefone: colaboradorSelecionado?.telefone || ''
                        })
                      }}
                      required
                    >
                      <option value="">Selecione um líder</option>
                      {colaboradores
                        .filter(colaborador => 
                          colaborador.ativo && 
                          colaborador.cargo && 
                          (colaborador.cargo.toLowerCase().includes('líder') ||
                           colaborador.cargo.toLowerCase().includes('lider')) &&
                          (userRole === USER_ROLES.ADMINISTRADOR || 
                           colaborador.empresa_id === userEmpresa?.id)
                        )
                        .map((colaborador) => (
                          <option key={colaborador.id} value={colaborador.id}>
                            {colaborador.nome} - {colaborador.cargo}
                          </option>
                        ))}
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="telefone_lider_equipe">Telefone do Líder:</label>
                    <input
                      type="tel"
                      id="telefone_lider_equipe"
                      value={equipeFormData.telefone}
                      onChange={(e) => setEquipeFormData({...equipeFormData, telefone: e.target.value})}
                      placeholder="Telefone do líder"
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="formulario_baixa">Formulário de Baixa: *</label>
                  <select
                    id="formulario_baixa"
                    value={equipeFormData.id_formularios_baixa}
                    onChange={(e) => setEquipeFormData({...equipeFormData, id_formularios_baixa: parseInt(e.target.value)})}
                    required
                  >
                    <option value="">Selecione um formulário</option>
                    {formulariosBaixa.map((formulario) => (
                      <option key={formulario.id} value={formulario.id}>
                        {formulario.tipo}
                      </option>
                    ))}
                  </select>
                </div>
                
                <div className="form-group">
                  <label>Configurações do App Mobile:</label>
                  <div className="checkbox-group">
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="exibir_presenca"
                        checked={equipeFormData.exibir_presenca}
                        onChange={(e) => setEquipeFormData({...equipeFormData, exibir_presenca: e.target.checked})}
                      />
                      <label htmlFor="exibir_presenca">📝 Lista de Presença App</label>
                    </div>
                    
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="exibir_baixa"
                        checked={equipeFormData.exibir_baixa}
                        onChange={(e) => setEquipeFormData({...equipeFormData, exibir_baixa: e.target.checked})}
                      />
                      <label htmlFor="exibir_baixa">📸 Baixar Com Fotos App</label>
                    </div>
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="multiequipes"
                        checked={equipeFormData.multiequipes}
                        onChange={(e) => setEquipeFormData({...equipeFormData, multiequipes: e.target.checked})}
                      />
                      <label htmlFor="multiequipes">🌐 Exibir em qualquer empresa (multiequipes)</label>
                    </div>
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="ativo_equipe">Status:</label>
                  <select
                    id="ativo_equipe"
                    value={equipeFormData.ativo}
                    onChange={(e) => setEquipeFormData({...equipeFormData, ativo: e.target.value === 'true'})}
                  >
                    <option value={true}>✅ Ativa</option>
                    <option value={false}>❌ Inativa</option>
                  </select>
                </div>
                
                <div className="form-actions">
                  <button type="button" onClick={closeEquipeForm} className="cancel-button">
                    Cancelar
                  </button>
                  <button type="submit" className="submit-button">
                    {editingEquipe ? 'Atualizar' : 'Cadastrar'} Equipe
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        
                 {/* Formulário de Usuário */}
         {showUsuarioForm && (
           <div className="form-overlay">
             <div className="form-modal">
               <div className="modal-header">
                 <h3>{editingUsuario ? 'Editar Usuário' : 'Cadastrar Novo Usuário'}</h3>
                 <button onClick={closeUsuarioForm} className="close-button">×</button>
               </div>
               
               <form onSubmit={handleUsuarioFormSubmit} className="usuario-form">
                 <div className="form-row">
                   <div className="form-group">
                     <label htmlFor="nome_usuario">Nome: *</label>
                     <input
                       type="text"
                       id="nome_usuario"
                       value={usuarioFormData.nome}
                       onChange={(e) => setUsuarioFormData({...usuarioFormData, nome: e.target.value})}
                       required
                     />
                   </div>
                   
                   <div className="form-group">
                     <label htmlFor="email_usuario">Email: *</label>
                     <input
                       type="email"
                       id="email_usuario"
                       value={usuarioFormData.email}
                       onChange={(e) => setUsuarioFormData({...usuarioFormData, email: e.target.value})}
                       required
                     />
                   </div>
                 </div>

                 <div className="form-row">
                   <div className="form-group">
                     <label htmlFor="telefone_usuario">Telefone (opcional):</label>
                     <input
                       type="tel"
                       id="telefone_usuario"
                       value={usuarioFormData.telefone}
                       onChange={(e) => setUsuarioFormData({...usuarioFormData, telefone: e.target.value})}
                       placeholder="DDD + número"
                     />
                     <small className="text-muted">Pode ficar em branco. Preencha só se esta pessoa for receber aviso no WhatsApp.</small>
                   </div>
                 </div>
                 
                 <div className="form-row">
                   <div className="form-group">
                     <label htmlFor="role_usuario">Função: *</label>
                     <select
                       id="role_usuario"
                       value={usuarioFormData.role}
                       onChange={(e) => setUsuarioFormData({...usuarioFormData, role: e.target.value})}
                       required
                     >
                      <option value="">Selecione uma função</option>
                      <option value="administrador">👑 Administrador</option>
                      <option value="administrativo">📋 Administrativo</option>
                      <option value="instalador">🔧 Instalador</option>
                      <option value="especialista">🎯 Especialista</option>
                      <option value="gerente">👔 Gerente</option>
                      <option value="gerente_comercial">💼 Gerente Comercial</option>
                      <option value="homologador">🏗️ Homologador</option>
                      <option value="campo">🌾 Campo</option>
                      <option value="vistoriador">📋 Vistoriador</option>
                      <option value="pap">📝 PAP</option>
                      <option value="sdr">📞 SDR</option>
                      <option value="avulso">👤 Avulso</option>
                     </select>
                   </div>
                   
                   <div className="form-group">
                     <label htmlFor="status_usuario">Status: *</label>
                     <select
                       id="status_usuario"
                       value={usuarioFormData.status}
                       onChange={(e) => setUsuarioFormData({...usuarioFormData, status: e.target.value})}
                       required
                     >
                       <option value="ativo">✅ Ativo</option>
                       <option value="inativo">❌ Inativo</option>
                     </select>
                   </div>
                 </div>
                 
                 <div className="form-row">
                   <div className="form-group">
                     <label htmlFor="empresa_usuario">Empresa: *</label>
                     <select
                       id="empresa_usuario"
                       value={usuarioFormData.empresa_id}
                       onChange={(e) => setUsuarioFormData({...usuarioFormData, empresa_id: e.target.value})}
                       required
                       disabled={loadingEmpresas}
                     >
                       <option value="">Selecione uma empresa</option>
                       {empresas.map((empresa) => (
                         <option key={empresa.id} value={empresa.id}>
                           {empresa.empresa}
                         </option>
                       ))}
                     </select>
                     {loadingEmpresas && !empresasLoaded && (
                       <small className="loading-text">Carregando empresas...</small>
                     )}
                   </div>
                 </div>

                <div className="form-group">
                  <label>Configurações:</label>
                  <div className="checkbox-group">
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="multiempresas_usuario"
                        checked={usuarioFormData.multiempresas}
                        onChange={(e) => setUsuarioFormData({ ...usuarioFormData, multiempresas: e.target.checked })}
                      />
                      <label htmlFor="multiempresas_usuario">🌐 Exibir em qualquer empresa (multiempresas)</label>
                    </div>
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="chat_zap_usuario"
                        checked={Number(usuarioFormData.chat_zap) === 1}
                        onChange={(e) => setUsuarioFormData({
                          ...usuarioFormData,
                          chat_zap: e.target.checked ? 1 : 0
                        })}
                      />
                      <label htmlFor="chat_zap_usuario">💬 Liberar no Chat Zap (atendimento)</label>
                    </div>
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="whatsapp_gestor_usuario"
                        checked={Number(usuarioFormData.whatsapp_gestor) === 1}
                        onChange={(e) => setUsuarioFormData({
                          ...usuarioFormData,
                          whatsapp_gestor: e.target.checked ? 1 : 0
                        })}
                      />
                      <label htmlFor="whatsapp_gestor_usuario">📊 Painel gestor WhatsApp (todas as conversas)</label>
                    </div>
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="whatsapp_proposta_usuario"
                        checked={Number(usuarioFormData.whatsapp_proposta) === 1}
                        onChange={(e) => setUsuarioFormData({
                          ...usuarioFormData,
                          whatsapp_proposta: e.target.checked ? 1 : 0
                        })}
                      />
                      <label htmlFor="whatsapp_proposta_usuario">📄 Liberar aba Proposta no WhatsApp</label>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="whatsapp_template_usuario">Template WhatsApp (Iniciar conversa)</label>
                  <select
                    id="whatsapp_template_usuario"
                    value={usuarioFormData.whatsapp_template_id || ''}
                    onChange={(e) => {
                      const id = e.target.value
                      const tpl = templatesWhatsAppUsuario.find((t) => String(t.id) === String(id))
                      setUsuarioFormData({
                        ...usuarioFormData,
                        whatsapp_template_id: id,
                        whatsapp_template_nome: tpl?.name || '',
                        whatsapp_template_language: languageCodeTemplate(tpl) || ''
                      })
                    }}
                    disabled={carregandoTemplatesWhatsApp}
                  >
                    <option value="">
                      {carregandoTemplatesWhatsApp ? 'Carregando templates...' : 'Nenhum template'}
                    </option>
                    {usuarioFormData.whatsapp_template_id
                      && !templatesWhatsAppUsuario.some((t) => String(t.id) === String(usuarioFormData.whatsapp_template_id)) && (
                      <option value={usuarioFormData.whatsapp_template_id}>
                        {usuarioFormData.whatsapp_template_nome
                          ? `${usuarioFormData.whatsapp_template_nome}${usuarioFormData.whatsapp_template_language ? ` (${usuarioFormData.whatsapp_template_language})` : ''}`
                          : usuarioFormData.whatsapp_template_id}
                      </option>
                    )}
                    {templatesWhatsAppUsuario.map((tpl) => (
                      <option key={tpl.id || tpl.name} value={tpl.id || ''}>
                        {tpl.name || 'sem nome'}
                        {languageCodeTemplate(tpl) ? ` (${languageCodeTemplate(tpl)})` : ''}
                        {tpl.status ? ` — ${tpl.status}` : ''}
                      </option>
                    ))}
                  </select>
                  <small className="text-muted">
                    Este modelo será usado automaticamente quando o usuário iniciar uma conversa. Ele não poderá escolher outro.
                  </small>
                </div>
                 
                 <div className="form-actions">
                   <button type="button" onClick={closeUsuarioForm} className="cancel-button">
                     Cancelar
                   </button>
                   <button type="submit" className="submit-button">
                     {editingUsuario ? 'Atualizar' : 'Cadastrar'} Usuário
                   </button>
                 </div>
               </form>
             </div>
           </div>
         )}
         
         {/* Formulário de Tipo de Serviço */}
         {showTipoServicoForm && (
           <div className="form-overlay">
             <div className="form-modal">
               <div className="modal-header">
                 <h3>{editingTipoServico ? 'Editar Tipo de Serviço' : 'Cadastrar Novo Tipo de Serviço'}</h3>
                 <button onClick={closeTipoServicoForm} className="close-button">×</button>
               </div>
               
               <form onSubmit={handleTipoServicoFormSubmit} className="tipo-servico-form">
                 <div className="form-group">
                   <label htmlFor="nome_tipo_servico">Nome do Tipo de Serviço *</label>
                   <input
                     type="text"
                     id="nome_tipo_servico"
                     value={tipoServicoFormData.nome}
                     onChange={(e) => setTipoServicoFormData({...tipoServicoFormData, nome: e.target.value})}
                     required
                     placeholder="Ex: Instalação de Sistema Fotovoltaico"
                   />
                 </div>

                 <div className="form-group">
                   <label htmlFor="descricao_tipo_servico">Descrição</label>
                   <textarea
                     id="descricao_tipo_servico"
                     value={tipoServicoFormData.descricao}
                     onChange={(e) => setTipoServicoFormData({...tipoServicoFormData, descricao: e.target.value})}
                     rows="4"
                     placeholder="Descreva os detalhes deste tipo de serviço..."
                   />
                 </div>

                 <div className="form-group">
                   <label htmlFor="valor_servico_tipo">Valor do Serviço (R$)</label>
                   <div className="input-group">
                     <span className="input-group-text">R$</span>
                     <input
                       type="text"
                       id="valor_servico_tipo"
                       value={tipoServicoFormData.valor_servico}
                       onChange={(e) => {
                         const formatted = formatCurrencyInput(e.target.value)
                         setTipoServicoFormData({...tipoServicoFormData, valor_servico: formatted})
                       }}
                       placeholder="0,00"
                     />
                   </div>
                   <small className="form-text-help">Valor padrão cobrado por este tipo de serviço</small>
                 </div>
                 
                 <div className="form-group">
                   <label htmlFor="ativo_tipo_servico">Status:</label>
                   <select
                     id="ativo_tipo_servico"
                     value={tipoServicoFormData.ativo}
                     onChange={(e) => setTipoServicoFormData({...tipoServicoFormData, ativo: e.target.value === 'true'})}
                   >
                     <option value={true}>✅ Ativo</option>
                     <option value={false}>❌ Inativo</option>
                   </select>
                 </div>
                 
                 <div className="form-actions">
                   <button type="button" onClick={closeTipoServicoForm} className="cancel-button">
                     Cancelar
                   </button>
                   <button type="submit" className="submit-button">
                     {editingTipoServico ? 'Atualizar' : 'Cadastrar'} Tipo de Serviço
                   </button>
                 </div>
               </form>
             </div>
           </div>
         )}
         
         {/* Modal de Validação de Nome Duplicado */}
         {showDuplicateModal && duplicateTipoData && (
           <div className="form-overlay" style={{ zIndex: 10000 }}>
             <div className="validation-modal">
               <div className="validation-modal-header">
                 <div className="validation-icon">⚠️</div>
                 <h3>Tipo de Serviço Já Existe!</h3>
               </div>
               
               <div className="validation-modal-body">
                 <p className="validation-message">
                   Já existe um tipo de serviço cadastrado com o nome <strong>"{duplicateTipoData.nome}"</strong>.
                 </p>
                 
                 <div className="existing-tipo-details">
                   <h4>📋 Detalhes do Tipo Existente:</h4>
                   <div className="detail-row">
                     <span className="detail-label">Nome:</span>
                     <span className="detail-value">{duplicateTipoData.nome}</span>
                   </div>
                   <div className="detail-row">
                     <span className="detail-label">Descrição:</span>
                     <span className="detail-value">
                       {duplicateTipoData.descricao || <em style={{ color: '#999' }}>Sem descrição</em>}
                     </span>
                   </div>
                   <div className="detail-row">
                     <span className="detail-label">Valor:</span>
                     <span className="detail-value valor-destaque">
                       {duplicateTipoData.valor_servico 
                         ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(duplicateTipoData.valor_servico)
                         : 'R$ 0,00'}
                     </span>
                   </div>
                   <div className="detail-row">
                     <span className="detail-label">Status:</span>
                     <span className="detail-value">
                       {duplicateTipoData.ativo 
                         ? <span className="status-ativo-text">✅ Ativo</span> 
                         : <span className="status-inativo-text">❌ Inativo</span>}
                     </span>
                   </div>
                 </div>
                 
                 <div className="validation-question">
                   <p>O que você deseja fazer?</p>
                 </div>
               </div>
               
               <div className="validation-modal-actions">
                 <button 
                   onClick={closeDuplicateModal} 
                   className="btn-validation cancel"
                 >
                   ← Voltar e Alterar Nome
                 </button>
                 <button 
                   onClick={handleEditExistingTipo} 
                   className="btn-validation edit"
                 >
                   ✏️ Editar Tipo Existente
                 </button>
               </div>
             </div>
           </div>
         )}
         
         {/* Formulário de Tipo de Padrão */}
         {showTipoPadraoForm && (
           <div className="form-overlay">
             <div className="form-modal">
               <div className="modal-header">
                 <h3>{editingTipoPadrao ? 'Editar Tipo de Padrão' : 'Cadastrar Novo Tipo de Padrão'}</h3>
                 <button onClick={closeTipoPadraoForm} className="close-button">×</button>
               </div>
               
               <form onSubmit={handleTipoPadraoFormSubmit} className="tipo-padrao-form">
                 <div className="form-group">
                   <label htmlFor="nome_tipo_padrao">Nome: *</label>
                   <input
                     type="text"
                     id="nome_tipo_padrao"
                     value={tipoPadraoFormData.nome}
                     onChange={(e) => setTipoPadraoFormData({...tipoPadraoFormData, nome: e.target.value})}
                     required
                     placeholder="Ex: Monofásico, Bifásico, Trifásico"
                   />
                 </div>
                 
                 <div className="form-group">
                   <label htmlFor="ativo_tipo_padrao">Status:</label>
                   <select
                     id="ativo_tipo_padrao"
                     value={tipoPadraoFormData.ativo}
                     onChange={(e) => setTipoPadraoFormData({...tipoPadraoFormData, ativo: e.target.value === 'true'})}
                   >
                     <option value={true}>✅ Ativo</option>
                     <option value={false}>❌ Inativo</option>
                   </select>
                 </div>
                 
                 <div className="form-actions">
                   <button type="button" onClick={closeTipoPadraoForm} className="cancel-button">
                     Cancelar
                   </button>
                   <button type="submit" className="submit-button">
                     {editingTipoPadrao ? 'Atualizar' : 'Cadastrar'} Tipo de Padrão
                   </button>
                 </div>
               </form>
             </div>
           </div>
         )}
        {/* Formulário de Presença */}
        {showPresencaForm && (
          <div className="form-overlay">
            <div className="form-modal">
              <div className="modal-header">
                <h3>{editingPresenca ? 'Editar Presença' : 'Nova Lista de Presença'}</h3>
                {/* Debug temporário */}
                <div style={{fontSize: '12px', color: 'red'}}>
                  presencaModalNaoFechavel: {presencaModalNaoFechavel ? 'true' : 'false'}
                </div>
                {/* Botão de fechar só aparece se o modal não for obrigatório */}
                {!presencaModalNaoFechavel && (
                  <button onClick={closePresencaForm} className="close-button">×</button>
                )}
              </div>
              
              <form onSubmit={handlePresencaFormSubmit} className="presenca-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="data_presenca">Data da Presença: *</label>
                    <input
                      type="date"
                      id="data_presenca"
                      value={presencaFormData.data_presenca}
                      onChange={(e) => setPresencaFormData({...presencaFormData, data_presenca: e.target.value})}
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="data_cadastro_preenchido">Data do Cadastro: *</label>
                    <input
                      type="date"
                      id="data_cadastro_preenchido"
                      value={presencaFormData.data_cadastro_preenchido}
                      onChange={(e) => setPresencaFormData({...presencaFormData, data_cadastro_preenchido: e.target.value})}
                      required
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="cliente_id">Cliente:</label>
                    <select
                      id="cliente_id"
                      value={presencaFormData.cliente_id}
                      onChange={(e) => setPresencaFormData({...presencaFormData, cliente_id: e.target.value})}
                      disabled={presencaModalNaoFechavel} // Desabilitar quando modal não for fechável
                    >
                      <option value="">Selecione um cliente (opcional)</option>
                      {clientes.map(cliente => (
                        <option key={cliente.id} value={cliente.id}>
                          {cliente.nome_cliente}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="equipe_id">Equipe: *</label>
                    <select
                      id="equipe_id"
                      value={presencaFormData.equipe_id}
                      onChange={(e) => setPresencaFormData({...presencaFormData, equipe_id: e.target.value})}
                      required
                    >
                      <option value="">Selecione uma equipe</option>
                      {equipes.map(equipe => (
                        <option key={equipe.id} value={equipe.id}>
                          {equipe.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="veiculo_id">Carro/Veículo: *</label>
                    <select
                      id="veiculo_id"
                      value={presencaFormData.veiculo_id}
                      onChange={(e) => setPresencaFormData({...presencaFormData, veiculo_id: e.target.value})}
                      required
                    >
                      <option value="">Selecione um carro/veículo</option>
                      {carros.filter(c => c.ativo).map(carro => (
                        <option key={carro.id} value={carro.id}>
                          {carro.veiculo} - {carro.placa}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="km_inicial">KM Inicial:</label>
                    <input
                      type="number"
                      id="km_inicial"
                      value={presencaFormData.km_inicial}
                      onChange={(e) => setPresencaFormData({...presencaFormData, km_inicial: e.target.value})}
                      placeholder="Ex: 15000"
                      min="0"
                      step="1"
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="colaboradores">Colaboradores: *</label>
                  <div className="colaboradores-selection">
                    {/* Botões de ação rápida */}
                    <div className="colaboradores-actions">
                      <button
                        type="button"
                        onClick={() => {
                          const todosAtivos = colaboradores.filter(c => c.ativo).map(c => c.id)
                          setPresencaFormData({
                            ...presencaFormData,
                            colaboradores: todosAtivos
                          })
                        }}
                        className="action-button select-all"
                        title="Selecionar todos os colaboradores ativos"
                      >
                        ✅ Selecionar Todos
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setPresencaFormData({
                            ...presencaFormData,
                            colaboradores: []
                          })
                        }}
                        className="action-button clear-all"
                        title="Limpar seleção"
                      >
                        🗑️ Limpar Seleção
                      </button>
                    </div>
                    
                    {/* Grid responsivo de colaboradores */}
                    <div className="colaboradores-grid">
                      {colaboradores.filter(c => c.ativo).map((colaborador) => (
                        <label key={colaborador.id} className="colaborador-checkbox">
                          <input
                            type="checkbox"
                            checked={presencaFormData.colaboradores.includes(colaborador.id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setPresencaFormData({
                                  ...presencaFormData,
                                  colaboradores: [...presencaFormData.colaboradores, colaborador.id]
                                })
                              } else {
                                setPresencaFormData({
                                  ...presencaFormData,
                                  colaboradores: presencaFormData.colaboradores.filter(id => id !== colaborador.id)
                                })
                              }
                            }}
                          />
                          <span className="checkbox-label">
                            <strong>{colaborador.nome}</strong>
                            <small>{colaborador.cargo}</small>
                          </span>
                        </label>
                      ))}
                    </div>
                    
                    {/* Contador e colaboradores selecionados */}
                    <div className="colaboradores-summary">
                      <div className="selection-count">
                        <span className="count-badge">
                          {presencaFormData.colaboradores.length} de {colaboradores.filter(c => c.ativo).length} colaboradores selecionados
                        </span>
                      </div>
                      
                      {presencaFormData.colaboradores.length > 0 && (
                        <div className="colaboradores-selecionados">
                          <h4>Colaboradores Selecionados:</h4>
                          <div className="selected-pills">
                            {presencaFormData.colaboradores.map((colaboradorId) => {
                              const colaborador = colaboradores.find(c => c.id === colaboradorId)
                              return colaborador ? (
                                <span key={colaboradorId} className="selected-pill">
                                  <span className="pill-content">
                                    <strong>{colaborador.nome}</strong>
                                    <small>{colaborador.cargo}</small>
                                  </span>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setPresencaFormData({
                                        ...presencaFormData,
                                        colaboradores: presencaFormData.colaboradores.filter(id => id !== colaboradorId)
                                      })
                                    }}
                                    className="remove-colaborador"
                                    title="Remover colaborador"
                                  >
                                    ×
                                  </button>
                                </span>
                              ) : null
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="observacoes">Observações:</label>
                  <textarea
                    id="observacoes"
                    value={presencaFormData.observacoes}
                    onChange={(e) => setPresencaFormData({...presencaFormData, observacoes: e.target.value})}
                    placeholder="Digite observações sobre a presença..."
                    rows="3"
                  />
                </div>
                
                <div className="form-actions">
                  {/* Debug temporário */}
                  <div style={{fontSize: '12px', color: 'red', marginBottom: '10px'}}>
                    presencaModalNaoFechavel: {presencaModalNaoFechavel ? 'true' : 'false'}
                  </div>
                  {/* Botão Cancelar só aparece se o modal não for obrigatório */}
                  {!presencaModalNaoFechavel && (
                    <button type="button" onClick={closePresencaForm} className="cancel-button">
                      Cancelar
                    </button>
                  )}
                  <button type="submit" className="submit-button">
                    {editingPresenca ? 'Atualizar' : 'Cadastrar'} Presença
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        
        {/* Modal de Visualização do Cliente */}
        {showClienteModal && clienteModalData && (
          <div className="form-overlay">
            <div className="form-modal cliente-view-modal">
              <div className="modal-header">
                <h3>👤 Detalhes do Cliente</h3>
                <button onClick={closeClienteModal} className="close-button">×</button>
              </div>
              
              <div className="cliente-view-content">
                {/* Seção 1: Informações Básicas */}
                <div className="view-section">
                  <h4 className="section-title">📋 Informações Básicas</h4>
                  <div className="view-row">
                    <div className="view-group">
                      <label>Nome do Cliente:</label>
                      <span>{clienteModalData.nome_cliente}</span>
                    </div>
                    <div className="view-group">
                      <label>Telefone:</label>
                      <span>{clienteModalData.telefone}</span>
                    </div>
                  </div>
                  <div className="view-group">
                    <label>Endereço:</label>
                    <span>{clienteModalData.endereco}</span>
                  </div>
                </div>

                {/* Seção 2: Datas e Cronograma */}
                <div className="view-section">
                  <h4 className="section-title">📅 Datas e Cronograma</h4>
                  <div className="view-row">
                    <div className="view-group">
                      <label>Data de Cadastro:</label>
                      <span>{clienteModalData.data_cadastro ? formatarData(clienteModalData.data_cadastro) : 'N/A'}</span>
                    </div>
                    <div className="view-group">
                      <label>Data da Instalação:</label>
                      <span>{clienteModalData.data_instalacao ? formatarData(clienteModalData.data_instalacao) : 'N/A'}</span>
                    </div>
                  </div>
                </div>

                {/* Seção 3: Especificações Técnicas */}
                <div className="view-section">
                  <h4 className="section-title">⚡ Especificações Técnicas</h4>
                  <div className="view-row">
                    <div className="view-group">
                      <label>Tipo de Serviço:</label>
                      <span>{clienteModalData.tipo_servico?.nome || 'N/A'}</span>
                    </div>
                    <div className="view-group">
                      <label>Tipo de Padrão:</label>
                      <span>{clienteModalData.tipo_padrao?.nome || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="view-row">
                    <div className="view-group">
                      <label>Quantidade de Módulos:</label>
                      <span>{clienteModalData.quantidade_modulos || 'N/A'}</span>
                    </div>
                    <div className="view-group">
                      <label>Equipe Responsável:</label>
                      <span>{clienteModalData.equipe?.nome || 'N/A'}</span>
                    </div>
                  </div>
                </div>

                {/* Seção 4: Status e Acompanhamento */}
                <div className="view-section">
                  <h4 className="section-title">📊 Status e Acompanhamento</h4>
                  <div className="view-row">
                    <div className="view-group">
                      <label>Status:</label>
                      <span className={`status-badge status-${clienteModalData.status_info?.status?.toLowerCase() || 'pendente'}`}>
                        {clienteModalData.status_info?.status === 'Pendente' ? '⏳ Pendente' : 
                         clienteModalData.status_info?.status === 'Em andamento' ? '🔄 Em Andamento' : 
                         clienteModalData.status_info?.status === 'Finalizado' ? '✅ Finalizado' : 
                         clienteModalData.status_info?.status === 'Validado' ? '🔍 Validado' : 
                         '⏳ Pendente'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Seção 5: Configurações e Opções */}
                <div className="view-section">
                  <h4 className="section-title">⚙️ Configurações e Opções</h4>
                  <div className="view-row">
                    <div className="view-group">
                                          <label>Deslocamento para Buscar Material:</label>
                    <span className={clienteModalData.deslocamento_buscar_material ? 'check-yes' : 'check-no'}>
                      {clienteModalData.deslocamento_buscar_material ? '✅ Sim' : '❌ Não'}
                    </span>
                    </div>
                    <div className="view-group">
                      <label>Configuração do Inversor:</label>
                      <span className={clienteModalData.configuracao_inversor ? 'check-yes' : 'check-no'}>
                        {clienteModalData.configuracao_inversor ? '✅ Sim' : '❌ Não'}
                      </span>
                    </div>
                  </div>
                  <div className="view-row">
                    <div className="view-group">
                      <label>Obra Civil:</label>
                      <span className={clienteModalData.obra_civil ? 'check-yes' : 'check-no'}>
                        {clienteModalData.obra_civil ? '✅ Sim' : '❌ Não'}
                      </span>
                    </div>
                    <div className="view-group">
                      <label>Obra Cancelada:</label>
                      <span className={clienteModalData.obra_cancelada ? 'check-yes' : 'check-no'}>
                        {clienteModalData.obra_cancelada ? '✅ Sim' : '❌ Não'}
                      </span>
                    </div>
                  </div>
                  <div className="view-group">
                    <label>Nota de Material:</label>
                    <span className={clienteModalData.nota_material ? 'check-yes' : 'check-no'}>
                      {clienteModalData.nota_material ? '✅ Sim' : '❌ Não'}
                    </span>
                  </div>
                </div>

                {/* Seção 6: Observações */}
                {(clienteModalData.observacoes || observacoesModalFormularioBaixa.length > 0) && (
                  <div className="view-section">
                    <h4 className="section-title">📝 Observações</h4>
                    
                    {/* Observações Adicionais do Cliente */}
                    {clienteModalData.observacoes && (
                      <div className="view-group" style={{ marginBottom: '20px' }}>
                        <label style={{ marginBottom: '8px', display: 'block', fontWeight: '600' }}>
                          Observações Adicionais:
                        </label>
                        <div style={{
                          padding: '12px',
                          backgroundColor: '#f8f9fa',
                          borderRadius: '8px',
                          border: '1px solid #e0e0e0',
                          whiteSpace: 'pre-wrap',
                          wordWrap: 'break-word'
                        }}>
                          <span className="observacoes-text">{clienteModalData.observacoes}</span>
                        </div>
                      </div>
                    )}
                    
                    {/* Observações de Formulários de Baixa Resolve */}
                    {observacoesModalFormularioBaixa.length > 0 && (
                      <div className="view-group">
                        <label style={{ marginBottom: '10px', display: 'block', fontWeight: '600' }}>
                          📋 Observações dos Formulários de Baixa:
                        </label>
                        <div style={{ 
                          maxHeight: '250px', 
                          overflowY: 'auto',
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          padding: '12px',
                          backgroundColor: '#f9f9f9'
                        }}>
                          {observacoesModalFormularioBaixa.map((obs, index) => (
                            <div 
                              key={obs.id} 
                              style={{ 
                                marginBottom: index < observacoesModalFormularioBaixa.length - 1 ? '15px' : '0',
                                paddingBottom: index < observacoesModalFormularioBaixa.length - 1 ? '15px' : '0',
                                borderBottom: index < observacoesModalFormularioBaixa.length - 1 ? '1px solid #e0e0e0' : 'none'
                              }}
                            >
                              <div style={{ 
                                fontSize: '12px', 
                                color: '#666', 
                                marginBottom: '5px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                              }}>
                                <span>
                                  {obs.tipo_formulario && (
                                    <>
                                      <strong>Tipo:</strong> {obs.tipo_formulario}{' '}
                                    </>
                                  )}
                                  {obs.tipo_fase && (
                                    <> • <strong>Fase:</strong> {obs.tipo_fase}</>
                                  )}
                                </span>
                                <span>
                                  {obs.created_at && new Date(obs.created_at).toLocaleDateString('pt-BR')}
                                </span>
                              </div>
                              <div style={{ 
                                fontSize: '14px', 
                                color: '#333',
                                whiteSpace: 'pre-wrap',
                                wordWrap: 'break-word'
                              }}>
                                {obs.observacao}
                              </div>
                            </div>
                          ))}
                        </div>
                        <small style={{ 
                          fontSize: '11px', 
                          color: '#666', 
                          marginTop: '8px',
                          display: 'block',
                          fontStyle: 'italic'
                        }}>
                          Observações carregadas da tabela formularios_baixa_resolve
                        </small>
                      </div>
                    )}
                  </div>
                )}

                {/* Seção 7: Ações */}
                <div className="view-section modal-actions-section">
                  <h4 className="section-title">⚡ Ações Rápidas</h4>
                  <div className="modal-action-buttons">
                    <button
                      onClick={() => {
                        openClientePDFs(clienteModalData)
                        closeClienteModal()
                      }}
                      className="modal-action-btn pdfs-btn"
                      title="Gerenciar PDFs do cliente"
                    >
                      📄 PDFs
                    </button>

                    <button
                      onClick={() => {
                        openClienteFotos(clienteModalData)
                        closeClienteModal()
                      }}
                      className="modal-action-btn fotos-btn"
                      title="Visualizar fotos do cliente"
                    >
                      📷 Fotos
                    </button>

                    {security.hasPermission(userRole, 'CLIENT_MANAGEMENT', 'EDIT') && (
                      <button
                        onClick={() => {
                          handleEditCliente(clienteModalData)
                          closeClienteModal()
                        }}
                        className="modal-action-btn edit-btn"
                        title="Editar cliente"
                      >
                        ✏️ Editar
                      </button>
                    )}

                    {security.canRemoveClient(userRole) && (
                      <button
                        onClick={() => {
                          handleDeleteCliente(clienteModalData)
                          closeClienteModal()
                        }}
                        className="modal-action-btn delete-btn"
                        title="Excluir cliente"
                      >
                        🗑️ Remover
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <button type="button" onClick={closeClienteModal} className="cancel-button">
                  Fechar
                </button>
              </div>
            </div>
          </div>
        )}
        
        {/* Modal para Alterar Senha */}
        {showChangePasswordForm && (
          <div className="form-overlay change-password-overlay" onClick={closeChangePasswordForm} style={{ zIndex: 10600 }}>
            <div className="form-modal change-password-modal" onClick={(e) => e.stopPropagation()} style={{ pointerEvents: 'auto' }}>
              <div className="modal-header">
                <h3>🔐 Alterar Senha</h3>
                <button onClick={closeChangePasswordForm} className="close-button">×</button>
              </div>
              
              <form onSubmit={handleChangePassword} className="change-password-form">
                {/* Campo de username oculto para acessibilidade */}
                <input
                  type="text"
                  name="username"
                  value={user?.email || user?.nome || ''}
                  autoComplete="username"
                  readOnly
                  tabIndex={-1}
                  style={{
                    position: 'absolute',
                    left: '-9999px',
                    width: '1px',
                    height: '1px',
                    opacity: 0,
                    pointerEvents: 'none'
                  }}
                  aria-hidden="true"
                />
                
                <div className="form-group">
                  <label htmlFor="currentPassword">Senha Atual: *</label>
                  <input
                    type="password"
                    id="currentPassword"
                    name="currentPassword"
                    value={changePasswordData.currentPassword}
                    onChange={(e) => setChangePasswordData({...changePasswordData, currentPassword: e.target.value})}
                    placeholder="Digite sua senha atual"
                    required
                    autoComplete="current-password"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="newPassword">Nova Senha: *</label>
                  <input
                    type="password"
                    id="newPassword"
                    name="newPassword"
                    value={changePasswordData.newPassword}
                    onChange={(e) => setChangePasswordData({...changePasswordData, newPassword: e.target.value})}
                    placeholder="Digite a nova senha (mín. 6 caracteres)"
                    required
                    autoComplete="new-password"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="confirmPassword">Confirmar Nova Senha: *</label>
                  <input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    value={changePasswordData.confirmPassword}
                    onChange={(e) => setChangePasswordData({...changePasswordData, confirmPassword: e.target.value})}
                    placeholder="Confirme a nova senha"
                    required
                    autoComplete="new-password"
                  />
                </div>
                
                {passwordError && (
                  <div className="error-message">
                    ❌ {passwordError}
                  </div>
                )}
                
                {passwordSuccess && (
                  <div className="success-message">
                    ✅ {passwordSuccess}
                  </div>
                )}
                
                <div className="form-actions">
                  <button type="button" onClick={closeChangePasswordForm} className="cancel-button">
                    Cancelar
                  </button>
                  <button type="submit" className="submit-button">
                    Alterar Senha
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        
        {/* Modal de erro de autenticação */}
        {showAuthErrorModal && (
          <div className="form-overlay">
            <div className="form-modal auth-error-modal">
              <div className="modal-header">
                <h3>⚠️ Erro de Autenticação</h3>
                <button onClick={() => {
                  setShowAuthErrorModal(false)
                  navigate('/login')
                }} className="close-button">×</button>
              </div>

              <div className="auth-error-content">
                <div className="auth-error-icon">⚠️</div>
                <h4>Problema de Autenticação</h4>
                <p>{authErrorMessage}</p>
              </div>

              <div className="form-actions">
                <button type="button" onClick={() => {
                  setShowAuthErrorModal(false)
                  navigate('/login')
                }} className="submit-button">
                  🔑 Ir para Login
                </button>
              </div>
            </div>
          </div>
        )}
        
        {/* Modal de confirmação de saída */}
        {showLogoutConfirmation && (
          <div className="form-overlay">
            <div className="form-modal logout-confirmation-modal">
              <div className="modal-header">
                <h3>🚪 Confirmar Saída</h3>
                <button onClick={closeLogoutConfirmation} className="close-button">×</button>
              </div>

              <div className="logout-confirmation-content">
                <div className="logout-icon">🚪</div>
                <h4>Tem certeza que deseja sair?</h4>
                <p>Você será desconectado do sistema e redirecionado para a tela de login.</p>
              </div>

              <div className="form-actions">
                <button type="button" onClick={closeLogoutConfirmation} className="cancel-button">
                  ❌ Cancelar
                </button>
                <button type="button" onClick={confirmLogout} className="confirm-logout-button">
                  ✅ Sim, Sair
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Resumo de Colaboradores Não Encontrados */}
        {showColaboradoresNaoEncontradosModal && (
          <div className="form-overlay">
            <div className="form-modal" style={{ maxWidth: '900px', width: '90%' }}>
              <div className="modal-header">
                <h3>⚠️ Colaboradores Não Encontrados</h3>
                <button 
                  onClick={() => setShowColaboradoresNaoEncontradosModal(false)} 
                  className="close-button"
                >
                  ×
                </button>
              </div>
              
              <div className="modal-body">
                <div className="alert alert-warning mb-3">
                  <strong>⚠️ Atenção:</strong> {colaboradoresNaoEncontrados.length} colaborador(es) não foram encontrados automaticamente. 
                  Associe manualmente cada um a um colaborador existente no sistema.
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <h5>📋 Colaboradores Não Encontrados ({colaboradoresNaoEncontrados.length})</h5>
                    <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                      <table className="table table-sm">
                        <thead className="table-dark">
                          <tr>
                            <th>Data</th>
                            <th>Nome da Planilha</th>
                            <th>Carro</th>
                            <th>Km</th>
                          </tr>
                        </thead>
                        <tbody>
                          {colaboradoresNaoEncontrados.map((item, index) => (
                            <tr key={index} className="table-warning">
                              <td>{item.data}</td>
                              <td><strong>{item.colaborador}</strong></td>
                              <td>{item.carro}</td>
                              <td>{item.km_inicial}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <h5>🔍 Buscar e Associar Colaborador</h5>
                    
                    {colaboradoresNaoEncontrados.length > 0 && (
                      <div className="mb-3">
                        <label className="form-label">Selecione um colaborador da planilha:</label>
                        <select 
                          className="form-select mb-3"
                          onChange={(e) => {
                            const selectedItem = colaboradoresNaoEncontrados[parseInt(e.target.value)]
                            if (selectedItem) {
                              setSearchTerm('')
                              setSearchResults([])
                            }
                          }}
                        >
                          <option value="">Selecione...</option>
                          {colaboradoresNaoEncontrados.map((item, index) => (
                            <option key={index} value={index}>
                              {item.colaborador} - {item.data}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    <div className="mb-3">
                      <label className="form-label">Buscar colaborador no sistema:</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Digite o nome do colaborador..."
                          value={searchTerm}
                          onChange={(e) => {
                            setSearchTerm(e.target.value)
                            buscarColaboradores(e.target.value)
                          }}
                        />
                        {searchLoading && (
                          <span className="input-group-text">
                            <div className="spinner-border spinner-border-sm" role="status">
                              <span className="visually-hidden">Buscando...</span>
                            </div>
                          </span>
                        )}
                      </div>
                    </div>

                    {searchResults.length > 0 && (
                      <div className="mb-3">
                        <label className="form-label">Resultados da busca:</label>
                        <div className="list-group" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          {searchResults.map((colaborador) => (
                            <button
                              key={colaborador.id}
                              className="list-group-item list-group-item-action"
                              onClick={() => {
                                const selectedIndex = document.querySelector('select').selectedIndex - 1
                                if (selectedIndex >= 0) {
                                  const selectedItem = colaboradoresNaoEncontrados[selectedIndex]
                                  associarColaborador(selectedItem, colaborador)
                                }
                              }}
                            >
                              <div className="d-flex w-100 justify-content-between">
                                <h6 className="mb-1">{colaborador.nome}</h6>
                                <small>{colaborador.cargo}</small>
                              </div>
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {colaboradoresEncontrados.length > 0 && (
                      <div className="mb-3">
                        <h6>✅ Colaboradores Associados ({colaboradoresEncontrados.length})</h6>
                        <div className="list-group" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                          {colaboradoresEncontrados.map((item, index) => (
                            <div key={index} className="list-group-item">
                              <div className="d-flex w-100 justify-content-between">
                                <div>
                                  <strong>{item.colaborador}</strong> → <span className="text-success">{item.colaborador_associado.nome}</span>
                                </div>
                                <small className="text-muted">{item.data}</small>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => setShowColaboradoresNaoEncontradosModal(false)}
                  className="btn btn-secondary"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={gerarResumoImportacao}
                  className="btn btn-primary"
                  disabled={colaboradoresNaoEncontrados.length > 0}
                >
                  {colaboradoresNaoEncontrados.length > 0 
                    ? `Associe todos os colaboradores (${colaboradoresNaoEncontrados.length} restantes)`
                    : '✅ Ver Resumo e Confirmar'
                  }
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Modal de Resumo de Confirmação */}
        {showResumoConfirmacaoModal && (
          <div className="form-overlay">
            <div className="form-modal" style={{ maxWidth: '1000px', width: '95%' }}>
              <div className="modal-header">
                <h3>📋 Resumo da Importação</h3>
                <button 
                  onClick={() => setShowResumoConfirmacaoModal(false)} 
                  className="close-button"
                >
                  ×
                </button>
              </div>
              
              <div className="modal-body">
                <div className="alert alert-info mb-4">
                  <h5 className="alert-heading">📊 Resumo Geral</h5>
                  <div className="row text-center">
                    <div className="col-md-3">
                      <div className="card border-primary">
                        <div className="card-body">
                          <h3 className="text-primary">{resumoImportacao.total_colaboradores || 0}</h3>
                          <p className="card-text">Colaboradores</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card border-success">
                        <div className="card-body">
                          <h3 className="text-success">{resumoImportacao.total_datas || 0}</h3>
                          <p className="card-text">Datas</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card border-warning">
                        <div className="card-body">
                          <h3 className="text-warning">{resumoImportacao.colaboradores_nao_encontrados || 0}</h3>
                          <p className="card-text">Não Encontrados</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card border-info">
                        <div className="card-body">
                          <h3 className="text-info">
                            {resumoImportacao.dados_por_data?.reduce((total, data) => total + data.veiculos.length, 0) || 0}
                          </h3>
                          <p className="card-text">Veículos</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <h5>📅 Detalhes por Data</h5>
                <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  <table className="table table-striped">
                    <thead className="table-dark">
                      <tr>
                        <th>Data</th>
                        <th>Colaboradores</th>
                        <th>Veículos</th>
                        <th>Km Inicial</th>
                        <th>Detalhes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resumoImportacao.dados_por_data?.map((data, index) => (
                        <tr key={index}>
                          <td><strong>{data.data}</strong></td>
                          <td>
                            <span className="badge bg-primary">{data.total_colaboradores_data}</span>
                          </td>
                          <td>
                            {data.veiculos.map((veiculo, vIndex) => (
                              <span key={vIndex} className="badge bg-info me-1">{veiculo}</span>
                            ))}
                          </td>
                          <td>{data.km_inicial}</td>
                          <td>
                            <button 
                              className="btn btn-sm btn-outline-primary"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#detalhes-${index}`}
                              aria-expanded="false"
                            >
                              👥 Ver Colaboradores
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Detalhes expandíveis por data */}
                {resumoImportacao.dados_por_data?.map((data, index) => (
                  <div key={index} className="collapse mt-2" id={`detalhes-${index}`}>
                    <div className="card">
                      <div className="card-header">
                        <h6>👥 Colaboradores para {data.data}</h6>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-sm">
                            <thead className="table-light">
                              <tr>
                                <th>Nome na Planilha</th>
                                <th>Nome no Sistema</th>
                                <th>Cargo</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {data.colaboradores.map((colaborador, cIndex) => (
                                <tr key={cIndex}>
                                  <td><strong>{colaborador.nome_planilha}</strong></td>
                                  <td className="text-success">{colaborador.nome_sistema}</td>
                                  <td>{colaborador.cargo}</td>
                                  <td>
                                    <span className="badge bg-success">✅ Associado</span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                {resumoImportacao.colaboradores_nao_encontrados > 0 && (
                  <div className="alert alert-warning mt-3">
                    <strong>⚠️ Atenção:</strong> {resumoImportacao.colaboradores_nao_encontrados} colaborador(es) não foram encontrados e serão ignorados na importação.
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => setShowResumoConfirmacaoModal(false)}
                  className="btn btn-secondary"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={processarImportacaoFinal}
                  className="btn btn-success"
                >
                  ✅ Confirmar e Importar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Progresso da Importação */}
        {showImportProgressModal && (
          <div className="form-overlay">
            <div className="form-modal progress-modal">
              <div className="modal-header">
                <h3>📊 Importando Dados...</h3>
              </div>
              
              <div className="progress-content">
                <div className="progress-info">
                  <div className="progress-text">
                    <strong>{importProgress.status}</strong>
                  </div>
                  <div className="progress-numbers">
                    {importProgress.current} de {importProgress.total} registros
                  </div>
                </div>
                
                <div className="progress-bar-container">
                  <div 
                    className="progress-bar"
                    style={{ 
                      width: `${(importProgress.current / importProgress.total) * 100}%` 
                    }}
                  ></div>
                </div>
                
                <div className="progress-percentage">
                  {Math.round((importProgress.current / importProgress.total) * 100)}%
                </div>
                
                <div className="progress-spinner">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Processando...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Importação de Planilha */}
        {showImportPresencaModal && (
          <div className="form-overlay">
            <div className="form-modal">
              <div className="modal-header">
                <h3>📊 Importar Planilha de Presença</h3>
                <button onClick={closeImportPresencaModal} className="close-button">×</button>
              </div>
              
              <div className="import-form">
                <div className="form-group">
                  <label htmlFor="importFile">Selecionar Arquivo Excel (.xlsx):</label>
                  <input
                    type="file"
                    id="importFile"
                    accept=".xlsx,.xls"
                    onChange={handleFileUpload}
                    className="file-input"
                  />
                  <small className="form-text">
                    Formato esperado: A1=Data (DD/MM/YYYY), B1=Colaborador, C1=Carro, D1=Email (ignorado), E1=Km Inicial
                    <br />
                    <strong>Exemplo de data:</strong> 25/06/2025
                    <br />
                    <strong>Nota:</strong> A coluna Email será ignorada na importação
                  </small>
                </div>

                {importLoading && (
                  <div className="loading-container">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Processando...</span>
                    </div>
                    <p>Processando planilha...</p>
                  </div>
                )}

                {importData.length > 0 && (
                  <div className="import-preview">
                    <h4>📋 Pré-visualização dos Dados ({importData.length} registros):</h4>
                    <div className="table-responsive">
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th>Data</th>
                            <th>Colaborador</th>
                            <th>Carro</th>
                            <th>Km Inicial</th>
                          </tr>
                        </thead>
                        <tbody>
                          {importData.slice(0, 10).map((item, index) => (
                            <tr key={index}>
                              <td>{item.data}</td>
                              <td>{item.colaborador}</td>
                              <td>{item.carro}</td>
                              <td>{item.km_inicial}</td>
                            </tr>
                          ))}
                          {importData.length > 10 && (
                            <tr>
                              <td colSpan="4" className="text-center">
                                ... e mais {importData.length - 10} registros
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                <div className="form-actions">
                  <button
                    type="button"
                    onClick={closeImportPresencaModal}
                    className="btn btn-secondary"
                    disabled={importLoading}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    onClick={importPresencaData}
                    className="btn btn-primary"
                    disabled={importData.length === 0 || importLoading}
                  >
                    {importLoading ? '⏳ Importando...' : '📊 Importar Dados'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de PDFs do Cliente */}
        {showClientePDFs && clientePDFsData && (
          <ClientePDFs
            clienteId={clientePDFsData.id}
            clienteIdCadastro={clientePDFsData.id_cliente_cadastro}
            clienteNome={clientePDFsData.nome}
            onClose={closeClientePDFs}
          />
        )}

        {/* Modal de Fotos do Cliente */}
        {showClienteFotos && clienteFotosData && (
          <div className="modal-overlay">
            <div className="modal-content fotos-modal">
              <div className="modal-header fotos-modal-header">
                <div className="fotos-modal-header-top">
                  <h3>📸 Fotos do Cliente: {clienteFotosData.nome}</h3>
                  <button className="fotos-btn-close" onClick={closeClienteFotos} aria-label="Fechar">
                    ×
                  </button>
                </div>
                {(clienteFotos.length > 0 || userRole === 'administrador') && (
                  <div className="fotos-modal-header-actions">
                    {userRole === 'administrador' && (
                      <>
                        <input
                          type="text"
                          className="form-control form-control-sm me-2"
                          placeholder="Título da(s) foto(s)"
                          value={tituloFotoAdicional}
                          onChange={(e) => setTituloFotoAdicional(e.target.value)}
                          style={{ maxWidth: '220px', display: 'inline-block' }}
                          disabled={addingFotosCliente}
                        />
                        <label className="btn btn-success btn-sm me-2 mb-0" style={{ cursor: 'pointer' }}>
                          {addingFotosCliente ? (
                            <><span className="spinner-border spinner-border-sm me-1"></span> Enviando...</>
                          ) : (
                            <>➕ Adicionar fotos</>
                          )}
                          <input
                            type="file"
                            accept="image/*"
                            multiple
                            style={{ display: 'none' }}
                            onChange={addFotosCliente}
                            disabled={addingFotosCliente || !formulariosFotosCache?.length}
                          />
                        </label>
                      </>
                    )}
                    {clienteFotos.length > 0 && (
                      <button
                        onClick={downloadAllFotos}
                        disabled={downloadingAll}
                        className="btn btn-primary btn-sm fotos-btn-download"
                        title="Baixar todas as fotos em um arquivo ZIP"
                      >
                        {downloadingAll ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Baixando...
                          </>
                        ) : (
                          <>
                            ⬇️ Baixar Todas ({clienteFotos.length})
                          </>
                        )}
                      </button>
                    )}
                  </div>
                )}
              </div>
              
              <div className="modal-body">
                {loadingFotos ? (
                  <div className="loading-container">
                    <div className="loading">Carregando fotos...</div>
                  </div>
                ) : clienteFotos.length === 0 ? (
                  <div className="no-fotos">
                    <div className="no-fotos-icon">📷</div>
                    <h4>Nenhuma foto encontrada</h4>
                    <p>Este cliente ainda não possui fotos cadastradas.</p>
                  </div>
                ) : (
                  <div className="fotos-grid">
                    {clienteFotos.map((foto, index) => (
                      <div key={index} className="foto-item">
                        <img
                          src={foto.url}
                          alt={foto.name}
                          className="foto-thumbnail"
                          onClick={() => window.open(foto.url, '_blank')}
                          onError={(e) => {
                            e.target.style.display = 'none'
                            e.target.nextSibling.style.display = 'flex'
                          }}
                        />
                        <div className="foto-placeholder" style={{ display: 'none' }}>
                          <span>❌ Erro ao carregar</span>
                        </div>
                        <div className="foto-info">
                          <div className="foto-info-header">
                            <span className="foto-name">{foto.name}</span>
                            <div className="d-flex gap-1">
                              {userRole === 'administrador' && (
                                <button
                                  type="button"
                                  onClick={() => removeFotoCliente(foto)}
                                  disabled={removingFotoId === foto.id}
                                  className="btn btn-sm btn-outline-danger"
                                  title="Remover foto"
                                >
                                  {removingFotoId === foto.id ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                  ) : (
                                    '🗑️'
                                  )}
                                </button>
                              )}
                              <button
                                onClick={() => downloadIndividualFoto(foto)}
                                disabled={downloadingIndividual[foto.id]}
                                className="btn btn-sm btn-outline-primary download-btn"
                                title="Baixar esta foto"
                              >
                                {downloadingIndividual[foto.id] ? (
                                  <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                  '⬇️'
                                )}
                              </button>
                            </div>
                          </div>
                          {foto.description && (
                            <span className="foto-description">{foto.description}</span>
                          )}
                          {foto.categoria && (
                            <span className="foto-categoria">
                              🏷️ {foto.categoria}
                            </span>
                          )}
                          {foto.tipoFase && (
                            <span className="foto-tipo-fase">
                              📋 {foto.tipoFase} - {foto.tipoFormulario}
                            </span>
                          )}
                          {foto.size > 0 && (
                            <span className="foto-size">
                              {(foto.size / 1024).toFixed(1)} KB
                            </span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              
            </div>
          </div>
        )}
        
        {/* Modal de Notificação */}
        {showNotificationModal && (
          <div className="modal-overlay">
            <div className="notification-modal">
              <div className="notification-header">
                <div className={`notification-icon ${notificationModalData.type}`}>
                  {notificationModalData.type === 'success' && '✅'}
                  {notificationModalData.type === 'error' && '❌'}
                  {notificationModalData.type === 'warning' && '⚠️'}
                  {notificationModalData.type === 'info' && 'ℹ️'}
                </div>
                <h3 className={`notification-title ${notificationModalData.type}`}>
                  {notificationModalData.title}
                </h3>
                <button onClick={closeNotificationModal} className="close-button">×</button>
              </div>
              
              <div className="notification-body">
                <p className="notification-message">
                  {notificationModalData.message}
                </p>
              </div>
              
              <div className="notification-actions">
                <button 
                  onClick={closeNotificationModal} 
                  className={`notification-button ${notificationModalData.type}`}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
        
        {/* Modal de Loading do Relatório */}
        {showRelatorioLoadingModal && (
          <div className="modal-overlay">
            <div className="loading-modal">
              <div className="loading-modal-content">
                <div className="loading-spinner-large">
                  <div className="spinner"></div>
                </div>
                <h3 className="loading-title">Gerando Relatório PDF</h3>
                <p className="loading-message">Aguarde enquanto processamos as informações...</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default Welcome